/* eslint-disable */
// biome-ignore-all lint: <auto-generated-file>
// This file was automatically generated. Do not edit manually.

import * as sdk from "hypertune";

export const queryId = "f337dfb9-13de-5430-8eeb-cd967cafc6f2";

export const query: sdk.Query<sdk.ObjectValueWithVariables> = {"variableDefinitions":{},"fragmentDefinitions":{"LabelTransition":{"type":"InlineFragment","objectTypeName":"LabelTransition","selection":{"autoupgraderDisabledTooltip":{"fieldArguments":{},"fieldQuery":null},"autoupgraderDisabled":{"fieldArguments":{},"fieldQuery":null},"showLabelMigrationStatus":{"fieldArguments":{},"fieldQuery":null},"showLabelTransitionBanner":{"fieldArguments":{},"fieldQuery":null},"migrationDeadline":{"fieldArguments":{},"fieldQuery":null}}},"LabelUpgradePurchase":{"type":"InlineFragment","objectTypeName":"LabelUpgradePurchase","selection":{"autoUpgradeTermsLink":{"fieldArguments":{},"fieldQuery":null},"subscriberFreeUpgradesCount":{"fieldArguments":{},"fieldQuery":null},"priceId":{"fieldArguments":{},"fieldQuery":null},"priceCents":{"fieldArguments":{},"fieldQuery":null},"freeCouponId":{"fieldArguments":{},"fieldQuery":null}}},"Shopify":{"type":"InlineFragment","objectTypeName":"Shopify","selection":{"useREST4InventoryActivation":{"fieldArguments":{},"fieldQuery":null},"shopifyShippingRatesSetupAppEnabled":{"fieldArguments":{},"fieldQuery":null}}},"Payments":{"type":"InlineFragment","objectTypeName":"Payments","selection":{"suplifulCreditsTopupEnabled":{"fieldArguments":{},"fieldQuery":null},"suplifulTokensEnabled":{"fieldArguments":{},"fieldQuery":null}}},"LabelSettings":{"type":"InlineFragment","objectTypeName":"LabelSettings","selection":{"dpi":{"fieldArguments":{},"fieldQuery":null},"width":{"fieldArguments":{},"fieldQuery":null},"height":{"fieldArguments":{},"fieldQuery":null},"borderWidth":{"fieldArguments":{},"fieldQuery":null}}},"Polotno":{"type":"InlineFragment","objectTypeName":"Polotno","selection":{"unsplashEnabled":{"fieldArguments":{},"fieldQuery":null},"templatesEnabled":{"fieldArguments":{},"fieldQuery":null},"useNewLabelForFulfillment":{"fieldArguments":{},"fieldQuery":null},"enabled":{"fieldArguments":{},"fieldQuery":null}}},"Shipments":{"type":"InlineFragment","objectTypeName":"Shipments","selection":{"shipmentInsuranceThreshold":{"fieldArguments":{},"fieldQuery":null},"easypostEelPfcEnabled":{"fieldArguments":{},"fieldQuery":null}}},"Shiphero":{"type":"InlineFragment","objectTypeName":"Shiphero","selection":{"productLotTrackingEnabled":{"fieldArguments":{},"fieldQuery":null},"orderTag":{"fieldArguments":{},"fieldQuery":null},"userProductTag":{"fieldArguments":{},"fieldQuery":null},"userProductSyncEnabled":{"fieldArguments":{},"fieldQuery":null},"warehouseSyncEnabled":{"fieldArguments":{},"fieldQuery":null},"catalogSyncEnabled":{"fieldArguments":{},"fieldQuery":null}}},"Hubspot":{"type":"InlineFragment","objectTypeName":"Hubspot","selection":{"testing":{"fieldArguments":{},"fieldQuery":null}}},"TikTok":{"type":"InlineFragment","objectTypeName":"TikTok","selection":{"discontinued":{"fieldArguments":{},"fieldQuery":null},"orderCutoffTimestamp":{"fieldArguments":{},"fieldQuery":null}}},"TiktokSellerShipping":{"type":"InlineFragment","objectTypeName":"TiktokSellerShipping","selection":{"enabled":{"fieldArguments":{},"fieldQuery":null},"shopUrls":{"fieldArguments":{},"fieldQuery":null}}},"TiktokShipping":{"type":"InlineFragment","objectTypeName":"TiktokShipping","selection":{"enabled":{"fieldArguments":{},"fieldQuery":null},"shopUrls":{"fieldArguments":{},"fieldQuery":null}}},"MetaConversionsAPI":{"type":"InlineFragment","objectTypeName":"MetaConversionsAPI","selection":{"testEventCode":{"fieldArguments":{},"fieldQuery":null}}},"ClickFunnels":{"type":"InlineFragment","objectTypeName":"ClickFunnels","selection":{"clickFunnelsStoreCardURL":{"fieldArguments":{},"fieldQuery":null}}},"StripeInvoicingProducts":{"type":"InlineFragment","objectTypeName":"StripeInvoicingProducts","selection":{"sampleDiscountPercent":{"fieldArguments":{},"fieldQuery":null},"shippingFee":{"fieldArguments":{},"fieldQuery":null},"sampleDiscountId":{"fieldArguments":{},"fieldQuery":null},"enabled":{"fieldArguments":{},"fieldQuery":null},"firstItemFulfillmentFee":{"fieldArguments":{},"fieldQuery":null},"additionalItemFulfillmentFee":{"fieldArguments":{},"fieldQuery":null},"processingFee":{"fieldArguments":{},"fieldQuery":null}}},"SubscriptionItems":{"type":"InlineFragment","objectTypeName":"SubscriptionItems","selection":{"enabled":{"fieldArguments":{},"fieldQuery":null},"brandedCustomerSupportPriceId":{"fieldArguments":{},"fieldQuery":null}}},"RoastifyProduct":{"type":"InlineFragment","objectTypeName":"RoastifyProduct","selection":{"sku":{"fieldArguments":{},"fieldQuery":null},"productType":{"fieldArguments":{},"fieldQuery":null},"desiredWidthInPixels":{"fieldArguments":{},"fieldQuery":null}}},"SocialSignOn":{"type":"InlineFragment","objectTypeName":"SocialSignOn","selection":{"facebook":{"fieldArguments":{},"fieldQuery":null},"google":{"fieldArguments":{},"fieldQuery":null},"twitter":{"fieldArguments":{},"fieldQuery":null}}},"HelpArticles":{"type":"InlineFragment","objectTypeName":"HelpArticles","selection":{"labelMigrateCommonIssues":{"fieldArguments":{},"fieldQuery":null},"labelMigration":{"fieldArguments":{},"fieldQuery":null},"orderKinds":{"fieldArguments":{},"fieldQuery":null},"sampleDiscount":{"fieldArguments":{},"fieldQuery":null},"createGeneralLabel":{"fieldArguments":{},"fieldQuery":null},"createRoastifyLabels":{"fieldArguments":{},"fieldQuery":null},"shippingCost":{"fieldArguments":{},"fieldQuery":null},"productCost":{"fieldArguments":{},"fieldQuery":null},"processingFee":{"fieldArguments":{},"fieldQuery":null},"fulfillmentFee":{"fieldArguments":{},"fieldQuery":null},"tieredPricing":{"fieldArguments":{},"fieldQuery":null},"storeAlreadyConnected":{"fieldArguments":{},"fieldQuery":null},"setUserStoreShippingRates":{"fieldArguments":{},"fieldQuery":null},"returns":{"fieldArguments":{},"fieldQuery":null},"shipping":{"fieldArguments":{},"fieldQuery":null}}},"FulfillmentDeadlines":{"type":"InlineFragment","objectTypeName":"FulfillmentDeadlines","selection":{"fbaDays":{"fieldArguments":{},"fieldQuery":null},"priorityDays":{"fieldArguments":{},"fieldQuery":null},"sampleDays":{"fieldArguments":{},"fieldQuery":null},"defaultDays":{"fieldArguments":{},"fieldQuery":null},"prelabeledDays":{"fieldArguments":{},"fieldQuery":null}}},"PaymentDeadlines":{"type":"InlineFragment","objectTypeName":"PaymentDeadlines","selection":{"prePaymentDays":{"fieldArguments":{},"fieldQuery":null}}},"RunNotionFbaProductsCron":{"type":"InlineFragment","objectTypeName":"RunNotionFbaProductsCron","selection":{"enabled":{"fieldArguments":{},"fieldQuery":null},"schedule":{"fieldArguments":{},"fieldQuery":null}}},"PostPaymentBucketsCron":{"type":"InlineFragment","objectTypeName":"PostPaymentBucketsCron","selection":{"paymentEmailRemindersEnabled":{"fieldArguments":{},"fieldQuery":null}}},"CronJobs":{"type":"InlineFragment","objectTypeName":"CronJobs","selection":{"runClickFunnelsOrderImportCron":{"fieldArguments":{},"fieldQuery":null},"runOrderInvoiceGenerationCron":{"fieldArguments":{},"fieldQuery":null},"runShopifyFulfillmentCheckCron":{"fieldArguments":{},"fieldQuery":null},"runShopifyStoreWebhookCheckCron":{"fieldArguments":{},"fieldQuery":null},"notionFbaProducts":{"fieldArguments":{},"fieldQuery":{"RunNotionFbaProductsCron":{"type":"FragmentSpread","fragmentName":"RunNotionFbaProductsCron"}}},"postPaymentBuckets":{"fieldArguments":{},"fieldQuery":{"PostPaymentBucketsCron":{"type":"FragmentSpread","fragmentName":"PostPaymentBucketsCron"}}},"runExpireOldUserCreditsCron":{"fieldArguments":{},"fieldQuery":null},"runClickFunnelsStoreWebhookCheckCron":{"fieldArguments":{},"fieldQuery":null},"runShipheroAccessTokenCheckCron":{"fieldArguments":{},"fieldQuery":null}}},"OrderTypeMinimumQuantities":{"type":"InlineFragment","objectTypeName":"OrderTypeMinimumQuantities","selection":{"minManualQuantity":{"fieldArguments":{},"fieldQuery":null},"minSampleQuantity":{"fieldArguments":{},"fieldQuery":null},"minFbaQuantity":{"fieldArguments":{},"fieldQuery":null},"minBulkQuantity":{"fieldArguments":{},"fieldQuery":null}}},"User":{"type":"InlineFragment","objectTypeName":"User","selection":{"userMinimumPricingTier":{"fieldArguments":{},"fieldQuery":null}}},"AIProductBuilder":{"type":"InlineFragment","objectTypeName":"AIProductBuilder","selection":{"isEnabled":{"fieldArguments":{},"fieldQuery":null},"appURL":{"fieldArguments":{},"fieldQuery":null}}},"SGTM":{"type":"InlineFragment","objectTypeName":"SGTM","selection":{"hubspotDirectEventsEnabled":{"fieldArguments":{},"fieldQuery":null}}},"Onboarding":{"type":"InlineFragment","objectTypeName":"Onboarding","selection":{"surveyEnabled":{"fieldArguments":{},"fieldQuery":null},"surveyEnabledSince":{"fieldArguments":{},"fieldQuery":null}}}},"fieldQuery":{"Query":{"type":"InlineFragment","objectTypeName":"Query","selection":{"root":{"fieldArguments":{"__isPartialObject__":true},"fieldQuery":{"Root":{"type":"InlineFragment","objectTypeName":"Root","selection":{"customersCanvasMockupPipeline":{"fieldArguments":{},"fieldQuery":null},"manualMockupRegenerationEnabled":{"fieldArguments":{},"fieldQuery":null},"labelTransition":{"fieldArguments":{},"fieldQuery":{"LabelTransition":{"type":"FragmentSpread","fragmentName":"LabelTransition"}}},"labelUpgradePurchase":{"fieldArguments":{},"fieldQuery":{"LabelUpgradePurchase":{"type":"FragmentSpread","fragmentName":"LabelUpgradePurchase"}}},"shopify":{"fieldArguments":{},"fieldQuery":{"Shopify":{"type":"FragmentSpread","fragmentName":"Shopify"}}},"payments":{"fieldArguments":{},"fieldQuery":{"Payments":{"type":"FragmentSpread","fragmentName":"Payments"}}},"adminGenerateMockupsFromLabelV1Enabled":{"fieldArguments":{},"fieldQuery":null},"adminLabelTransitionsPageEnabled":{"fieldArguments":{},"fieldQuery":null},"adminGenericLabelPreviewEnabled":{"fieldArguments":{},"fieldQuery":null},"labelSettings":{"fieldArguments":{},"fieldQuery":{"LabelSettings":{"type":"FragmentSpread","fragmentName":"LabelSettings"}}},"polotno":{"fieldArguments":{},"fieldQuery":{"Polotno":{"type":"FragmentSpread","fragmentName":"Polotno"}}},"shipments":{"fieldArguments":{},"fieldQuery":{"Shipments":{"type":"FragmentSpread","fragmentName":"Shipments"}}},"shiphero":{"fieldArguments":{},"fieldQuery":{"Shiphero":{"type":"FragmentSpread","fragmentName":"Shiphero"}}},"regenerateMockupsOnSubscribe":{"fieldArguments":{},"fieldQuery":null},"hubspot":{"fieldArguments":{},"fieldQuery":{"Hubspot":{"type":"FragmentSpread","fragmentName":"Hubspot"}}},"tikTok":{"fieldArguments":{},"fieldQuery":{"TikTok":{"type":"FragmentSpread","fragmentName":"TikTok"}}},"canPublishToTiktok":{"fieldArguments":{},"fieldQuery":null},"canConnectTiktokStore":{"fieldArguments":{},"fieldQuery":null},"tiktokSellerShipping":{"fieldArguments":{},"fieldQuery":{"TiktokSellerShipping":{"type":"FragmentSpread","fragmentName":"TiktokSellerShipping"}}},"tiktokShipping":{"fieldArguments":{},"fieldQuery":{"TiktokShipping":{"type":"FragmentSpread","fragmentName":"TiktokShipping"}}},"magicLinkWithOTP":{"fieldArguments":{},"fieldQuery":null},"metaConversionsAPI":{"fieldArguments":{},"fieldQuery":{"MetaConversionsAPI":{"type":"FragmentSpread","fragmentName":"MetaConversionsAPI"}}},"blackFridayPromoIsEnabled":{"fieldArguments":{},"fieldQuery":null},"clickFunnels":{"fieldArguments":{},"fieldQuery":{"ClickFunnels":{"type":"FragmentSpread","fragmentName":"ClickFunnels"}}},"clickFunnelsAllowTestOrdersInProduction":{"fieldArguments":{},"fieldQuery":null},"useAsyncGtmSignupCallbacks":{"fieldArguments":{},"fieldQuery":null},"sampleDiscountValidDate":{"fieldArguments":{},"fieldQuery":null},"clickFunnelsIsEnabled":{"fieldArguments":{},"fieldQuery":null},"extendedCatalogIsEnabled":{"fieldArguments":{},"fieldQuery":null},"roastifyProduct3DPreviewReportIssueEnabled":{"fieldArguments":{},"fieldQuery":null},"stripeInvoicing":{"fieldArguments":{},"fieldQuery":{"StripeInvoicingProducts":{"type":"FragmentSpread","fragmentName":"StripeInvoicingProducts"}}},"subscriptionItems":{"fieldArguments":{},"fieldQuery":{"SubscriptionItems":{"type":"FragmentSpread","fragmentName":"SubscriptionItems"}}},"roastifySkus":{"fieldArguments":{},"fieldQuery":{"RoastifyProduct":{"type":"FragmentSpread","fragmentName":"RoastifyProduct"}}},"singleSkuBundleEnabled":{"fieldArguments":{},"fieldQuery":null},"socialSignOn":{"fieldArguments":{},"fieldQuery":{"SocialSignOn":{"type":"FragmentSpread","fragmentName":"SocialSignOn"}}},"jetpackFbaEmails":{"fieldArguments":{},"fieldQuery":null},"newPricingSystemVideoPopupEnabled":{"fieldArguments":{},"fieldQuery":null},"fulfillmentFeeExemptProducts":{"fieldArguments":{},"fieldQuery":null},"cnameRedirectNotificationEnabled":{"fieldArguments":{},"fieldQuery":null},"bulkOrdersEnabled":{"fieldArguments":{},"fieldQuery":null},"processingFeeRate":{"fieldArguments":{},"fieldQuery":null},"fulfillmentFeeAdditionalSkuUnits":{"fieldArguments":{},"fieldQuery":null},"fulfillmentFeeFirstSkuUnit":{"fieldArguments":{},"fieldQuery":null},"helpArticles":{"fieldArguments":{},"fieldQuery":{"HelpArticles":{"type":"FragmentSpread","fragmentName":"HelpArticles"}}},"newPricingSystemEnabled":{"fieldArguments":{},"fieldQuery":null},"orderProcessingStatusItemCountThreshold":{"fieldArguments":{},"fieldQuery":null},"partnerProductStockSnapshotEnabled":{"fieldArguments":{},"fieldQuery":null},"shouldApplyExpressShippingSampleOrder":{"fieldArguments":{},"fieldQuery":null},"fulfillmentDeadlines":{"fieldArguments":{},"fieldQuery":{"FulfillmentDeadlines":{"type":"FragmentSpread","fragmentName":"FulfillmentDeadlines"}}},"paymentDeadlines":{"fieldArguments":{},"fieldQuery":{"PaymentDeadlines":{"type":"FragmentSpread","fragmentName":"PaymentDeadlines"}}},"postOrderCreationFeedbackIntervalSeconds":{"fieldArguments":{},"fieldQuery":null},"cronJobs":{"fieldArguments":{},"fieldQuery":{"CronJobs":{"type":"FragmentSpread","fragmentName":"CronJobs"}}},"postOrderCreationFeedbackEnabled":{"fieldArguments":{},"fieldQuery":null},"orderFormFeedbackEnabled":{"fieldArguments":{},"fieldQuery":null},"prepaidPriceEnabled":{"fieldArguments":{},"fieldQuery":null},"easypostEelPfcEnabled":{"fieldArguments":{},"fieldQuery":null},"onboardingSurveyEnabled":{"fieldArguments":{},"fieldQuery":null},"acceptOrderDelayMinutes":{"fieldArguments":{},"fieldQuery":null},"orderTypeMinimumQuantities":{"fieldArguments":{},"fieldQuery":{"OrderTypeMinimumQuantities":{"type":"FragmentSpread","fragmentName":"OrderTypeMinimumQuantities"}}},"user":{"fieldArguments":{},"fieldQuery":{"User":{"type":"FragmentSpread","fragmentName":"User"}}},"devMailBypassList":{"fieldArguments":{},"fieldQuery":null},"aiProductBuilder":{"fieldArguments":{},"fieldQuery":{"AIProductBuilder":{"type":"FragmentSpread","fragmentName":"AIProductBuilder"}}},"membershipsEnabled":{"fieldArguments":{},"fieldQuery":null},"sgtm":{"fieldArguments":{},"fieldQuery":{"SGTM":{"type":"FragmentSpread","fragmentName":"SGTM"}}},"onboarding":{"fieldArguments":{},"fieldQuery":{"Onboarding":{"type":"FragmentSpread","fragmentName":"Onboarding"}}}}}}}}}}};

export const initData = {"commitId":57684,"hash":"8224055854933509","reducedExpression":{"id":"RkQ8bg6jmmANYS5zmBRIy","logs":{},"type":"ObjectExpression","fields":{"root":{"id":"lZuu-AqIG0t_NWrNKjzZ0","body":{"id":"Mf2tYi71ky0h7n8esdQVz","logs":{},"type":"ObjectExpression","fields":{"customersCanvasMockupPipeline":{"id":"WUToIKTOMmSfmdeIwP85o","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"FgLQfg6YvEv_I-CTnK5k1":1}}},"manualMockupRegenerationEnabled":{"id":"NvTJEMlQyCXOk4ubPVXDH","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"9LKeNCrHme5gav6a2cwQe":1}}},"labelTransition":{"id":"CwQvq2XBRy2m3xxkN5jRX","type":"ObjectExpression","fields":{"autoupgraderDisabledTooltip":{"id":"Yjh5FRzcVa3Av5s1MAC-z","type":"StringExpression","value":"","valueType":{"type":"StringValueType"},"logs":{"evaluations":{"2_ZbEcYoWPpo7Tp8ecvgz":1}}},"autoupgraderDisabled":{"id":"DlTW1-jJwwulpRWVfJQ7c","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"wDrbFwfPoLdrTROLRCOV7":1}}},"showLabelMigrationStatus":{"id":"re54q3VQ2tHWLTVoc-rsE","type":"SwitchExpression","cases":[{"id":"4mHsGxTOhYzc9fpdWmLdO","when":{"a":{"id":"ogT7Ji9MrxJzlHMuMn3dM","type":"GetFieldExpression","object":{"id":"W_8mC4qwqgHEH1VlyZvJ5","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"FFdNVwcX7eXALiCfqhAD1","type":"ListExpression","items":[{"id":"hIjawzL6weHwiD0kLDKBZ","type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},{"id":"QCov28D_9iqBz9_kcL-at","type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"BmsOPatj38riTxaOla4xW","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"f2DpOrIWOUm-FVOlpyzyK","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}},{"id":"_JU4dSNeVezwq7sph4DYT","when":{"a":{"id":"7aERv9WfKx92pkvzLwKMr","type":"GetFieldExpression","object":{"id":"8AsOwDnCFWkZk7nP-Bm3r","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > webUser > email","valueType":{"type":"StringValueType"}},"b":{"id":"1-NmKQPcMZ_z1FUaBl2Fl","type":"ListExpression","items":[{"id":"xoiviTLuIDLKhD92O9YZI","type":"StringExpression","value":"alina@supliful.com","valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}}},"id":"ggpqNyWajrG_KfRK6GTeO","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"goqgxn-b_0sTaFAC2Jr66","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"opPrv4nyFDq6I8Ck1XESe","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"uq4Z8N7HWLIxfuemrVbKD","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"eJb5bEOQZQrRnzYRsotGO":1}}},"showLabelTransitionBanner":{"id":"EU4C5VDOT4XTWk7FGKJrw","type":"SwitchExpression","cases":[{"id":"OCDzlBtlfsQWUp-jT-Rcu","when":{"a":{"id":"3uMYqi7CByVjNwhPZyal5","type":"GetFieldExpression","object":{"id":"nMnJ8Vo8oKy7HRCsEVMR4","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"jYBiCVUHvBgfnWGeKBLXy","type":"ListExpression","items":[{"id":"aTeiN5qUO2NDnDG9t4Qbi","type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},{"id":"QIULmXmLbBYakxKRHflKg","type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"jCInwk18IvoccD6QsuHMn","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"DdMfUhry_w0Of6zKugtY-","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}},{"id":"TBJMz9ewShsDGw-6fBdNB","when":{"a":{"id":"wyt7FrQloWtVtJZucFbBK","type":"GetFieldExpression","object":{"id":"JZL7i4Zl7Ap3GssGcmnkq","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > webUser > email","valueType":{"type":"StringValueType"}},"b":{"id":"t_1CoN2IsxxCWJMksym_5","type":"ListExpression","items":[{"id":"gRnEWygQ0NSCkJBFDSOJr","type":"StringExpression","value":"alina@supliful.com","valueType":{"type":"StringValueType"}},{"id":"1WCxNw9ZjcK9PmbuuaENM","type":"StringExpression","value":"toms+user@supliful.com","valueType":{"type":"StringValueType"}},{"id":"W19ujlhT0jwNoL56VbsqN","type":"StringExpression","value":"katie@supliful.com","valueType":{"type":"StringValueType"}},{"id":"TVtVkDheSg90zuo7OdNWQ","type":"StringExpression","value":"rihards.eglajs@supliful.com","valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}}},"id":"qYFfRu92N8srjHaNqQAGS","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"lGr8ASASXMqBA7Ew-Js6m","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"nWPhP_u0Dd2CmHM2s6BE8","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"XhkOhuCVdFrNZWyZ3EG2u","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"i-yVOznSuLdRhyC2YL119":1}}},"migrationDeadline":{"id":"BS9_r6Ls2A6kRmqn3tmoQ","type":"StringExpression","value":"2026-07-01","valueType":{"type":"StringValueType"},"logs":{"evaluations":{"_k-YphruYjt0h03dOdMWW":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"LabelTransition"},"objectTypeName":"LabelTransition","logs":{"evaluations":{"hsMA8BZjSdMVW_hPGkoN6":1}}},"labelUpgradePurchase":{"id":"JQuq8gAGTDVhvF5gEFmz7","type":"ObjectExpression","fields":{"autoUpgradeTermsLink":{"id":"uFxUAGY9wHUSwXoDEOE-f","type":"StringExpression","value":"https://supliful.notion.site/supplemental-terms-of-use-label-auto-upgrade-tool","valueType":{"type":"StringValueType"},"logs":{"evaluations":{"w_uuHtRNWpuEXTDdzFHfd":1}}},"subscriberFreeUpgradesCount":{"id":"HTfZ-u4Au0RVpxmumYUbr","type":"IntExpression","value":3,"valueType":{"type":"IntValueType"},"logs":{"evaluations":{"YgU2hSwdaTopdicKdP0g0":1}}},"priceId":{"id":"uHXwZOJayIiUSLT_ldBGM","type":"SwitchExpression","cases":[{"id":"ZUB6W8g7uc5lA4PsVZ5Kq","when":{"a":{"id":"GQyedcEkEik47VlzNaq32","type":"GetFieldExpression","object":{"id":"T817-T0c-BRVI8vGDaTWU","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"MkrdBbj7LixSu31_JP9CM","type":"ListExpression","items":[{"id":"3-MSDaFYO9vWOlQq5QDXt","type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"jK0HHe87ybRKKdSuEo4lV","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"Y-tSPE6U2the40sHClrxu","type":"StringExpression","value":"price_1TZoLqHKBukoNoyr1snwLRdq","valueType":{"type":"StringValueType"}}}],"control":{"id":"As63DglObOqP42_IZyaqv","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"pB5uZ2dtZwq9zwlrSZ6El","type":"StringExpression","value":"price_1TZnqjHKBukoNoyrjzfh7T8v","valueType":{"type":"StringValueType"}},"valueType":{"type":"StringValueType"},"logs":{"evaluations":{"4SV9wBW_asm6w_XI-FEgZ":1}}},"priceCents":{"id":"TDXF2nsf_CthYD6w9J7UC","type":"IntExpression","value":199,"valueType":{"type":"IntValueType"},"logs":{"evaluations":{"cgD9s56BG7T3Sw160Phrp":1}}},"freeCouponId":{"id":"Ngw9Kqi3QcjtS5UHjdEr1","type":"SwitchExpression","cases":[{"id":"Z53qDjD_JedUtq_B4Sgbg","when":{"a":{"id":"IwBXzrx7FoJYCScrVtVDM","type":"GetFieldExpression","object":{"id":"eW2LL7_3DOml_4119_Q40","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"hYCuB4lVm6pI7UnI6VNTJ","type":"ListExpression","items":[{"id":"A06y0pHqJ4ThSPKYPUfkp","type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"qkdV06Eq7QRZ7AFweIyUz","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"VdxMoWGevX8DUfmZY0H7d","type":"StringExpression","value":"qIo7q2lu","valueType":{"type":"StringValueType"}}}],"control":{"id":"Idn1d8a8mKNqIjZIxGkjU","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"d8J2o-ONUv9jJfN3AAbCT","type":"StringExpression","value":"BLl1GWCx","valueType":{"type":"StringValueType"}},"valueType":{"type":"StringValueType"},"logs":{"evaluations":{"dHG7VGtjTyNObxEGTYto-":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"LabelUpgradePurchase"},"objectTypeName":"LabelUpgradePurchase","logs":{"evaluations":{"pLl_cOQSr2OkzqNwzOHfn":1}}},"shopify":{"id":"jWRsVDDkYz95sHGV8IY-4","type":"ObjectExpression","fields":{"useREST4InventoryActivation":{"id":"nSE2Cxx1jQC8-XT6Ep6pk","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"-VKlcoy4pSMZjJLioqJkx":1}}},"shopifyShippingRatesSetupAppEnabled":{"id":"4zx6qAdL8gHI5GtkVgPdu","type":"SwitchExpression","cases":[{"id":"PBWQTQV5OisfOC8sI9oEo","when":{"a":{"id":"moVo5WQVQ4Q6OWtmlqv9z","type":"GetFieldExpression","object":{"id":"TJiw_3dog0Ef7B1lunW1r","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"EmOZm-8QIRjYjnJlPXFGv","type":"ListExpression","items":[{"id":"56_ubJ7yws3MXYdpGTkI9","type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"sNyDQ3zqR3AnETxbOG8m5","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"QsmArFiECmRfDIppB3WDS","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"pwAyhjRRpWoJItlKQcSYS","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"4Rb4Foc2I_vNoHyDJVt_E","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"bUUdsyyHVtUCgVUSogc6Z":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"Shopify"},"objectTypeName":"Shopify","logs":{"evaluations":{"nlvPlt6xVgHytYSmrwCLQ":1}}},"payments":{"id":"X6skYwfSKoJzaaQctZiXo","type":"ObjectExpression","fields":{"suplifulCreditsTopupEnabled":{"id":"mzNQy7hDX28N_w9n0NOkE","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"lfqFNBleOs57618ifBzWc":1}}},"suplifulTokensEnabled":{"id":"LhCRQZGfYedfAVzRoEq2Y","type":"BooleanExpression","value":false,"metadata":{"note":"// not going forward with tokens for now"},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"9tvv-nApxPPjrlNjnUn3X":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"Payments"},"objectTypeName":"Payments","logs":{"evaluations":{"WxGxyCcHfeS7SoHfhvDY2":1}}},"adminGenerateMockupsFromLabelV1Enabled":{"id":"R5Py5nlyfWo6A0vmOAozz","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"I5XfR8tD3CXB9p_1jVkoL":1}}},"adminLabelTransitionsPageEnabled":{"id":"YasDLyFuvZ1H43BZa59Jl","type":"SwitchExpression","cases":[{"id":"ZCFntmjX2nR488syyvQD1","when":{"a":{"id":"-fKKbIDIf5It1JJGTXXsM","type":"GetFieldExpression","object":{"id":"ST8BN-VIXxU1eLjjVB_67","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > adminUser > email","valueType":{"type":"StringValueType"}},"b":{"id":"cJeDoi-wNuj9qoRnSAAZI","type":"ListExpression","items":[{"id":"Lx3zgc2lG0hRsD4ireLAM","type":"StringExpression","value":"linards.bulks+everything@supliful.com","valueType":{"type":"StringValueType"}},{"id":"UPCbxHFq45byvKpNu01io","type":"StringExpression","value":"linards.bulks@gmail.com","valueType":{"type":"StringValueType"}},{"id":"e2upeJnXjFbpK9vPo8-Gt","type":"StringExpression","value":"ehsan+everything@supliful.com","valueType":{"type":"StringValueType"}},{"id":"P1TIdYV1QhYAzqOgbhT7A","type":"StringExpression","value":"toms+everything@supliful.com","valueType":{"type":"StringValueType"}},{"id":"MQaytUPBkJNERUHq38_d_","type":"StringExpression","value":"alina@supliful.com","valueType":{"type":"StringValueType"}},{"id":"8wLuebc7BtPNHL7hsoFGX","type":"StringExpression","value":"daniels@supliful.com","valueType":{"type":"StringValueType"}},{"id":"J7xPW24g_yZiWJFB9vXWj","type":"StringExpression","value":"toms@supliful.com","valueType":{"type":"StringValueType"}},{"id":"ajVAb9y87kEY-SX-bwhoX","type":"StringExpression","value":"glebs.paltovs@supliful.com","valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}}},"id":"wtfMYt5IwCJIAyrauLCx5","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"XY48xcLiQ_skAYDaPGi3x","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"-Hl6eGr2ZA0_ozQnCn_ZO","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"FrcbxfUdCD3ka8fWPuGhW","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"RVE_9GVpbPDSk2Ucjh4xQ":1}}},"adminGenericLabelPreviewEnabled":{"id":"J8hmyU5tbPGU2j5csTGTS","type":"SwitchExpression","cases":[{"id":"nwB9i9LJ7xBmbUefI1rUX","when":{"a":{"id":"apfyDpP2PVpjKX-_LQ5lP","type":"GetFieldExpression","object":{"id":"1J8Hq8XHF2EgDObVVzvlM","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"Ulo4qFrFh91VLiN0VE2cz","type":"ListExpression","items":[{"id":"qusGKSm1Je22gN0xrHLSu","type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},{"id":"kZtbVWR_jzFkG4RmaQrqq","type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"YmIrA31i3F7pqIP568M24","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"AIOCWkpTwBORHeCuBoIvt","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"Vu4hdBDx8rXALUnwVvxSE","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"TizsPWTQ0BvRKAeOPrDeO","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"L6LNajQHjragb2JOXOhn3":1}}},"labelSettings":{"id":"mqV78EMnT_lHgLX870QSx","type":"ObjectExpression","fields":{"dpi":{"id":"oah2H2QUrqWdvdi6mXErm","type":"IntExpression","value":300,"valueType":{"type":"IntValueType"},"logs":{"evaluations":{"M_3erYyYRludPCQJ99A7p":1}}},"width":{"id":"8loQFvJK3JcYkcOrVz_xo","type":"FloatExpression","value":0.2165,"valueType":{"type":"FloatValueType"},"logs":{"evaluations":{"5x1rM8IBPzPHlzetKEtvK":1}}},"height":{"id":"RHoI3s51Jqd_rzaso7eSe","type":"FloatExpression","value":0.2165,"valueType":{"type":"FloatValueType"},"logs":{"evaluations":{"zl92j3-GCUzTQZCmezymU":1}}},"borderWidth":{"id":"n3WbObKLfviurudKU7M2P","type":"FloatExpression","value":0.0197,"valueType":{"type":"FloatValueType"},"logs":{"evaluations":{"XpsNiVehhlIfTG3P3HYLg":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"LabelSettings"},"objectTypeName":"LabelSettings","logs":{"evaluations":{"W_nVIoTcWqIDkf8AOKy1f":1}}},"polotno":{"id":"fdoNhus1TLRhUZ0cluKTI","type":"ObjectExpression","fields":{"unsplashEnabled":{"id":"h_J-RKyK1g6axdaX8d6sO","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"PPW7Y9eRUhU-XSAZ8-KQC":1}}},"templatesEnabled":{"id":"MarG3Vg_JZ6XLSiUgJalM","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"88Qlxd4liJlQUZhUhmA91":1}}},"useNewLabelForFulfillment":{"id":"eUVrXThn2V_OZD0LVhd9E","type":"SwitchExpression","cases":[{"id":"7dPmmKzyw6o6331tQeEsd","when":{"a":{"id":"jmr6_UichPqO0CvxyAb0p","type":"GetFieldExpression","object":{"id":"R_CslqV8SRYmGhlH9qx4B","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"fvnSlaJ8Q9DOiyHlvTXOj","type":"ListExpression","items":[{"id":"vnVw-cKZH8dfkKXbXHqeN","type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"COBec5Oe30wzSvSYn6bEn","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"ODlqI2614udC4cGKDNOuE","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"h2gjp1zfDK5zkaTMOna4L","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"ynTF7kTcvqNQcI5bupON4","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"dh-teTfEjhx3aZj_PiYHN":1}}},"enabled":{"id":"O1p8nLvUfZyANcxa-Zmjz","type":"SwitchExpression","cases":[{"id":"OwC4ySDNPZnN-JeMKo9Z3","when":{"a":{"id":"IosQq9MluP9ED4lPSV-G6","type":"GetFieldExpression","object":{"id":"Hn7FfubXy33I3k_4Ft9kB","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > webUser > email","valueType":{"type":"StringValueType"}},"b":{"id":"N15Uhn5Evbf7m7F_B8icE","type":"ListExpression","items":[{"id":"Xfdc6cUyPzSpz2aTxw7z4","type":"StringExpression","value":"alina@supliful.com","valueType":{"type":"StringValueType"}},{"id":"RlvtOYsDtaL3LxKF0stmp","type":"StringExpression","value":"katie@supliful.com","valueType":{"type":"StringValueType"}},{"id":"-qeshYCvB6655cKW4JA8Y","type":"StringExpression","value":"rihards.eglajs@supliful.com","valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}}},"id":"yKGhzR3wZUoLQPu1V5892","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"ZGhQvzt72vrsO_7TgGq7O","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}},{"id":"hN4gr5tLP7eXznMMqvGV-","when":{"a":{"id":"9GjrYbdRTnLCNDYjx5luj","type":"GetFieldExpression","object":{"id":"SZ3UOToz7Z1B6xFEqF5Rc","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > webUser > email","valueType":{"type":"StringValueType"}},"b":{"id":"twjzeSuj7zwXmFsBQz6ny","type":"ListExpression","items":[{"id":"ABW2Xjeshjfue-Z_fYZmG","type":"StringExpression","value":"toms+user@supliful.com","valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}}},"id":"9r4wEc4-jiopzpG_eaL7k","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"Xkj_WmJYsWrDwjivzZ25Y","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}},{"id":"jOm_fNpBAIFSNTbITw29p","when":{"a":{"id":"dF6uVtaH-UIgJXcQeu10f","type":"GetFieldExpression","object":{"id":"RChaANqmZVhUFu0Gpdt5-","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"BxrVF_zbX_ArfvcFdW8WC","type":"ListExpression","items":[{"id":"HUXiW8r17MNhuq58Hpo38","type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"h76blzBihDdsi2DCKuNtI","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"b1QJF0KFelA1f33rlxVc2","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"8WU02UKHMRuNs3ZGyuoEg","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"t8ltdvcoBYOS6UTBSWrIt","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"ImNuIGBV_EDYD3CE8fdF-":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"Polotno"},"objectTypeName":"Polotno","logs":{"evaluations":{"1Yv05XDGCx_EBYpaYei6G":1}}},"shipments":{"id":"rhRtMi52pD3mzlTxNuzqf","type":"ObjectExpression","fields":{"shipmentInsuranceThreshold":{"id":"GubDyWv_64SnEKzb5v4BS","type":"FloatExpression","value":100000,"valueType":{"type":"FloatValueType"},"logs":{"evaluations":{"ygYqVKBWGgpIWxAknNuLO":1}}},"easypostEelPfcEnabled":{"id":"-cCHgsDC8xRg9klZ2Gy6R","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"G65tKQjfQmlTPYGibStdR":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"Shipments"},"objectTypeName":"Shipments","logs":{"evaluations":{"F-xg1NP6a1Diz7Ii5PAkG":1}}},"shiphero":{"id":"DD8t7oX4O0y8o4xp-kMEs","type":"ObjectExpression","fields":{"productLotTrackingEnabled":{"id":"qCUaQn6vpUVSYy-8t19vv","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"oe8URrv3z9uSEdc7jIWxE":1}}},"orderTag":{"id":"Mfg8C8OdwfildzMxeO6Z0","type":"StringExpression","value":"POD","valueType":{"type":"StringValueType"},"logs":{"evaluations":{"7IZbGW89UptLSrBFXVNTd":1}}},"userProductTag":{"id":"VUHSRB7IGf-FfNbomiw_a","type":"StringExpression","value":"user-product","valueType":{"type":"StringValueType"},"logs":{"evaluations":{"VsY-bEISI0f7y4Nsybo2x":1}}},"userProductSyncEnabled":{"id":"o-9DEdGmqD8ffNyGhUbKV","type":"SwitchExpression","cases":[{"id":"Vwf6MMf2G8WCkRh7nAeTe","when":{"a":{"id":"Yoyhdoy5XiTGp6guta1ej","type":"GetFieldExpression","object":{"id":"d76I5H1UMAc1EvKJlxg7A","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > rdeID","valueType":{"type":"StringValueType"}},"b":{"id":"UZuuFT_S36FT9QnLT9wR3","type":"ListExpression","items":[{"id":"MHaCJYCOReO80aUOjwW2U","type":"StringExpression","value":"kshna","valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}}},"id":"Yf3OF-hQAbkcIgVw1Jaqy","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"hJH3Dy9qaRXKaugZy5X7t","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"eT4ctnrLki6bZuLmXQaKF","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"1NeXEXCptvapp10InN3ae","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"0n1pi9YK4qSguLOrzKPjH":1}}},"warehouseSyncEnabled":{"id":"zJUmlO93a9SYuxyDY9Zo-","type":"SwitchExpression","cases":[{"id":"I32RKrkmvivp0KnptaO4A","when":{"a":{"id":"p-vEdE9mrVi2HRw9e2ZaK","type":"GetFieldExpression","object":{"id":"hARmIWKOSam8idniSiws-","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > rdeID","valueType":{"type":"StringValueType"}},"b":{"id":"8gm4O3QWIPq6ushJqIxAC","type":"ListExpression","items":[{"id":"Q2J458QboqWmOfXJ3Uq9u","type":"StringExpression","value":"kshna","valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}}},"id":"GyeRF0jBmJAtGNblk4G9-","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"FNlDMsjZ1iqB35DFnB-bI","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"2MkXZ8RgTtbv1ysicD9ta","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"2kBiJyOzRX4dZUe1UBKLd","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"DTMXb0LOultxn5CgqmpAj":1}}},"catalogSyncEnabled":{"id":"5-ALsiA_ygtuOQHEfXyB3","type":"SwitchExpression","cases":[{"id":"eLF0QpAClbUSFRSIjqBCz","when":{"a":{"id":"jQiRHlpGqFw5d8PVAVBwg","type":"GetFieldExpression","object":{"id":"1cW14jCfNjZlRKftXEfTp","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > rdeID","valueType":{"type":"StringValueType"}},"b":{"id":"Ug87ZVHnTyt7Alr1tIPC2","type":"ListExpression","items":[{"id":"T5bBNMRB_Qp5qTGkrf-mP","type":"StringExpression","value":"kshna","valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}}},"id":"Fyz1bhSySxL7iC_2LT7RP","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"oGjKxsF720sq67Rd7zH49","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"W1zmsMZD-pF1M8o1mktds","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"rHH66xzRTcO23EVkF7Iro","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"L5loIeU12nloXfEB389Nu":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"Shiphero"},"objectTypeName":"Shiphero","logs":{"evaluations":{"a6PDm3JfgSHzRyf-uBUd2":1}}},"regenerateMockupsOnSubscribe":{"id":"AqAupV4voLC2Tn52BVABW","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"-A-LXFD9yApkEQBEVFfcG":1}}},"hubspot":{"id":"NmkgEQZLWijDg6QW04AeS","type":"ObjectExpression","fields":{"testing":{"id":"z8t3BQ8On0FKl84Dr6phB","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"m4CJCAJ9R4WI2UlmNCVXW":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"Hubspot"},"objectTypeName":"Hubspot","logs":{"evaluations":{"PUGEaHyIyn-I0EtkLJzcI":1}}},"tikTok":{"id":"_B4hiZZYzxO17q28r_b8K","logs":{"evaluations":{"ZYDSa-F1Y-fuHK42ZyBGx":1}},"type":"ObjectExpression","fields":{"discontinued":{"id":"vwaVXzAoD9wG-wAch-fAP","logs":{"evaluations":{"3TgdYDmeBtvNCP2b0WVKR":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"orderCutoffTimestamp":{"id":"xgcP-Dxto0CP40j97chc7","logs":{"evaluations":{"QelLVBQBqyKFg72J7LNT3":1}},"type":"IntExpression","value":1740052800,"metadata":{"note":"2025-02-20T12:00:00Z"},"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"TikTok"},"isTransient":false,"objectTypeName":"TikTok"},"canPublishToTiktok":{"id":"NscGR477nTL8Mi8Sg-DrQ","logs":{"evaluations":{"BnSooMSPW_PvGjpwpk68e":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"canConnectTiktokStore":{"id":"t1gQASLPoRTyouKxsnSwb","logs":{"evaluations":{"agFGchoWOEediYXYVd5MX":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"tiktokSellerShipping":{"id":"xD7Qk2byjfmUnaDd1N2Kc","logs":{"evaluations":{"PlFDfCtu1SPQRR3p1P1_q":1}},"type":"ObjectExpression","fields":{"enabled":{"id":"hg7A4wvxdec4tkO7bDWXI","logs":{"evaluations":{"ZBdZCjK0MdgFTFRT9F-AH":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"shopUrls":{"id":"7OTgDANgcDtOXb86N0Mh9","logs":{"evaluations":{"LDjLcBIgV0DmbKlHhLWJh":1}},"type":"ListExpression","items":[],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"TiktokSellerShipping"},"isTransient":false,"objectTypeName":"TiktokSellerShipping"},"tiktokShipping":{"id":"P7uVhvjnGAez_EHy_m4Ve","logs":{"evaluations":{"d0a8SxCrm85mT2HEhueED":1}},"type":"ObjectExpression","fields":{"enabled":{"id":"GNDsPQpBYqXK65Uw92obJ","logs":{"evaluations":{"fS_YOk6BxxiRq6yKpOACz":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"shopUrls":{"id":"OAQCuF0yNkEjKfuxtmvlK","logs":{"evaluations":{"aI0mcfeb2hOm0mCMsD1rG":1}},"type":"ListExpression","items":[],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"TiktokShipping"},"isTransient":false,"objectTypeName":"TiktokShipping"},"magicLinkWithOTP":{"id":"9SRZDoGCNdHNT67YRiqbw","logs":{"evaluations":{"bUHbsb5Z1Vgj3Q1skJLcr":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"metaConversionsAPI":{"id":"I03sD4ztC_Ywx7SqaBnZC","logs":{"evaluations":{"r9Y2QL1yxGmt7T18iUWZ2":1}},"type":"ObjectExpression","fields":{"testEventCode":{"id":"P4iyWSBOzlXUAjvOA2209","logs":{"evaluations":{"Y5KHfI6olnQcDlO1Qq2lV":1}},"type":"StringExpression","value":"","valueType":{"type":"StringValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"MetaConversionsAPI"},"isTransient":false,"objectTypeName":"MetaConversionsAPI"},"blackFridayPromoIsEnabled":{"id":"Tmi6wyT4-8C-BalJR3oOr","logs":{"evaluations":{"-UkWr9KKTkdLe0orH9wFw":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"clickFunnels":{"id":"OapIuccBXQZ40Vk8g0Jc8","logs":{"evaluations":{"CpchsLyiIHMKmSe3EaeeA":1}},"type":"ObjectExpression","fields":{"clickFunnelsStoreCardURL":{"id":"RHp_IRG6rzR5FF61M2-JS","logs":{"evaluations":{"choqQ8Rk9wG2UsOQTPzPV":1}},"type":"SwitchExpression","cases":[{"id":"CkRtEvcRMGu7dWmMJwqRP","when":{"a":{"id":"C69P8HpBpfPaPse56Lnsa","logs":{},"type":"GetFieldExpression","object":{"id":"AiHzSQBogHD-tl64uqnQI","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"e6Q6b0M2atOdEeH9la65E","logs":{},"type":"ListExpression","items":[{"id":"wMpN1TE2oBIo2wNgV5uav","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"ffltuzAM7k_S5CQ0sfpBu","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"MyGiQzlyoQ_HyAiWKHUyL","logs":{},"type":"StringExpression","value":"https://help.supliful.com/en/articles/12927829-how-to-connect-your-clickfunnels-account-with-your-supliful-profile","valueType":{"type":"StringValueType"},"isTransient":false}}],"control":{"id":"RIidCfqfhhr1lBIbRGT02","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"t16r_zHSyXB3qEZxguXOV","logs":{},"type":"StringExpression","value":"","valueType":{"type":"StringValueType"},"isTransient":false},"valueType":{"type":"StringValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"ClickFunnels"},"isTransient":false,"objectTypeName":"ClickFunnels"},"clickFunnelsAllowTestOrdersInProduction":{"id":"bjwq5fhqyCkfRE9Vc9Jmy","logs":{"evaluations":{"xrV2S0TOSa_UOMCwOkytM":1}},"type":"SwitchExpression","cases":[{"id":"gb1tmOSAy167m-k21rB9-","when":{"a":{"id":"BOJe9duA_hVTbvWergSNU","logs":{},"type":"GetFieldExpression","object":{"id":"WuWWgZmJU4EfgCo9994X9","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > webUser > id","valueType":{"type":"StringValueType"},"isTransient":false},"b":{"id":"tgv_TaXYqCwpCeGkLcxNZ","logs":{},"type":"ListExpression","items":[],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"id":"Sxr5fExtzCq2yfLn18v4o","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"fr1aLkNjL_Lv9iRWXf3FG","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"5vx-wGTnkMBMWNq1w6O_U","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"RJX6a1fslFCYV6wMWRFQR","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"useAsyncGtmSignupCallbacks":{"id":"iBtTKCmrKifOAtgWFeL6T","logs":{"evaluations":{"URboHUkWN6jRrMQhcepcx":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"sampleDiscountValidDate":{"id":"5kDoHy-rBKoJTz9kDGOP2","logs":{"evaluations":{"M7LLfVweLFgM4jO2Ije4A":1}},"type":"StringExpression","value":"12 November, 2025","valueType":{"type":"StringValueType"},"isTransient":false},"clickFunnelsIsEnabled":{"id":"EnuLaZektMLZcISTGqxAr","logs":{"evaluations":{"-Vqzox6sNsRmXktKVAX8W":1}},"type":"SwitchExpression","cases":[{"id":"dtl63T_r3GlZH0WUalFNC","when":{"a":{"id":"KyCDe_Kae_r4vnILD2t5C","logs":{},"type":"GetFieldExpression","object":{"id":"pCepFn1MOhoUpEQEgP6qx","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"MRfhK7XHgb6ZXl9xcYPL9","logs":{},"type":"ListExpression","items":[{"id":"_zlM5LWYzDQK_l-oreBi4","logs":{},"type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"cR2WLQevBY5krjDPkb0IZ","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"xKXIjdFly0lZuc5gxy9-j","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"vXjxN28SnsHHpnUbcYDDm","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"ZiWiauiV-2t2lltPvN8LM","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"DY721nVHCIdUf4w-jaUG2","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"BtjiFnvPPoCXUdzGdApPp","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"extendedCatalogIsEnabled":{"id":"hsbRz4Bqzys-TAZTEJCKr","logs":{"evaluations":{"LwigzxtiGCB-DEAIFt5uo":1}},"type":"SwitchExpression","cases":[{"id":"WuB0wSi-2mul49qyjbi0F","when":{"a":{"id":"yxU_JsmvN2V1r-mFtKFGm","logs":{},"type":"GetFieldExpression","object":{"id":"SFCE4cva85lbnAVTlw0fV","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > webUser > email","valueType":{"type":"StringValueType"},"isTransient":false},"b":{"id":"9NMulzOgZUOzY40dOOS05","logs":{},"type":"ListExpression","items":[{"id":"sf-hJcmvFMhvdwB0epNbK","logs":{},"type":"StringExpression","value":"rudolfs@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"vJBPs2VZaxM2GkK0JSAGm","logs":{},"type":"StringExpression","value":"lasmanisjanis@gmail.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"PFK0_f_cFhJ_7h8MHntUA","logs":{},"type":"StringExpression","value":"mike@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"yPcTqvti9TH2zfU28dnYh","logs":{},"type":"StringExpression","value":"noranskepals@gmail.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"6xGDqm-ksyS8o8uCNGCGC","logs":{},"type":"StringExpression","value":"darta.tene@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"ijqKIkvjF3oYLtAcq65zb","logs":{},"type":"StringExpression","value":"andriy26102023@outlook.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"4fHuRGsam_Pu0H6uE5QbD","logs":{},"type":"StringExpression","value":"alina+333@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"crlnhyDR7LJpS3bfBr1UR","logs":{},"type":"StringExpression","value":"suplifulbot@gmail.com","valueType":{"type":"StringValueType"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"id":"fXqRfmjjIzxCOWLK4ESlw","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"bLQQO6_y6ZFBtmRC66_vn","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"GVCqlwYGUYf8gytGQTXf8","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"NQK6bq6Bedspb5n23js0g","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"roastifyProduct3DPreviewReportIssueEnabled":{"id":"TNNelU2fQNUx6KTIW8d3Q","logs":{"evaluations":{"qZn27EMZHsJkosNSw-QAu":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"stripeInvoicing":{"id":"uOxAJ1E51BWFLwn0HuGde","logs":{"evaluations":{"1jcKFGs9naBpk7gR0SEwe":1}},"type":"ObjectExpression","fields":{"sampleDiscountPercent":{"id":"eXB0Ar9MfOMxyDSC6d2o3","type":"IntExpression","value":10,"valueType":{"type":"IntValueType"},"logs":{"evaluations":{"NVAI3atLycTTj-B2om8HH":1}}},"shippingFee":{"id":"PyKHuAjdC4YB0TtQ6bLho","type":"SwitchExpression","cases":[{"id":"_TV-IIvvBEkYLBY6lzNbT","when":{"a":{"id":"7MeFMkq8vyFv4RRMb37gA","type":"GetFieldExpression","object":{"id":"HJkIkYro2-OMIO_ReFG1w","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"oOc-hi1lnefUWQVlqUkdg","type":"ListExpression","items":[{"id":"DlbiFNe_TFPisdpj_B7cR","type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"UIM4fvOUGtTP9ZRYsBPGW","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"9aMMMN7kaBdzUdi3SWLTT","type":"StringExpression","value":"prod_UCtM8bHTUtvIte","metadata":{"note":"// PRODUCTION"},"valueType":{"type":"StringValueType"}}}],"control":{"id":"EaUpzZ-di0YB_oXuNFo0d","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"OaStOdTwKmhjzeBgyg_b-","type":"StringExpression","value":"prod_U2pjdLZ5IsnKIb","valueType":{"type":"StringValueType"}},"valueType":{"type":"StringValueType"},"logs":{"evaluations":{"5i8m_3HuSmfSaEdIdSt7_":1}}},"sampleDiscountId":{"id":"zofUicHcmjSdwvMSjARdU","logs":{"evaluations":{"PUt3H5yWDfHWOKrftMcPG":1}},"type":"SwitchExpression","cases":[{"id":"mjAJ-kQpaDD6QwyfnCvVW","when":{"a":{"id":"dkR4SbCknYjmx12_WaFNj","logs":{},"type":"GetFieldExpression","object":{"id":"qjE-5Uts8MT1DIKrx3wsY","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"QJ1j5LJA20vSKpCz14iVa","logs":{},"type":"ListExpression","items":[{"id":"X01O8fuutsQ4LoTupTYYv","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"FOYND-7eRYfAzTceGxd3s","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"O9icWLzzI0sB8A3zmB4OY","logs":{},"type":"StringExpression","value":"s4IbKymp","metadata":{"note":"// PRODUCTION"},"valueType":{"type":"StringValueType"},"isTransient":false}}],"control":{"id":"yERV-_TSAWD4U0kKnwOfU","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"MiGcPq5I6Bu_hHVgvK2tj","logs":{},"type":"StringExpression","value":"dsHVa8YH","valueType":{"type":"StringValueType"},"isTransient":false},"valueType":{"type":"StringValueType"},"isTransient":false},"enabled":{"id":"JHdU1PQ9s9f3aJibdYYYI","type":"SwitchExpression","cases":[{"id":"qOaimMI1alYus2JYrKiiI","when":{"a":{"id":"6TghXAsY6jm_f3362b3fh","type":"GetFieldExpression","object":{"id":"7I-9xRtnmZ2Vxu1Wuwz-B","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"NMULY9eRoFgPXfus8pdin","type":"ListExpression","items":[{"id":"wUQZmaz7BEYxvc8er_K3T","type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},{"id":"gPcMab0GzHRI5m9cBgCeF","type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"hTiQWxQJlA2Ybp-IthGoe","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"3ka4t3L_yUhwsCCUK2lAf","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}},{"id":"4XnC3SLlnvpK2wLfwOYlp","when":{"a":{"a":{"id":"WYPsYc8R5r3Yb6DnYI2nP","type":"GetFieldExpression","object":{"id":"RH4fIh3-_8m2WYDbtyqfP","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"5x9BZmAx8h5LJKsskWQib","type":"ListExpression","items":[{"id":"EyyXC4KConWIcrC6C7Pzu","type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"H-Wu4axEjn-U9Nxu8Zco9","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"b":{"a":{"id":"twt5df9vj_1yDKTFwx8-D","type":"GetFieldExpression","object":{"id":"CU0yRO-LEjKM1Pq1cvnDx","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > webUser > id","valueType":{"type":"StringValueType"}},"b":{"id":"8bOIBvzKmeGtwy8Z0gl5B","type":"ListExpression","items":[{"id":"OH41p8q1-lL5XZjm6QaE7","type":"StringExpression","value":"c0f0f363-2ca0-4bcf-85a4-2cd40576b4e1","valueType":{"type":"StringValueType"}},{"id":"QqADaT8X5qZ02JqkhZabl","type":"StringExpression","value":"bf8b1967-27b8-4b27-a098-d62cbd7ac7d6","valueType":{"type":"StringValueType"}},{"id":"SJ7FrvUsYDPPRLNT1rz6C","type":"StringExpression","value":"38fdbfe8-450b-4ffa-803b-f6d90b212683","valueType":{"type":"StringValueType"}},{"id":"-kDjBZebe3Zt2W9fAF8IC","type":"StringExpression","value":"ac7d80bd-f66a-4b18-80b1-881494fb1292","valueType":{"type":"StringValueType"}},{"id":"srXgCX65gN_is3FT2lnuZ","type":"StringExpression","value":"152b31bc-e9b8-4cca-a39c-84872627028d","valueType":{"type":"StringValueType"}},{"id":"uY1fyiMkAA5eeOSE8jaj3","type":"StringExpression","value":"3615d559-4a99-48ae-a910-9d6793b71780","valueType":{"type":"StringValueType"}},{"id":"CET2ZvH291z4zCEO66RT7","type":"StringExpression","value":"d07528dd-c70e-4091-aa21-9465399021be","valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}}},"id":"Zw2VnfW6bvPV2yl0OIzbK","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"id":"fhFI6yTVekX4JqCHl8h7C","type":"ComparisonExpression","operator":"AND","valueType":{"type":"BooleanValueType"}},"then":{"id":"FZcXk8NBBGRmv0JZmaxgU","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"}}},{"id":"7tswTTEK0FHGcNdLrSj_q","when":{"a":{"id":"TAizNqqFTdBQysk5Qeo_9","type":"GetFieldExpression","object":{"id":"-5vomKZ0F0db7CO0CEb3h","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"xC6ZsbQp9tbySVVexnZC-","type":"ListExpression","items":[{"id":"RfL_b4KUhR0NfQLYnKKXC","type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"BxqUD2kXeSwJbVCZj-_Ln","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"OoCmL6qXerTnkIdOp_ETL","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"WaBbA3U83MVGt5Nmc-L1Z","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"uy0NyRu2031VnQSCO2J1g","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"m9WddwsykBQpT58tKJeh3":1}}},"firstItemFulfillmentFee":{"id":"rDNV2iOLXx4DksRvac8KI","logs":{"evaluations":{"yBkiCy0FRR_FqHJr4NTI4":1}},"type":"SwitchExpression","cases":[{"id":"JxlGB7NcvtKfNzit3nN-J","when":{"a":{"id":"3bBEMAhyr9XPFaSgPNsjL","logs":{},"type":"GetFieldExpression","object":{"id":"Sk7U9RN7j5gGGHSV2JBDH","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"LhEqDjl65pm43-e1D-AcR","logs":{},"type":"ListExpression","items":[{"id":"VO6Kv0Q3MknizaoLwZBpd","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"ycco994NhkD6PvhXpto4U","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"Vb7Oy0eU6j9htUXyNrbrl","logs":{},"type":"StringExpression","value":"prod_UCtP3gKDPyyV3O","metadata":{"note":"// PRODUCTION"},"valueType":{"type":"StringValueType"},"isTransient":false}}],"control":{"id":"Pai9KxXpsCVET-JEkbwCG","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"ecMXaGxi-pTifswo3w7y_","logs":{},"type":"StringExpression","value":"prod_T6GXGBueimtYY1","metadata":{"note":""},"valueType":{"type":"StringValueType"},"isTransient":false},"valueType":{"type":"StringValueType"},"isTransient":false},"additionalItemFulfillmentFee":{"id":"Ke03iXZJgIGH3uJPsiXQt","logs":{"evaluations":{"N_pwNfrVoFNJb-3mlNvVA":1}},"type":"SwitchExpression","cases":[{"id":"-Co2NQcl-7e_BJgX3NP-Y","when":{"a":{"id":"LLcY5F-qaLSkEEfogV4jC","logs":{},"type":"GetFieldExpression","object":{"id":"0mg3bAdeYyqMvgtwqsNZ1","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"VttNXQ4GOxPt3xrSK9ZgL","logs":{},"type":"ListExpression","items":[{"id":"nAJu36sLDAL2Uwirrumir","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"b-z6y2_IxdZCiHA-jxwGS","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"GVwj5kaIwG6LmobCikFgI","logs":{},"type":"StringExpression","value":"prod_UCtPjEB1o9JaDb","metadata":{"note":"// PRODUCTION"},"valueType":{"type":"StringValueType"},"isTransient":false}}],"control":{"id":"VL3PHs5Tbi-qyI1tocp6n","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"acBZs9m2slruUW9xBX2Ik","logs":{},"type":"StringExpression","value":"prod_T6GXZ95MxR4hn6","metadata":{"note":""},"valueType":{"type":"StringValueType"},"isTransient":false},"valueType":{"type":"StringValueType"},"isTransient":false},"processingFee":{"id":"W94YBhSq3-Tj6U_xHUyCo","logs":{"evaluations":{"nhEifaaeVVV1UJdEMokz9":1}},"type":"SwitchExpression","cases":[{"id":"iFeV9JFbNJrQq8J0RdJvn","when":{"a":{"id":"2ftwU3H86XPlr2cDJm5Sd","logs":{},"type":"GetFieldExpression","object":{"id":"zw30732ynAu7IgbMDEHEJ","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"Tp705Cl1n8ectD8golzk8","logs":{},"type":"ListExpression","items":[{"id":"bQoWmdOKcINzJTj-4uUOI","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"D3kVEIBieiG3esRP5ZJCO","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"17Hy0jgvVZIQxXNQOXsif","logs":{},"type":"StringExpression","value":"prod_UCtO9tiQAOKqfH","metadata":{"note":"// PRODUCTION"},"valueType":{"type":"StringValueType"},"isTransient":false}}],"control":{"id":"-CFZtmJVyGtClwyL3Km9E","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"ouDgwcO-CsqQzJHI91hOs","logs":{},"type":"StringExpression","value":"prod_T6GWbmu9RkQfmb","metadata":{"note":""},"valueType":{"type":"StringValueType"},"isTransient":false},"valueType":{"type":"StringValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"StripeInvoicingProducts"},"isTransient":false,"objectTypeName":"StripeInvoicingProducts"},"subscriptionItems":{"id":"2MQab1zx09zDQ_phDFjnB","logs":{"evaluations":{"ZOKccU70CBlRpi3YmIwG6":1}},"type":"ObjectExpression","fields":{"enabled":{"id":"O3Se2FwVmTIUuMbs9NQbO","logs":{"evaluations":{"wNpCOQF_U_KYkKX-Cugr-":1}},"type":"SwitchExpression","cases":[{"id":"V-69kwb3CMbkVx0K4xAWl","when":{"a":{"id":"VV9UXuPXwvsJWPt3g7zQ_","logs":{},"type":"GetFieldExpression","object":{"id":"NqT0NnBlYOYm0pwq2O8oP","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"fs-NRNThaFZfuRZDujvuW","logs":{},"type":"ListExpression","items":[{"id":"_XhxRLkQ7zntloSzzWMue","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"ORZ9pUg6JHADuXOFJEhRq","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"9pzpa03Y7sFxoHrUsgB5s","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"DMkTq85QD1gYZtLIkAcAx","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"s5HeRR7MQbIsDfHWF0mGT","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"brandedCustomerSupportPriceId":{"id":"3AIcUL_3ksuwyeAlsfRMy","logs":{"evaluations":{"ijFhDJUcEtqf0t2umXD_h":1}},"type":"SwitchExpression","cases":[{"id":"662J31Qxzm80w4jyYqbgS","when":{"a":{"id":"hyKysWalQWAfe5Jnc1Tzf","logs":{},"type":"GetFieldExpression","object":{"id":"v-1yrJxKpW3p9fLotKyGV","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"5BBkr1or88r-KKrR3wG-F","logs":{},"type":"ListExpression","items":[{"id":"IZ4e-dRVz8ws9wA_g57xs","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"meToTfQp_ABh0nrc3G9zm","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"AQn1MRRcfsaxNrUbcK_8w","logs":{},"type":"StringExpression","value":"price_1QgqxYHKBukoNoyrqe968Vh4","valueType":{"type":"StringValueType"},"isTransient":false}}],"control":{"id":"5OAa8eia_4zvzoCM4mNzw","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"9f5ORyvuxT65CNcCHAfcX","logs":{},"type":"StringExpression","value":"price_1S8IEEHKBukoNoyrvUPYGGOi","valueType":{"type":"StringValueType"},"isTransient":false},"valueType":{"type":"StringValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"SubscriptionItems"},"isTransient":false,"objectTypeName":"SubscriptionItems"},"roastifySkus":{"id":"7OsQF8CE79SGWuS7pAPXH","logs":{"evaluations":{"GjPpttcdcgkvyFVKzazXT":1}},"type":"ListExpression","items":[{"id":"bqEIWgd06u3QsLIfZEDDM","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"wZmwL8bnHhWq6r3YksbGm","logs":{"evaluations":{"KgMm6W57nTrj_WOaoBIyD":1}},"type":"StringExpression","value":"ROCOGNDGUASO12OBOX","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"JZ0Ker6AFSogEo9COn_rv","logs":{"evaluations":{"W3mgke09m23TZ2txsuBUr":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"Cgd0BYPyDSSTLSFGVgK3Q","logs":{"evaluations":{"xl8Jrbij-k6VWo1hbOFnY":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"metadata":{"note":"Ehsan Test 1"},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"C_5KGMNdr8pXwgV8Uw0BY","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"l6GaMgA35th9E7H5x1Khd","logs":{"evaluations":{"thXMWRbbTZLnnOOpBnIlB":1}},"type":"StringExpression","value":"ROCOWHBGUASO12OBOX","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"-wRHH1bnwCdEUj2UTgqia","logs":{"evaluations":{"8ooi23nre-cuciHiGL3fe":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"xWlAdR97WWEGbQnKyyIZl","logs":{"evaluations":{"mnROF3UnttSStgpRLfqRx":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"metadata":{"note":"Ehsan Test 2"},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"CijMS_gMm3tgc9cF3fp3K","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"W0cUp1dBnW1MQdhvifIau","logs":{"evaluations":{"-GqAQ46OuhoZnPQoNn27-":1}},"type":"StringExpression","value":"RST0CZMR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"Obk6NBnZX4umw5k0oN3vB","logs":{"evaluations":{"kyFLGRPgPaNkTM28JuAwQ":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"X7yfo-vVaBttk4B5dF3D_","logs":{"evaluations":{"BoQJNmUyh5tP83mhVcS6P":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"S0udrmkGC5ggaIpyHTMJa","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"C5AvPtaUIbjM1Q4j5wrqP","logs":{"evaluations":{"Lm38U6DVUenMI6zttNhiq":1}},"type":"StringExpression","value":"RST0MGMR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"bP5MREozsIxWnRY0OanWg","logs":{"evaluations":{"QUEZF-k9jjja9wuvSby0f":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"uY9nfdR0q8jmgvZhJjn6i","logs":{"evaluations":{"vRopSCtim8i6iPzO6soYW":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"i_XCnKyDeZZADxq8mwIyI","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"Pon19tvE0rjz1k6cj4H-_","logs":{"evaluations":{"eaumCVywKYf7L8Nmyd2RU":1}},"type":"StringExpression","value":"RST0VCMR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"FgcoQE4eJv-HWsJB2vkWQ","logs":{"evaluations":{"FaCJQNv5B9XmOvGvd7Q9L":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"4af0zyIj9YYUopdCroZhN","logs":{"evaluations":{"EOcRFUNLDDQr6lJPgxrje":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"jhc6ZL_Kd_2NF6W0n99Ih","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"vPUzDiEbnVY5ubxgQop4O","logs":{"evaluations":{"JBl8rYRXhE1I_xczEDzm3":1}},"type":"StringExpression","value":"RST0GTMR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"OzVaKt0Wc4NH60JzAMrOW","logs":{"evaluations":{"Q9u5naBIbN0Hsz-ZSDPAK":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"tvbHsJUptwOS-DfkeFoqg","logs":{"evaluations":{"3mXZSvsNTj4G2vu5x8r1R":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"zWwndipKd9NV3_UOKPaez","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"1x4_3gJR8hIuq8SGo9BrZ","logs":{"evaluations":{"tbvjbzZrhC71iW8Kk-dv5":1}},"type":"StringExpression","value":"RST0CDMR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"sEtbhwODMxuCd_xCu_H5e","logs":{"evaluations":{"CuyOnOvdqIZmxP1E6iS5o":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"LnLmV_hNHSuOeDKcJDmBX","logs":{"evaluations":{"C6-hltZsgI98Ln4DNmHmA":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"RXsYKTYdPgpHclbHoJZQZ","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"t3tyyTIvMf2hB-vxZY83i","logs":{"evaluations":{"m5wo9QEy_7CQr0PnVTYp9":1}},"type":"StringExpression","value":"RST0RHMR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"KXTPADl9tWuTcDteN54-t","logs":{"evaluations":{"n8v9743DAjKC22qpNsBP_":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"bvMBiVcIfgAlP-qORTDOS","logs":{"evaluations":{"B4WA5CiXMEycYD0e1J58X":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"zV78FirqMqGFMu1R6wlLG","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"3czRjGucuWrfhvf5e10SA","logs":{"evaluations":{"wRv-aYN6AWIIOFFZlpdi7":1}},"type":"StringExpression","value":"RST0PRMR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"J53GL7y7iMye8VQhsf8cm","logs":{"evaluations":{"q6OJHKkY-9EoWEHNEcdCV":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"sYcfbUe_-DfzuWd2ctMYY","logs":{"evaluations":{"bqTurMMG4hciiXp7mDmWo":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"hjxuER5MYnFT1yOXRODdT","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"sJDxmHrvXzlgT5nJnE96d","logs":{"evaluations":{"LMTPCmJjF_jNaZAIRdwfX":1}},"type":"StringExpression","value":"RST0DRDR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"2R0-iTtwiFoGEG_5I5FlK","logs":{"evaluations":{"AhlxfaDIwZFaYZ6AmBT9C":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"_QbwDr4fofS6uv-geInTW","logs":{"evaluations":{"EHmMW4nRprelBc1GGgQ32":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"2crH5ydjYuk1HI_tEmlJ6","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"klsW-DitMul80K-oxn4OI","logs":{"evaluations":{"nKnL6_Z3THeJIAdM-K6Mm":1}},"type":"StringExpression","value":"RST0MCDR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"BfPXVuRtU41wA52-AT_up","logs":{"evaluations":{"zParX8SWKKxwF8mpJVWY5":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"Wng_84Bd3jlgqb-NUzj14","logs":{"evaluations":{"Aq3pvvwtZn0LeGcE6XIRS":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"sPUqNP753em4UOLORhEWN","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"ccF21neobY-p6m9QYKcz0","logs":{"evaluations":{"jp9eRGD02_JeWJCZkYNDm":1}},"type":"StringExpression","value":"RST0CBDR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"jzkNBdM_tmyEi82VN08yU","logs":{"evaluations":{"1AOVZ2dXauO4BSjrlY23l":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"JFGvED39mu4iEFlu-NrER","logs":{"evaluations":{"UqbJzdqiX7oc7aZc3YkhH":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"FnqHz2-GU_hur5ATrf_BR","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"QcBtA8bzn6QkkUuO6R5Yz","logs":{"evaluations":{"ttngjOVt5ePOv8ssxpW7G":1}},"type":"StringExpression","value":"RST0FBLR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"FA_Cul8MpA19nqr0IcnUr","logs":{"evaluations":{"A9A2AB2GtgqYnZfQOTn4E":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"-4kdUZzOApOJecJC7uTMf","logs":{"evaluations":{"LU8c1r1QmEM2YaKo4xKkk":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"7NDO1lOlYbUEOsnYS-p1m","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"3-Z3f4iFiOcGsPCzuP0Y1","logs":{"evaluations":{"cYYh7CwAOkTt8fzcTSTct":1}},"type":"StringExpression","value":"RST0LGLR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"yXA0UiESmOXf8cq8B7UvJ","logs":{"evaluations":{"H2odU1x9lFYZvmKNbujgR":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"sjwPyhYpYA2A-UJMf-_Ay","logs":{"evaluations":{"k6ido_ao0f6PqfSbSSH9v":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"gdx6aAAT5_ZU5uLx5Pr4V","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"dRCsU2gcITAthGkKDO2aY","logs":{"evaluations":{"ZFyOkeXLbF34OJ2_35rnX":1}},"type":"StringExpression","value":"RST0FDMR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"hZ9vQZyRCvXm4I6Fgj77c","logs":{"evaluations":{"TdA2r31WAMNXF6R-LDKX2":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"tC5ScJnMTH-CtBhmqliyV","logs":{"evaluations":{"lEyEFgtD_1FoxrMgO6os7":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"PoomU9N84YVdiNApLMX9Y","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"466sMsiUaarfuzMBqOJj0","logs":{"evaluations":{"mvv9BK1DZ7NLP2vff5SfR":1}},"type":"StringExpression","value":"RST0FBCP","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"3bojA27KyUblzYuQX4NxH","logs":{"evaluations":{"CHkHRo6CeZcb538aocfNv":1}},"type":"EnumExpression","value":"Pods","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"8FiAuLnZQ7zz1j43CHApt","logs":{"evaluations":{"kExhJI0XOhU7r0WsTQTX9":1}},"type":"IntExpression","value":5700,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"OxI4e5CwUQmuok8oVRUri","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"lM7IK7XveqPTTeGAeUPgE","logs":{"evaluations":{"HacFqvs9IFj3SY9PZsgT-":1}},"type":"StringExpression","value":"RST0RHCP","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"ZsGu3lRD2tXwPpRc8ysLY","logs":{"evaluations":{"L0q0sV9h6-QVznTRkMMn_":1}},"type":"EnumExpression","value":"Pods","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"uVJS-QSW5XSb2kOcisagV","logs":{"evaluations":{"wH62Ph8vRxl798_JUAd9Q":1}},"type":"IntExpression","value":5700,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"5V3c9byi7zdHnodTW6ilh","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"rS2oE9CeHy1w3teO-NNek","logs":{"evaluations":{"mSspIElQfiKmBEFJ0hwO7":1}},"type":"StringExpression","value":"RST0MCCP","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"_V4UMo1ZQ1Ye6zjVY3jK6","logs":{"evaluations":{"vBQBMPipFw4wapXPjeQyx":1}},"type":"EnumExpression","value":"Pods","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"534XOfUajlUep3bQggrAS","logs":{"evaluations":{"FSfmBDDJVnSS5JGUi02hV":1}},"type":"IntExpression","value":5700,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"AoqHudfnYJmTfgtmJ6fIh","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"LNTXeJTwljBcX9BMIKFJt","logs":{"evaluations":{"IE9Sm6yHtrhixH-nrqeW8":1}},"type":"StringExpression","value":"RST0SBDR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"j0_KJZDFVrrsZgsilA1bp","logs":{"evaluations":{"_2CTsKkaXSkMMP3SjOjho":1}},"type":"EnumExpression","value":"Tubes","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"M-MubYrJzPmooSjo4-JGx","logs":{"evaluations":{"RAQ0UscZm_9obkJcyjcsc":1}},"type":"IntExpression","value":2138,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"kzeTqwYBWOdPTuJx_OqUf","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"cfhNDfXEgQ6wgNOl7pkV8","logs":{"evaluations":{"CHQNlO8e8HN2LeQAvrwSZ":1}},"type":"StringExpression","value":"RST0VMMR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"AquYNRBjv7O0xAZHZe6Nh","logs":{"evaluations":{"6gUQWcK3Aqr0DIwOh0hvf":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"ZZxdp6Gobo_rjpN0HP2ik","logs":{"evaluations":{"5HJ3Ds3iu4M-62aFzKoSp":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"HV164jNWov33LrNg4JlFn","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"qvUW_UIdrJAEddU0ftPy8","logs":{"evaluations":{"wUoHwAVaTRksp2CjAq0O7":1}},"type":"StringExpression","value":"RST0HHMR","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"rd4xly3hnXcwrUsNzmoOe","logs":{"evaluations":{"wDduG-fCWNEsrYTqyxmzx":1}},"type":"EnumExpression","value":"CoffeeBox12oz","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"KAPk1xpids0Y_T-xVgaDR","logs":{"evaluations":{"x4AV1Bkr-1VJxJFOqBmsp":1}},"type":"IntExpression","value":3900,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"OuJVVrG5IBT5dHJ0vRLLS","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"i6Aq6xT8EcCH-o20M2JdI","logs":{"evaluations":{"c15c6YHmIeLZYGHS4tfOQ":1}},"type":"StringExpression","value":"RST0CEMA","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"HQjt7srVhBBj_u04Mux5C","logs":{"evaluations":{"lTdKz-DPaQFjM6uqlReid":1}},"type":"EnumExpression","value":"Tubes","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"0pHl7wDUk0-D5N4JwIGqX","logs":{"evaluations":{"n88i5WpVhyOqYvpVP9cYk":1}},"type":"IntExpression","value":2138,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"},{"id":"aWl3ff8OnL_5JD9RetT-v","logs":{},"type":"ObjectExpression","fields":{"sku":{"id":"A5S5wsSNlbynUwtZmFLwa","logs":{"evaluations":{"Yguclrg_KIHbnqzEJnljy":1}},"type":"StringExpression","value":"RST0MUIN","valueType":{"type":"StringValueType"},"isTransient":false},"productType":{"id":"q9MXsG-fi48v8BMCbW0as","logs":{"evaluations":{"HTYRixFev24uHWHH0Jdpc":1}},"type":"EnumExpression","value":"Tubes","valueType":{"type":"EnumValueType","enumTypeName":"RoastifyProductType"},"isTransient":false},"desiredWidthInPixels":{"id":"c5gkrZ8iY7oUoLVzchlef","logs":{"evaluations":{"sRd6SM0DRfjouhD-Mh41T":1}},"type":"IntExpression","value":2138,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"},"isTransient":false,"objectTypeName":"RoastifyProduct"}],"valueType":{"type":"ListValueType","itemValueType":{"type":"ObjectValueType","objectTypeName":"RoastifyProduct"}},"isTransient":false},"singleSkuBundleEnabled":{"id":"uwqWrk8_8H2qPnrfsYM8I","logs":{"evaluations":{"2NdXFOznwtl8-3qcGIczE":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"socialSignOn":{"id":"NtBfGtxkOWLO0D4xQRmna","logs":{"evaluations":{"C7ztBJad7zKMBbAcKciWL":1}},"type":"ObjectExpression","fields":{"facebook":{"id":"RCAg1vHKFatIaLIzg67HK","logs":{"evaluations":{"KMRVB3fHhZPfSC0R1gBSN":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"google":{"id":"rGU55xUflfXwMSwMx7hHi","logs":{"evaluations":{"Rw6bTdnvb3fV9f59biZj9":1}},"type":"SwitchExpression","cases":[{"id":"IOIWwmzI-_04-KpCkGJmp","when":{"a":{"id":"wqyUAg0Ux-YY4TGj-bzGx","logs":{},"type":"GetFieldExpression","object":{"id":"KpNRzXk1ZEYWuae73EDSR","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"5CkAgqOtGaoqd7lkGFiE3","logs":{},"type":"ListExpression","items":[{"id":"as5BUN3Qw-05zjAdUHaZl","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"WwAzKEQ9vlCDG1Io2u5ek","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"j05g2nR0nbIOTqwvJc7Eg","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"BXk8S_jSm3QPQcM0T-iZ8","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"rTR40qQnvbZQYX3hNcKl8","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"rPlAcQj0CFWmxXQv4THfy","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"twitter":{"id":"3NIorFZtpyniz_VhOV0Ly","logs":{"evaluations":{"dOOvtZYm2Vh0f1gTMDogM":1}},"type":"SwitchExpression","cases":[{"id":"-PH4KqsXV-2W-k9xfcNgY","when":{"a":{"id":"_YFK62fVjbhu6X65jHgSW","logs":{},"type":"GetFieldExpression","object":{"id":"mskxa-1zB2TVHmP4mY1ei","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"9c6wBqDoBUWUPL4APTiPR","logs":{},"type":"ListExpression","items":[{"id":"qFmu4F1sjGiKc0p2UTSSs","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"_aj_bRCbmDc05QGahYBaL","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"S0WYCpSUBzhGNTQTIZBf3","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"LP_YblGfIW0QFc_8CjSg_","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"nvgbTxFlrOKCUFRf40pF_","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"SocialSignOn"},"isTransient":false,"objectTypeName":"SocialSignOn"},"jetpackFbaEmails":{"id":"DBDqswAsKjasvtqmMjxKa","logs":{"evaluations":{"YG7CdeWKupnFRPHpP3zIk":1}},"type":"SwitchExpression","cases":[{"id":"WfE6hGL3No_LpcdAmjKxF","when":{"a":{"id":"saeohG-6ko1xR5yePrrdx","logs":{},"type":"GetFieldExpression","object":{"id":"iUv4CzwbV8tyHFoHw3bhu","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"IzuDF6fiIUMTx8uO1GaKw","logs":{},"type":"ListExpression","items":[{"id":"KH8Q7zEnio7s7bnb-yo7j","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"tmW4ZY4owQZJKUWSxrsiO","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"M2ErEIFaE3jpXZnpYQ16T","logs":{},"type":"ListExpression","items":[{"id":"elFIwM4l1nweAtPpwd_sI","logs":{},"type":"StringExpression","value":"ellenharrell@jetpackshipping.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"PfU13agrsp1X1ozGYLJ87","logs":{},"type":"StringExpression","value":"marlon@jetpackshipping.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"L7mi74YU8s5SiRatTue4U","logs":{},"type":"StringExpression","value":"darius@jetpackshipping.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"WOYppal7SfB-fCX8NWDMM","type":"StringExpression","value":"Brigid@jetpackshipping.com","valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false}}],"control":{"id":"ByXxc2j3ACZNJeWstEvfy","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"jOTcXJfwiHSpU99sPwQoB","logs":{},"type":"ListExpression","items":[{"id":"aP2YTQEB7E5rlOrax5e8U","logs":{},"type":"StringExpression","value":"rudolfs@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"tdm6MKli80wkAeA7pkNzH","logs":{},"type":"StringExpression","value":"alina+jetpack@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"9istrvF0nTJ4WVDSJcTVF","logs":{},"type":"StringExpression","value":"randomtest@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"newPricingSystemVideoPopupEnabled":{"id":"TbfgiiryEAgSIoFtSGMnI","logs":{"evaluations":{"mYZ8WtD5bzWrQX21BJuB_":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"fulfillmentFeeExemptProducts":{"id":"PVaJr2m-8vzywtpHC9-gP","logs":{"evaluations":{"a61DuEaxhU4s9MhUWB7fB":1}},"type":"ListExpression","items":[{"id":"IB_nGRFTG9kyBp3LVTMP7","logs":{},"type":"StringExpression","value":"6d962f10-37cc-4473-97e2-778c6f21f02a","metadata":{"note":"Alina: Exemption Testing"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"cHbcUCgsM6jzWbUa9Ypnp","logs":{},"type":"StringExpression","value":"5b88849b-9c65-4c37-9ea7-2f0ae5263b4a","metadata":{"note":"NRT3BEEP-AK"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"2e2ZJaa43qIN1F_9XWh53","logs":{},"type":"StringExpression","value":"37da2d25-bf36-4703-8ee0-437d91d19fa4","metadata":{"note":"NRT3BEEV-JM"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"i9h2lPlkTdAht8bdPy1sd","logs":{},"type":"StringExpression","value":"028947a6-3030-476e-b7ac-9db7662abaf2","metadata":{"note":"NRT0SACH-JM"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"-fyJ5JAwgkayXEWDlkbuA","logs":{},"type":"StringExpression","value":"bc4fe978-f3bb-48c4-a1b8-176098424d29","metadata":{"note":"NRT0SACH-JM"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"6iYcWabhyiwpE4Zi6HV-X","logs":{},"type":"StringExpression","value":"51023c2b-6fdd-4a37-bf2b-146a8242bef4","metadata":{"note":"NRT0SACH-JM"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"xasbDcblJsCaMcOpVtsE4","logs":{},"type":"StringExpression","value":"764b7d9b-1a82-4136-a9b3-a4f5470842d0","metadata":{"note":"ART1LI16-AK"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"tZ6ELEreSRB0xZLP4slPS","logs":{},"type":"StringExpression","value":"1cff5b0e-71d5-42cc-8881-a6638688a56f","metadata":{"note":"RLC4MULT-JK"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"s-_9ZCRKeECLVGRO8R0a7","logs":{},"type":"StringExpression","value":"d4e7992f-ecc3-47c5-8e0a-7215fa5d360a","metadata":{"note":"JTP4GUTH-IG"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"duMahO5mMUebkgLlyfVyz","logs":{},"type":"StringExpression","value":"e4f360cc-7c63-4bb9-8131-65fb271a9869","metadata":{"note":"AAV0LIBI-JM"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"I2vBj8QDGEmoopFQBjpd9","logs":{},"type":"StringExpression","value":"1964ac2e-1930-472c-8e50-19c4a6d02ee8","metadata":{"note":"TRO0TALL-MA"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"IlKQb3xmPw8QMMkhoHWfV","logs":{},"type":"StringExpression","value":"9bc523f2-139c-4ecc-af50-e6b94d7f500f","metadata":{"note":"FMN0HAIR-VG"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"Y5cSLy9RjniCmo_8b4F_q","logs":{},"type":"StringExpression","value":"81904a9b-fc9e-4eea-8b48-be6ddc77905a","metadata":{"note":"ANW0STRE"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"u4_pK0I6JAdfCqHAyJTLc","logs":{},"type":"StringExpression","value":"dfb6653e-1515-4d2b-ac2c-39f38bef7edf","metadata":{"note":"DNV0VIVO"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"ZskZGh49S3SQ6d5MxCpSR","logs":{},"type":"StringExpression","value":"529171a3-c36b-41dd-b9f8-28e0ac3b6cd5","metadata":{"note":"DNV0MUGU"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"sO6AhulA4WVIBWvO-Yn3v","logs":{},"type":"StringExpression","value":"54fbcd1d-3854-4d4e-b741-90e7fdee0c46","metadata":{"note":"Vital Gut Health 4in1: KIT OF 2"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"V5Kkw263ngbYc0N-0qKWZ","logs":{},"type":"StringExpression","value":"2beb49c7-1be8-4175-b2eb-c4253b5abced","metadata":{"note":"Vital Super Fruits & Veggies: KIT OF 2"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"4-H2e3HU4GbJV5J3yKKeQ","logs":{},"type":"StringExpression","value":"1c9eff7f-1fe9-4489-92c1-b23ffaadddc4","metadata":{"note":"Vital Gut Health 4in1: KIT OF 3"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"xltZjY9R8nNrGN-I4VxnJ","logs":{},"type":"StringExpression","value":"3b988563-1476-41c1-89c6-a06b68e3c973","metadata":{"note":"Vital Super Fruits & Veggies: KIT OF 3"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"iU4nZ4nn42MQJCHBi8GAY","logs":{},"type":"StringExpression","value":"27ff1ccf-b24c-4a8b-8250-349d5d237289","metadata":{"note":"hello@nagomi.health (Normal Blood Sugar Plus)"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"UUYfxpiH4Mqh55uMtbfYy","logs":{},"type":"StringExpression","value":"70b71172-f790-48ed-98df-098b331e6a4c","metadata":{"note":"S4W LLC"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"lmlOfslxcGAswEgs-O5K2","logs":{},"type":"StringExpression","value":"bfbc835e-855a-48d0-b94a-a5a668aefa93","metadata":{"note":"Beowulf Urban - VTL4VIHA"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"tI-U5t1_CtcjGk1w4DnoT","logs":{},"type":"StringExpression","value":"b7838b11-d24d-4690-8095-ed93fabbd1b0","metadata":{"note":"FMN0ANSE-LW"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"k0m_37YRMZI-P5WNDoXCz","type":"StringExpression","value":"cf131f03-128c-4857-9521-512cdba85abe","metadata":{"note":"Vital Joint Support: KIT OF 3"},"valueType":{"type":"StringValueType"}},{"id":"BpryrqTLoo1b7ZhJl4tF7","type":"StringExpression","value":"d2f263f8-58e6-47c6-9e5d-b2d3e2587fd3","metadata":{"note":"Vital Joint Support: KIT OF 2"},"valueType":{"type":"StringValueType"}},{"id":"rGz14ilVeaInfK1U_tUSA","type":"StringExpression","value":"c2a8d333-1411-49cc-a227-fbd88985cfbd","metadata":{"note":"After30 Hormone Rebalance™"},"valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"cnameRedirectNotificationEnabled":{"id":"OUl2tycI76i8WCWb6poSk","logs":{"evaluations":{"d0Bq5EKOToOW6fKw3_1IS":1}},"type":"SwitchExpression","cases":[{"id":"iuqInwLdhx6mycJovOYxN","when":{"a":{"id":"-lzxXylGtDrwsoiEYbV8X","logs":{},"type":"GetFieldExpression","object":{"id":"QY80TFu3muxc08fiXibxK","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"JjedzVk_PmHNh5uO-YfU3","logs":{},"type":"ListExpression","items":[{"id":"E1F_v0oIUeW_aB6SpRlgp","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"fzhCSLwNKgvO_LMjwTe4j","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"QlNU6ro4RadZbtxK8y06b","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"VTU92uUU6yKYWtE89xTC_","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"7rHt3Iz2O6oCHi_W8pHZ9","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"bulkOrdersEnabled":{"id":"P0eNHhrwTPjb0Kf7W9tDc","logs":{"evaluations":{"iSo2DL7K-u_-m0X-TkA6_":1}},"type":"SwitchExpression","cases":[{"id":"iUzGTW54uXVjmmn21kVfH","when":{"a":{"id":"BvjFpRebSxKzBZVUYpXj_","logs":{},"type":"GetFieldExpression","object":{"id":"79M79EpV2PqsfJVeL0jFF","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"wpAAr7RyfaqTL3-tWE3Uf","logs":{},"type":"ListExpression","items":[{"id":"lV_AX44hgK2bEu_lVYfsk","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"gVbCXVVLTHJ0H_YYL6EMH","logs":{},"type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"dQ_HN0NX_TsguwHQClDGn","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"b4FIznlDL7LzFXz8Rcm4n","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}},{"id":"S9dPX6EunkUum6MdsUxkI","when":{"a":{"id":"5Uyvp3gYFvFnLLuNlzlmU","logs":{},"type":"GetFieldExpression","object":{"id":"-WQ12xGght2v6dPdPVIYr","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"wdDI2sVwO-oxvuf3ctEvR","logs":{},"type":"ListExpression","items":[{"id":"0WXRc3DMzkiKdlVeMeU_W","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"s5d3tv_GefOI4OTNt1Flg","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"9-yD2z6mDWYSS7hLQ7OdO","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"5bTrrBFphXmv1UV1tcTHw","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"G8MMVjY7B3a5jQFPHibcV","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"processingFeeRate":{"id":"SI3gKBfdfA0yTmk9p1DHw","logs":{"evaluations":{"kSBajW_Y_kCUWQ13-SYrZ":1}},"type":"FloatExpression","value":0.0299,"valueType":{"type":"FloatValueType"},"isTransient":false},"fulfillmentFeeAdditionalSkuUnits":{"id":"3pA8gEffqQ1WE2pmDnkO7","logs":{"evaluations":{"AdW4KBD146WmLQd3GLvpb":1}},"type":"SwitchExpression","cases":[{"id":"TMyCcXlivAShj8kZbhIBw","when":{"a":{"id":"1ZPlTxFbGKM5D4Oqek-Yy","logs":{},"type":"GetFieldExpression","object":{"id":"b5UbN58OZGW2SkbKt0Iag","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > webUser > id","valueType":{"type":"StringValueType"},"isTransient":false},"b":{"id":"_fFPjC0g8TuHQ_QvpA1G3","logs":{},"type":"ListExpression","items":[{"id":"rtaQZGJsnMHxr7cUpAtf6","logs":{},"type":"StringExpression","value":"152b31bc-e9b8-4cca-a39c-84872627028d","metadata":{"note":"jim@jagalliance.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"SVfUARXF4-yD8LKrTIBT5","logs":{},"type":"StringExpression","value":"724cdefc-061f-40d4-9bbc-c8bce2a5f3bd","metadata":{"note":"choicemartdeals@gmail.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"yc8M6S9Uzzn8lpndvJiTu","logs":{},"type":"StringExpression","value":"ee1442be-b42c-489c-99e2-b564438c4f35","metadata":{"note":"info@arcticcollagen.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"3N5msvFzrmxSob0btRmzv","logs":{},"type":"StringExpression","value":"2df4d7a6-8583-4db1-be24-038f8600264f","metadata":{"note":"alam@protaxinsurance.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"8PQTPuzcRb88kqLM3E335","logs":{},"type":"StringExpression","value":"504c7e25-e07d-4b8a-8c61-10bb0bcafbfb","metadata":{"note":"afroze@afroze.com"},"valueType":{"type":"StringValueType"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"id":"WxhyduzRMu_LDydt1694S","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"L5raq5PMd_xvWGe0GkGAx","logs":{},"type":"FloatExpression","value":0.99,"valueType":{"type":"FloatValueType"},"isTransient":false}}],"control":{"id":"KHG5EWhn2gOtXRAkgMdyy","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"9z7m2HacvcBDHUm2QauQj","logs":{},"type":"FloatExpression","value":1.29,"valueType":{"type":"FloatValueType"},"isTransient":false},"valueType":{"type":"FloatValueType"},"isTransient":false},"fulfillmentFeeFirstSkuUnit":{"id":"WMuViTlGJzSrOkvmZ-Xj-","logs":{"evaluations":{"uZnMc_54YoHflGSjaJmxa":1}},"type":"SwitchExpression","cases":[{"id":"HPkVSkEGO6xls1PVKcfjB","when":{"a":{"id":"1Gzu31krHOIhofRLk47Ax","logs":{},"type":"GetFieldExpression","object":{"id":"LA3rMI4mwnKKSaojEAbsj","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > webUser > id","valueType":{"type":"StringValueType"},"isTransient":false},"b":{"id":"1_S54-PdweKCVgKfTzGCw","logs":{},"type":"ListExpression","items":[{"id":"1Xnov9827XJFEh3SQKj-D","logs":{},"type":"StringExpression","value":"152b31bc-e9b8-4cca-a39c-84872627028d","metadata":{"note":"jim@jagalliance.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"4bkOQ6Qz0lXJKJQ_YcWP-","logs":{},"type":"StringExpression","value":"504c7e25-e07d-4b8a-8c61-10bb0bcafbfb","metadata":{"note":"afroze@afroze.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"UWObpRJ2M3uJRzAKs9fz5","logs":{},"type":"StringExpression","value":"2df4d7a6-8583-4db1-be24-038f8600264f","metadata":{"note":"alam@protaxinsurance.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"mdT0C1tHmF8DmX_kTpNur","logs":{},"type":"StringExpression","value":"ee1442be-b42c-489c-99e2-b564438c4f35","metadata":{"note":"info@arcticcollagen.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"IayOMJU6U96wUtFarkj2R","logs":{},"type":"StringExpression","value":"724cdefc-061f-40d4-9bbc-c8bce2a5f3bd","metadata":{"note":"choicemartdeals@gmail.com"},"valueType":{"type":"StringValueType"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"id":"hYn9ff0izYly_FAa0BkZv","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"T1Z0eBnndIqpJicf6nbfv","logs":{},"type":"FloatExpression","value":1.29,"valueType":{"type":"FloatValueType"},"isTransient":false}}],"control":{"id":"nks-0IOpxAMHk-riwkqUf","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"E3GOvBxkPcy6ilcDS5cae","logs":{},"type":"FloatExpression","value":1.99,"valueType":{"type":"FloatValueType"},"isTransient":false},"valueType":{"type":"FloatValueType"},"isTransient":false},"helpArticles":{"id":"empZyFIgpTQNVsgRfmvrw","logs":{"evaluations":{"YrY5fyMGg6V7lTSJZIeaV":1}},"type":"ObjectExpression","fields":{"labelMigrateCommonIssues":{"id":"mm11O6iZb9it0Tt8X69az","type":"StringExpression","value":"https://help.supliful.com/en/articles/15501409-full-label-migration-guide#h_1c18bcdae4","valueType":{"type":"StringValueType"},"logs":{"evaluations":{"fGBVTImjlNeUPeL_sjldP":1}}},"labelMigration":{"id":"c1XQx9Uz4ja95hwImR40u","type":"StringExpression","value":"https://help.supliful.com","valueType":{"type":"StringValueType"},"logs":{"evaluations":{"0vYzDHx-qivSxPOhTbTZ_":1}}},"orderKinds":{"id":"fFu0ZbxXgyGnpK6sw9AYo","logs":{"evaluations":{"28_1O8lzaKesRztvEtPkx":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/6141709-what-s-the-difference-between-sample-manual-and-bulk-orders","valueType":{"type":"StringValueType"},"isTransient":false},"sampleDiscount":{"id":"V9ef8zkrZYA1Ivj2Sg9DJ","logs":{"evaluations":{"TeSR_9Rp_LHR5L1TTIBV8":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/6141709-what-s-the-difference-between-sample-manual-and-bulk-orders#h_9e1e027491","valueType":{"type":"StringValueType"},"isTransient":false},"createGeneralLabel":{"id":"Kr4qyD8yqZOAAXSgfUIu7","logs":{"evaluations":{"eT0-tDNxnCuV-Ph7fvbrC":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/5579874-customizing-your-first-label","valueType":{"type":"StringValueType"},"isTransient":false},"createRoastifyLabels":{"id":"1Q7V9F_N5zR2i-AnX85Uw","logs":{"evaluations":{"mNxow7Og2uIyAhzNz5t8T":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/12352668-step-by-step-guide-to-creating-coffee-product-labels","metadata":{"note":"Alina: please update the link when it's ready"},"valueType":{"type":"StringValueType"},"isTransient":false},"shippingCost":{"id":"yfBj4iAP29RQp3TaFXWSx","logs":{"evaluations":{"ULHbZYKY12wst8YKJUMNK":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/6721922-shipping-prices","valueType":{"type":"StringValueType"},"isTransient":false},"productCost":{"id":"zarjX8uLEv_icaa_egI1f","logs":{"evaluations":{"1LH70zq6PYhwNzPe82qZM":1}},"type":"StringExpression","value":"https://help.supliful.com/en/collections/13496997-product-price-tiers","valueType":{"type":"StringValueType"},"isTransient":false},"processingFee":{"id":"LyXCWgZj-dfAlmvWzPm-4","logs":{"evaluations":{"ZtmBDZWLqwwPEmzub9rv7":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/11549933-what-is-a-processing-fee","valueType":{"type":"StringValueType"},"isTransient":false},"fulfillmentFee":{"id":"CyM9zXGKpeuSCHBPg02MR","logs":{"evaluations":{"oiZ08fAxXsZM_G6mIEb5w":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/11628956-what-is-a-fulfillment-fee","valueType":{"type":"StringValueType"},"isTransient":false},"tieredPricing":{"id":"WzVwFyxFeRumbqMMkA8UT","logs":{"evaluations":{"mm16jssZeEcYMBrSaGCiY":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/11588477-understanding-supliful-s-product-price-tiers","valueType":{"type":"StringValueType"},"isTransient":false},"storeAlreadyConnected":{"id":"ndeCH7u0q4NpbtFOxsA4r","logs":{"evaluations":{"UpoEc61sZ6sRo_F7ivhTS":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/10852402-cannot-connect-a-store-to-my-account","valueType":{"type":"StringValueType"},"isTransient":false},"setUserStoreShippingRates":{"id":"MjvJJaIs9uC44v8Lno2Fz","logs":{"evaluations":{"DHpCimMec1T-iEr8a5JbL":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/12800804-how-to-set-up-shipping-rates","valueType":{"type":"StringValueType"},"isTransient":false},"returns":{"id":"8Q4l8injrWZ6cArRdf0l3","logs":{"evaluations":{"1AWPkw9qtwBvUHWjuZAsw":1}},"type":"StringExpression","value":"https://help.supliful.com/en/articles/5415148-return-refund-replacement-policy","valueType":{"type":"StringValueType"},"isTransient":false},"shipping":{"id":"RQ6JShPdND92wHszV07R5","logs":{"evaluations":{"-7s8Vy4lteLD8s1OmcfyM":1}},"type":"StringExpression","value":"https://help.supliful.com/en/collections/3045345-shipping/","valueType":{"type":"StringValueType"},"isTransient":false}},"metadata":{"permissions":{"user":{},"group":{}}},"valueType":{"type":"ObjectValueType","objectTypeName":"HelpArticles"},"isTransient":false,"objectTypeName":"HelpArticles"},"newPricingSystemEnabled":{"id":"dZkzNOm0Dn7Or18uuYQer","logs":{"evaluations":{"IdZtcc30ZSNTKGlSudWJb":1}},"type":"SwitchExpression","cases":[{"id":"YnWlE7ILgr_uQz5ngwMGR","when":{"a":{"id":"iHKTBboBN4G2FaXQsedsh","logs":{},"type":"GetFieldExpression","object":{"id":"JjnvJMxktNLl2HS5EGTM-","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"GNdErZl0izv5iiVSLF02I","logs":{},"type":"ListExpression","items":[{"id":"w_I2AxPlmHVh2PxKShoNX","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"EG3dSCXUNcTZIdEN0Sf3P","logs":{},"type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"1xoNakQINOUSg2SwH-ERS","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"EzfCzSQ_JUOCUmNUcwvAd","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"cOgv47WFmjU8sF8FSmURT","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"hA1qml6_Ga-Ey7By2zyqL","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"cecT0oSCW5IpnjLpnFQqm","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"orderProcessingStatusItemCountThreshold":{"id":"SGbZwsAMMVJXJ4EjcMAzA","logs":{"evaluations":{"F2EeBeJUEQ3_zghIhzm_J":1}},"type":"IntExpression","value":25,"valueType":{"type":"IntValueType"},"isTransient":false},"partnerProductStockSnapshotEnabled":{"id":"OtZ0s_ms3Rx8puREmSo9S","logs":{"evaluations":{"F_D52An2ehBnjZPBbr6Yu":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"shouldApplyExpressShippingSampleOrder":{"id":"ffXUCFLgSN54RmYG2qdK-","logs":{"evaluations":{"Vw-F0Rc-XlcSecpsCCkhP":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"fulfillmentDeadlines":{"id":"e9HyrsqCjMaWjkEHYg63j","logs":{"evaluations":{"03Bif8Lqbj6S64qaZWXcD":1}},"type":"ObjectExpression","fields":{"fbaDays":{"id":"6gMkSd6L8Quax4GSIfsip","logs":{"evaluations":{"wgyNU0KA6tG5NyfTK7QCN":1}},"type":"IntExpression","value":5,"valueType":{"type":"IntValueType"},"isTransient":false},"priorityDays":{"id":"2o31TiraojtYVCDptpFuE","logs":{"evaluations":{"Xw8HiuG8cvTpKEu0qcDdZ":1}},"type":"IntExpression","value":1,"valueType":{"type":"IntValueType"},"isTransient":false},"sampleDays":{"id":"kj6APmWDaZzM9per1e4cc","logs":{"evaluations":{"9rH19Sl3BMTkuZ4nAdNwO":1}},"type":"IntExpression","value":2,"valueType":{"type":"IntValueType"},"isTransient":false},"defaultDays":{"id":"P-wwNTfirh0oyQq6KtA0h","logs":{"evaluations":{"btBHd4dg7cgEiwxH4wjR-":1}},"type":"IntExpression","value":3,"valueType":{"type":"IntValueType"},"isTransient":false},"prelabeledDays":{"id":"rzH-a7FrJwcB9ZFIOqt1L","logs":{"evaluations":{"I-ac6yfF6PAMQGdebTPVD":1}},"type":"IntExpression","value":2,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"FulfillmentDeadlines"},"isTransient":false,"objectTypeName":"FulfillmentDeadlines"},"paymentDeadlines":{"id":"B0QJqv2ARzt64VulCvf5J","logs":{"evaluations":{"Rcolv5XzDqin9FfdKY7VA":1}},"type":"ObjectExpression","fields":{"prePaymentDays":{"id":"RsXjwG8DPf749tmbt2uIn","logs":{"evaluations":{"FIyLGpMZsXKTQ1_NkMx4L":1}},"type":"IntExpression","value":30,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"PaymentDeadlines"},"isTransient":false,"objectTypeName":"PaymentDeadlines"},"postOrderCreationFeedbackIntervalSeconds":{"id":"2lWCIU45X6-ixayc3YLZb","logs":{"evaluations":{"ebpMs_oerqYZiNrl0kzYq":1}},"type":"IntExpression","value":2592000,"valueType":{"type":"IntValueType"},"isTransient":false},"cronJobs":{"id":"GNs3gOgDw8okHyG0KSdd7","logs":{"evaluations":{"iTDReJZjS-UEuySgEEuCK":1}},"type":"ObjectExpression","fields":{"runClickFunnelsOrderImportCron":{"id":"B2TP2qclpXrOxTqTgjJ-a","logs":{"evaluations":{"PkoDpu6ihssMsMPmBx5-N":1}},"type":"SwitchExpression","cases":[{"id":"61dAIbelvEgJ6TqIivirD","when":{"a":{"id":"iCgJvujf3a4eUwjqKh7J3","logs":{},"type":"GetFieldExpression","object":{"id":"m4obtrDJT6JMRBjQxvSq2","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"YvLhRndHuFs6t5g5aYXOI","logs":{},"type":"ListExpression","items":[{"id":"0VgkSni0gWAO6d7rvQFu0","logs":{},"type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"gPknunTb6mcCe2duACs1W","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"aC0dpEILCkYr9O2dbHlpG","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"kny0gQLHpwPyZ26D1NThs","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"15w3_ZM0F7IH_mzz62RLs","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"-Wsn76wxJ34i0B46uT61Z","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"runOrderInvoiceGenerationCron":{"id":"_mYY2Q_jsLKbJhra9alEp","logs":{"evaluations":{"oRDbw04Mot5tyZRT2NMkK":1}},"type":"SwitchExpression","cases":[{"id":"SQMRCh720nc3jkXgbyLVI","when":{"a":{"id":"gAAl0Yaz96CcYjGpJkfhU","logs":{},"type":"GetFieldExpression","object":{"id":"Y_CU5g-J11U6la5_sEU6P","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"Z5BP8-f-BrEz2FqzHA8RW","logs":{},"type":"ListExpression","items":[{"id":"5SkchN13I_XrkfLQFuYW-","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"BI_f1QloFqzOuBa6j2UyO","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"PAcpuhC1Kpwvn7zoj1LOc","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"KpKfCG1_o97vscDhhz6zy","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"a6r_uI-MYkgIzhglIdLeh","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"runShopifyFulfillmentCheckCron":{"id":"e25bOLBqarngEheBNwA3M","logs":{"evaluations":{"TZzfGJj-mRpihy1__WI5N":1}},"type":"SwitchExpression","cases":[{"id":"uJK4pxXprmFkFhoOjgegH","when":{"a":{"id":"1UG8Kucx1WqGL6Xc4pj-B","logs":{},"type":"GetFieldExpression","object":{"id":"4oWEu3UY1wJA2l2J_pa8_","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"3XdoKwBkjcU9evnq3fm8p","logs":{},"type":"ListExpression","items":[{"id":"xeNW8iF91itURkMjkyffd","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"sFGypU8CgRBoDwpM3nGyg","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"dqea8S54dguev4uRvxL3G","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"ATFibTVBh7SqRBJsJH2t0","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"97WukK8sy_zGEpoh_sYv0","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"FLLMKxnEE4S8HqvHTo6q3","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"runShopifyStoreWebhookCheckCron":{"id":"G1hZx-TlPgmTb74YqfiAC","logs":{"evaluations":{"LFPXDGVV6H0tPxhXXtruM":1}},"type":"SwitchExpression","cases":[{"id":"rhsaCwLTOYz3QL3vb8QHy","when":{"a":{"id":"AmW6jI4d-yfd12-LpLSyE","logs":{},"type":"GetFieldExpression","object":{"id":"Swko595z51a4B1HgxXB80","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"gpCTTEx6k-rJ7iM8xN1Px","logs":{},"type":"ListExpression","items":[{"id":"AQrR3s6VVXIcHLeKeUCZ3","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"DPoRBwY11A78miyyZIbNP","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"FiwTtu6lLPoPnsVPZOIK9","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"V2fu_0xggf9txsXJ5dsOZ","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"YXQvhJ-sXuLx4a6I9_jSq","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"notionFbaProducts":{"id":"kAa86EO7MHlwYhZ_FoDiq","logs":{"evaluations":{"P9WL7a4DiFpWl-ZmKmBIZ":1}},"type":"ObjectExpression","fields":{"enabled":{"id":"Efr23Poh3hbHqIhiNSRW3","logs":{"evaluations":{"neYfylKIgqnSud544Un9C":1}},"type":"SwitchExpression","cases":[{"id":"uV0QO-YiTPQS4BGvTU0oZ","when":{"a":{"id":"oQSJEJsDozFSZmJTqe_t0","logs":{},"type":"GetFieldExpression","object":{"id":"NFnzeOn3PQm0Ud12BzVVP","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"xzTFT0X_bQEBFI7uwph_4","logs":{},"type":"ListExpression","items":[{"id":"BRAbOQhNJGbmumwx_Ertk","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"hiiKB1MD_fc8JeYOXLHr8","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"e4BOBogR3KYw-MXFcJKYi","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"V_ok-VndJhXZig78-vIOs","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"-FnSecAQgUO4sHlR5B7hd","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"U2vWsXjJdBumS89uFJoSa","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"schedule":{"id":"Ii1h8IXNnnSfwFX98mc2v","logs":{"evaluations":{"l9XLSiWDGgAP10BVI6kqF":1}},"type":"StringExpression","value":"0 * * * *","valueType":{"type":"StringValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"RunNotionFbaProductsCron"},"isTransient":false,"objectTypeName":"RunNotionFbaProductsCron"},"postPaymentBuckets":{"id":"aIfQ6O6nYDVTqhn3nToj5","logs":{"evaluations":{"cLoYXA9wtDwcLmc9TpvYd":1}},"type":"ObjectExpression","fields":{"paymentEmailRemindersEnabled":{"id":"1sA1KtkaweQM7RiSfmuSV","logs":{"evaluations":{"rGQwi2knBvxOxNtgLMyiQ":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"PostPaymentBucketsCron"},"isTransient":false,"objectTypeName":"PostPaymentBucketsCron"},"runExpireOldUserCreditsCron":{"id":"rKotghnzyZk_v2dobZWJH","logs":{"evaluations":{"hYkotNKofwcuY6lCITId5":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"runClickFunnelsStoreWebhookCheckCron":{"id":"xYpQ3bZs1thcs_sEtqOiI","logs":{"evaluations":{"kUHA9J8hTmRxlRFQ8Zc1I":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"runShipheroAccessTokenCheckCron":{"id":"vygUmHO6G4H0W2t8qqjZh","type":"SwitchExpression","cases":[{"id":"xU6yTVqlRYbRQn8qSr2dW","when":{"a":{"id":"hZk2MW2I0vYz2Ru-tvwKw","type":"GetFieldExpression","object":{"id":"Cl1JECWEDr9Y2jUkBBM9O","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"iL8iBd4xV6_FqvDwMuQeB","type":"ListExpression","items":[{"id":"g4fn-FtwMZGZbfuK-whBk","type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},{"id":"9QgAr_-rtnjH00Gjreg1V","type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"fpX-6wejXsY-g8v2ueVKX","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"3vZfBb1Qy3zGKHaSXqAuP","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}}}],"control":{"id":"HFyW9RQtnyr85jE5lXJhf","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"}},"default":{"id":"D3xt8k7vTDGQH2C5KL61y","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"}},"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"iuNRnOobu7D2BaVCtF8hM":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"CronJobs"},"isTransient":false,"objectTypeName":"CronJobs"},"postOrderCreationFeedbackEnabled":{"id":"3Wq79aP0E5yRoIAo9PS70","logs":{"evaluations":{"Gy9a22V_XuExuT0niAqL6":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"orderFormFeedbackEnabled":{"id":"ltQ0Z791wiT3ZS4iqWGNe","logs":{"evaluations":{"k780gFFu1ZgqJ_cGWWH8l":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"prepaidPriceEnabled":{"id":"qSthS7Z0CF7uIXnDJ8PE3","logs":{"evaluations":{"Gdl-tHlSblfjqPKlHL3Bn":1}},"type":"SwitchExpression","cases":[{"id":"js2uYCFv68mSgksdsymXk","when":{"a":{"id":"pBPMUEzlhy4Ev0dCLg8Nk","logs":{},"type":"GetFieldExpression","object":{"id":"bAKlUdbgbFeanRjCP9nJD","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"W0zcDZZ68mN_saM9s-bxR","logs":{},"type":"ListExpression","items":[{"id":"hQgdsTOMxFCwC0NpP1Gn1","logs":{},"type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"-4_eO2EsGzCmqtBITqbVz","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"YClPwDlOh3F54PZxvp_2H","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"3GwOiZc8lm4U0WREi6G9Y","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"HWR02pdglE2oe8axW8wx6","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"pzVYVC55-eKlnkIQZWw3t","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"easypostEelPfcEnabled":{"id":"-jbaqzLZW_DKpD0-Le-lg","logs":{"evaluations":{"zbaAoNwIa74-BuWLMsvJy":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"onboardingSurveyEnabled":{"id":"ej_cADjAAMvmIu47x_yup","logs":{"evaluations":{"UlEg_kjHm9Cbm3vIIohwI":1}},"type":"SwitchExpression","cases":[{"id":"Grf9T2Ov7aE4DiozZFY4W","when":{"a":{"a":{"id":"hfmtjMi6ey5IinvuInrjP","logs":{},"type":"GetFieldExpression","object":{"id":"-JUu002Jgps8LaINAdhrk","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"qUpTB_hVOpQsG0_bS5uQj","logs":{},"type":"ListExpression","items":[{"id":"jEhA9zOwgVy7uj9z0ly0A","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"CTGr7rwAn209VvXc9oibV","logs":{},"type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"a1M1kXwtJh62bSbR9fAOp","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"b":{"a":{"id":"IiwCQ0MPqzc1_W10ys8PV","logs":{},"type":"GetFieldExpression","object":{"id":"W3WMsPqJqlv2gNC9lhQz-","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > webUser > email","valueType":{"type":"StringValueType"},"isTransient":false},"b":{"id":"h0D1LmmjBxoDH9HF16daE","logs":{},"type":"StringExpression","value":"test@yahoo.com","valueType":{"type":"StringValueType"},"isTransient":false},"id":"3dotCJJz0Ujazld3Ayi11","logs":{},"type":"ComparisonExpression","operator":"endsWith","valueType":{"type":"BooleanValueType"},"isTransient":false},"id":"x2f-uWTIdqOsKFMkibIji","logs":{},"type":"ComparisonExpression","operator":"AND","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"uuLOijkW533PamEQbvhUM","logs":{},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false}}],"control":{"id":"LwoVatXYn8VPkRLt_wn-b","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"qEHHdUEVaS7UMX91RZU0s","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"valueType":{"type":"BooleanValueType"},"isTransient":false},"acceptOrderDelayMinutes":{"id":"qXDFhi3u5oRUrGXqaOY74","logs":{"evaluations":{"U-Lf4IBfFG0ed8fub4wDi":1}},"type":"SwitchExpression","cases":[{"id":"kh9D7XoVgKYZUvepFUr7Q","when":{"a":{"id":"z1yJZHBL5DvEOSb-lc8tF","logs":{},"type":"GetFieldExpression","object":{"id":"BQGTwb9CCADv_KkmzbD7H","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"jtA26q3h96hRzn2axiyLu","logs":{},"type":"ListExpression","items":[{"id":"LAGn4bpDLFeZcpJFyopkh","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"Cn5hCXkyGj7UN6RGeaOy9","logs":{},"type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"wO4WwtcjpXcdoozbVT8FX","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"vb98PCbeT36gxjwLh6tLT","logs":{},"type":"IntExpression","value":1,"valueType":{"type":"IntValueType"},"isTransient":false}},{"id":"0K3zx4AaeKykCEbDoxLqv","when":{"a":{"id":"Lrdx287Flj6FQmnYniHS-","logs":{},"type":"GetFieldExpression","object":{"id":"EI98nM4Apsg42OQKQsl6J","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"ejxqhvpW9bNY2Ab-SUAb-","logs":{},"type":"ListExpression","items":[{"id":"nkst__mDPLWEdu8HN04GB","logs":{},"type":"EnumExpression","value":"production","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"m4TMyjWiSiCpeYZHJLVLD","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"faFg9V8DBxrgLOrZy0-oO","logs":{},"type":"IntExpression","value":120,"valueType":{"type":"IntValueType"},"isTransient":false}}],"control":{"id":"XNT9D_w38ymYaZYj_9iZ9","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"eCEQ9irEsS-pjvCPKJuwB","logs":{},"type":"IntExpression","value":120,"valueType":{"type":"IntValueType"},"isTransient":false},"valueType":{"type":"IntValueType"},"isTransient":false},"orderTypeMinimumQuantities":{"id":"BSBmT5JWjU94ZwE0hM8pM","logs":{"evaluations":{"Y1nUKdeDgXfGf4PMmTTV_":1}},"type":"ObjectExpression","fields":{"minManualQuantity":{"id":"uDxZ6Qeav_Sf42d_hpz9o","logs":{"evaluations":{"f4-D1JtPrRLFtsJd3fWyL":1}},"type":"IntExpression","value":1,"valueType":{"type":"IntValueType"},"isTransient":false},"minSampleQuantity":{"id":"WMv5vTNpdiXgChuesZ4W7","logs":{"evaluations":{"0nDFBkvaaeUrqtJEHQkiN":1}},"type":"IntExpression","value":1,"valueType":{"type":"IntValueType"},"isTransient":false},"minFbaQuantity":{"id":"5Tr7C-32NQoBRfVPh-W8h","logs":{"evaluations":{"LeUTgGdZOLgtc82XBY5j8":1}},"type":"IntExpression","value":1,"valueType":{"type":"IntValueType"},"isTransient":false},"minBulkQuantity":{"id":"t8ZYBJr80Fy8JT1liY35Y","logs":{"evaluations":{"h2xTo4qJnzCiJOtZCIFa_":1}},"type":"IntExpression","value":100,"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"OrderTypeMinimumQuantities"},"isTransient":false,"objectTypeName":"OrderTypeMinimumQuantities"},"user":{"id":"Yz8IS5Hc3cp2Oqkq0w-Gd","logs":{"evaluations":{"jJBHARvsrURu_SDP3Qy9J":1}},"type":"ObjectExpression","fields":{"userMinimumPricingTier":{"id":"9YjuC8xihB0EZ-cHAsiDV","logs":{"evaluations":{"BIvyFmsqhlpt3JBOJOseN":1}},"type":"SwitchExpression","cases":[{"id":"Gc0I4EpIs6L7N2qcg1Akg","when":{"a":{"id":"sH9Bmx7gtkhobeRZFndS0","logs":{},"type":"GetFieldExpression","object":{"id":"iScUWbRz3zuPRbbsl1NWj","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > webUser > id","valueType":{"type":"StringValueType"},"isTransient":false},"b":{"id":"pYVQoLCRpnbcyScz3h_xc","logs":{},"type":"ListExpression","items":[{"id":"vd79tFgxv6eiRi1V13xKO","logs":{},"type":"StringExpression","value":"2c249272-bdb6-4ba1-83b0-7fcd361b244e","metadata":{"note":"rudolfs@supliful.com-staging"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"PrRgYw2PDjjI6TVm7YLye","logs":{},"type":"StringExpression","value":"a79359fd-9c71-47c8-abd5-a341b5ee550e","metadata":{"note":"alina@supliful.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"a3E8tHe_kRbmh_x2XcWkG","logs":{},"type":"StringExpression","value":"152b31bc-e9b8-4cca-a39c-84872627028d","metadata":{"note":"jim@jagalliance.com"},"valueType":{"type":"StringValueType"},"isTransient":false}],"metadata":{"note":""},"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"id":"R0-jBEZ0CvGRgzzpVBW_B","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"qXoUZUfI39JCK_xrL0tdk","logs":{},"type":"IntExpression","value":5,"valueType":{"type":"IntValueType"},"isTransient":false}},{"id":"KTAyKajxs5cm9qrBkKEQg","when":{"a":{"id":"YaHIDZSIxMLVPjXhj15_J","logs":{},"type":"GetFieldExpression","object":{"id":"tEIO3vgDrXNabom5eh93E","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > webUser > id","valueType":{"type":"StringValueType"},"isTransient":false},"b":{"id":"3SSquWoiLCuuxRqGaRqOY","logs":{},"type":"ListExpression","items":[{"id":"RcRPqdp0BmSxKzZM6eeUH","logs":{},"type":"StringExpression","value":"945febe1-4d0f-4b08-9e4d-88ecf786a943","metadata":{"note":"peteris.varpins@gmail.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"y0ovjdijE4ANB0dm0CsjF","type":"StringExpression","value":"39df246b-0586-47b6-80a1-a15e45bf05c1","metadata":{"note":"rudolfs@supliful.com"},"valueType":{"type":"StringValueType"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"id":"Xn389BG75aNw_sW3dLLv_","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"ISDOvt7EsJI_6oYwqKRes","logs":{},"type":"IntExpression","value":11,"valueType":{"type":"IntValueType"},"isTransient":false}},{"id":"oE3u1BiCm9eubSsxRjJrM","when":{"a":{"id":"9CG172xxpAxM8rGJuBuAf","logs":{},"type":"GetFieldExpression","object":{"id":"qvh9jsnYC4lguNzztGzWf","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > webUser > id","valueType":{"type":"StringValueType"},"isTransient":false},"b":{"id":"_QOu9sxmVWnagIl7FiGiq","logs":{},"type":"ListExpression","items":[{"id":"VKjBd2OqQvrKNUHOaurNK","logs":{},"type":"StringExpression","value":"56f93aab-c3c6-4c8d-83df-e6a0bb160dd7","metadata":{"note":"fabfpeixoto@gmail.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"6gfFm7thTREseu1KpnPjT","logs":{},"type":"StringExpression","value":"eef3ef7b-a26b-45a1-bff5-893bee683c48","metadata":{"note":"Sulejman Murati"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"lMA1J0xWB79afUbFBKCyd","logs":{},"type":"StringExpression","value":"724cdefc-061f-40d4-9bbc-c8bce2a5f3bd","metadata":{"note":"choicemartdeals@gmail.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"p-lT31qDdAbCCHCSRr16j","logs":{},"type":"StringExpression","value":"ee1442be-b42c-489c-99e2-b564438c4f35","metadata":{"note":"info@arcticcollagen.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"DdQwiA829SX_Vx_n6TSZW","logs":{},"type":"StringExpression","value":"2df4d7a6-8583-4db1-be24-038f8600264f","metadata":{"note":"alam@protaxinsurance.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"0L8zI78Z4W9k9ZXCQAVeF","logs":{},"type":"StringExpression","value":"504c7e25-e07d-4b8a-8c61-10bb0bcafbfb","metadata":{"note":"afroze@afroze.com"},"valueType":{"type":"StringValueType"},"isTransient":false},{"id":"pLfeq4Ijvw3FDVM4INNiq","logs":{},"type":"StringExpression","value":"42611247-6eb3-4040-a9dd-8c48ad8aed46","metadata":{"note":"nelson-yeung"},"valueType":{"type":"StringValueType"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"id":"_qDwALxh3hXRY6u7jrsDS","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"CuWlYczVga34l7pT8bGsQ","logs":{},"type":"IntExpression","value":6,"valueType":{"type":"IntValueType"},"isTransient":false}},{"id":"v_mFE4v6fbeKn4BY8BGfk","when":{"a":{"id":"YgmUosmGf46_Ky5nVakMq","logs":{},"type":"GetFieldExpression","object":{"id":"ULveR1YcLa562WHrY-ilH","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > webUser > id","valueType":{"type":"StringValueType"},"isTransient":false},"b":{"id":"qucqV8T3Sk4YdBDsnDcnX","logs":{},"type":"ListExpression","items":[{"id":"EnYJZBbp4HD19gdfDRJhO","logs":{},"type":"StringExpression","value":"e0e6d165-62ab-4ea2-9280-149cbb269873","metadata":{"note":"drtruong@truongrehab.com"},"valueType":{"type":"StringValueType"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"id":"Q3KkbNGeCPFgtQg4UI7f-","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"_58-Evc0qG2Rhj-INBmak","logs":{},"type":"IntExpression","value":7,"valueType":{"type":"IntValueType"},"isTransient":false}},{"id":"jVIEVKrcpFskMsJfUdCel","when":{"a":{"id":"NnmzOnRBZqWUrA9M1KXdl","logs":{},"type":"GetFieldExpression","object":{"id":"dj95fFexlQgI-6DQnpjP9","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > webUser > id","valueType":{"type":"StringValueType"},"isTransient":false},"b":{"id":"_ii-ZhIDxEmKJNVk3Ovao","logs":{},"type":"ListExpression","items":[{"id":"Kj9gxGGQvW_OoOwNlgD36","logs":{},"type":"StringExpression","value":"60f28eaf-208d-4504-b738-8488334e89e2","metadata":{"note":"amaad-habibovic-1"},"valueType":{"type":"StringValueType"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"id":"CzcWbiTNWNsIM7n3YqikR","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"oHrXPQkZB5A4UEjP_oE8a","logs":{},"type":"IntExpression","value":8,"valueType":{"type":"IntValueType"},"isTransient":false}}],"control":{"id":"hbd_7ZPXtnRJZBCv6cWBJ","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"HeD_R1-gb9iMeX-cHBTxr","logs":{},"type":"IntExpression","value":0,"valueType":{"type":"IntValueType"},"isTransient":false},"valueType":{"type":"IntValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"User"},"isTransient":false,"objectTypeName":"User"},"devMailBypassList":{"id":"ClKmqn6OAyEQ8HyorcZpm","logs":{"evaluations":{"2FN4wL9TheBfOrMS1hfFt":1}},"type":"ListExpression","items":[{"id":"un6JQNG2g9zM-lonMeudY","logs":{},"type":"StringExpression","value":"namike.baiba@gmail.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"o0WmShvCuBEi_5DcajWSo","logs":{},"type":"StringExpression","value":"alina@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"xMO-DH4W-MpPxesBxwqmX","logs":{},"type":"StringExpression","value":"beerzina.baiba@gmail.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"TgJ_UJ4Tv_oOXfEWvA_Ph","logs":{},"type":"StringExpression","value":"alina+ftt@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"tvVAE_ul-R9X_Ft34PtsF","logs":{},"type":"StringExpression","value":"kristaps.leperis@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"qCd-Cz-aiGLiLGWGTg2QR","logs":{},"type":"StringExpression","value":"alina+hubspot@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"upsvJO04dtIbDjDApr2QW","logs":{},"type":"StringExpression","value":"alina+hbt@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"BjUtfIw_WMLTbhyFHDhHr","logs":{},"type":"StringExpression","value":"alina+hbtt@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"aWqBo-AFDwmzUKbpTRZB9","logs":{},"type":"StringExpression","value":"alina+111@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"tZDhyehR2GpgIiDTuhRwG","logs":{},"type":"StringExpression","value":"alina+222@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"-DCnpYgHmmEYpZCLb8MGa","logs":{},"type":"StringExpression","value":"rudolfs@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"FDknHyjMQyagomIdbv3Gk","logs":{},"type":"StringExpression","value":"alina+333@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"JwfiJ9f9FPh4Gb8mqpK5Z","logs":{},"type":"StringExpression","value":"alina+jetpack@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"yQmmKqee7zg-s2L95vYcy","logs":{},"type":"StringExpression","value":"randomtest@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"fEJ8OAO1xFjj17u3B__ZL","logs":{},"type":"StringExpression","value":"linards.bulks@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"jbZtT6DOIcx7Sv0g_G4Hn","logs":{},"type":"StringExpression","value":"linards.bulks+1@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"YNyjjDRe7ROd3zzL1v8pn","logs":{},"type":"StringExpression","value":"rudolfs+shopifytest@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"IBJ9Vq1MnlhAT2iOmCVjs","logs":{},"type":"StringExpression","value":"rudolfs+t@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"HasOUvTR-aQZR_biwkuxo","logs":{},"type":"StringExpression","value":"alina+mmb@supliful.com","valueType":{"type":"StringValueType"},"isTransient":false},{"id":"59XXoS3P4wqqMKHCdkpHy","type":"StringExpression","value":"alina+mns@supliful.com","valueType":{"type":"StringValueType"}},{"id":"grCKCQWpYhlzdzBbBITuY","type":"StringExpression","value":"alina+apr2@supliful.com","valueType":{"type":"StringValueType"}},{"id":"S8QavOIcjmvE4o_qXM24Z","type":"StringExpression","value":"alina+ot1@supliful.com","valueType":{"type":"StringValueType"}}],"metadata":{"note":"Email"},"valueType":{"type":"ListValueType","itemValueType":{"type":"StringValueType"}},"isTransient":false},"aiProductBuilder":{"id":"ZJJSlr9LeZiBYlfuJeVxV","logs":{"evaluations":{"32j36pcSJdmmNH-Ut10lj":1}},"type":"ObjectExpression","fields":{"isEnabled":{"id":"LSZHUx7l09yTtrPCR99xt","logs":{"evaluations":{"4klopew5Jl2_hOwd-8DUj":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false},"appURL":{"id":"vL3Ao5I0VFMM67W25bC3z","logs":{"evaluations":{"NOHpA8xVKHBTwuy5GAHz3":1}},"type":"StringExpression","value":"https://create.supliful.com/","valueType":{"type":"StringValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"AIProductBuilder"},"isTransient":false,"objectTypeName":"AIProductBuilder"},"membershipsEnabled":{"id":"N3lcLzUHB1nkhbUHBYTIi","type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"clEY1dJSn6v949R0uoQZe":1}}},"sgtm":{"id":"GC7YWJonWQ-rfu3y8lu2v","logs":{"evaluations":{"SVvabbWyYketvvb2r2eZS":1}},"type":"SwitchExpression","cases":[{"id":"MIIksco2YoKslfT7zB4y8","when":{"a":{"id":"9zAdSoWnDbD5ANHmKBuzf","logs":{},"type":"GetFieldExpression","object":{"id":"o5WH6YSXpImghw1np_0CT","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"OQclYi0vE58zzoD5QJGmZ","logs":{},"type":"ListExpression","items":[{"id":"H69Y0FtmFIUL7J_eDhpy0","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"ycSSMMbnFuJlc8GYT69dG","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"6lkW2ooxKKxCnuuShk9CX","logs":{},"type":"ObjectExpression","fields":{"hubspotDirectEventsEnabled":{"id":"3sD6Rx1wDVx2kdI60et5Q","logs":{"evaluations":{"BUBwWd7QkFgXAFqZ0z6eG":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"SGTM"},"isTransient":false,"objectTypeName":"SGTM"}},{"id":"vVx5eLpMLM8zc7I7fVoTf","when":{"a":{"id":"Bq-MNAZ7XQFZL_r0sfrfI","type":"GetFieldExpression","object":{"id":"2S6VQ1cN3FDHR7Yixk3Fl","type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE"},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"b":{"id":"dR9_zol8LGceTvkGlM5o1","type":"ListExpression","items":[{"id":"dC-NN1LJocoPQKbtG1JtB","type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"}}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}}},"id":"LyMjnBbIuFBqF-XVLJDw-","type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"}},"then":{"id":"w29gF7r3HCNsThQQRoBQR","type":"ObjectExpression","fields":{"hubspotDirectEventsEnabled":{"id":"UHrSVNcF3M8X4fLepYIPx","type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"logs":{"evaluations":{"kaqHzX1Ai1_qjHRWOEQu7":1}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"SGTM"},"objectTypeName":"SGTM"}}],"control":{"id":"fFyFQidaItEimHs92TebC","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"LmLBQW1XBmmSfkXlXszeG","logs":{},"type":"ObjectExpression","fields":{"hubspotDirectEventsEnabled":{"id":"nXFyQTx9jo66sQRYd7E3B","logs":{"evaluations":{"4R6a_h58RErVnoAiwsh3t":1}},"type":"BooleanExpression","value":false,"valueType":{"type":"BooleanValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"SGTM"},"isTransient":false,"objectTypeName":"SGTM"},"valueType":{"type":"ObjectValueType","objectTypeName":"SGTM"},"isTransient":false},"onboarding":{"id":"heKrepDRZhxRSQIrJ9zUi","logs":{"evaluations":{"bWk6kRr6xpfLS8BfrloZS":1}},"type":"SwitchExpression","cases":[{"id":"CFrgvngftavXQaMKWdeM8","when":{"a":{"id":"lCGc60B9hra95TCmc_HsK","logs":{},"type":"GetFieldExpression","object":{"id":"HiFtVLzfNw5GeVFwyfZNR","logs":{},"type":"VariableExpression","valueType":{"type":"ObjectValueType","objectTypeName":"Query_root_args"},"variableId":"hKX4pu-uMNsbD4TRZFWQE","isTransient":false},"fieldPath":"context > environment","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},"b":{"id":"R9HwBHgjSUJBU3NC4li3L","logs":{},"type":"ListExpression","items":[{"id":"5pWHC_JdoGuW3S_W8TfDc","logs":{},"type":"EnumExpression","value":"staging","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false},{"id":"KfYIMjGDptElUnKyQlp25","logs":{},"type":"EnumExpression","value":"development","valueType":{"type":"EnumValueType","enumTypeName":"Environment"},"isTransient":false}],"valueType":{"type":"ListValueType","itemValueType":{"type":"EnumValueType","enumTypeName":"Environment"}},"isTransient":false},"id":"qRMKgjKpAl17D2m5Fb6tZ","logs":{},"type":"ComparisonExpression","operator":"in","valueType":{"type":"BooleanValueType"},"isTransient":false},"then":{"id":"QOtPIElvAK65hT29pO4KS","logs":{},"type":"ObjectExpression","fields":{"surveyEnabled":{"id":"MFm-fOfjZHV3szUJ4Ev-o","logs":{"evaluations":{"e9gKnRSZH0HsNq9ee5SBx":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"surveyEnabledSince":{"id":"Mh9xleHp4V2yfOI4UfKTl","logs":{"evaluations":{"-uf-ui6Q6Yl5k3sLc5JUu":1}},"type":"StringExpression","value":"2026-02-26T07:30:00.000Z","valueType":{"type":"StringValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"Onboarding"},"isTransient":false,"objectTypeName":"Onboarding"}}],"control":{"id":"rWP3Qs4nkY8GJw6tsTQ2T","logs":{},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"default":{"id":"EhuJZ4AbUVi0XenoXm0Fx","logs":{},"type":"ObjectExpression","fields":{"surveyEnabled":{"id":"OcMky1vSzMT04QBTXO8PX","logs":{"evaluations":{"aGCYxbXUwzL-58g1y99Ub":1}},"type":"BooleanExpression","value":true,"valueType":{"type":"BooleanValueType"},"isTransient":false},"surveyEnabledSince":{"id":"2Bkd-J9JKp7G_vubZgaHr","logs":{"evaluations":{"qEceFLwGFxii152qqxJq_":1}},"type":"StringExpression","value":"2026-03-03T11:20:00.000Z","valueType":{"type":"StringValueType"},"isTransient":false}},"valueType":{"type":"ObjectValueType","objectTypeName":"Onboarding"},"isTransient":false,"objectTypeName":"Onboarding"},"valueType":{"type":"ObjectValueType","objectTypeName":"Onboarding"},"isTransient":false}},"metadata":{"permissions":{"user":{},"group":{}}},"valueType":{"type":"ObjectValueType","objectTypeName":"Root"},"isTransient":false,"objectTypeName":"Root"},"logs":{},"type":"FunctionExpression","valueType":{"type":"FunctionValueType","returnValueType":{"type":"ObjectValueType","objectTypeName":"Root"},"parameterValueTypes":[{"type":"ObjectValueType","objectTypeName":"Query_root_args"}]},"parameters":[{"id":"hKX4pu-uMNsbD4TRZFWQE","name":"rootArgs"}],"isTransient":false}},"metadata":{"permissions":{"user":{},"group":{"team":{"write":"allow"}}}},"valueType":{"type":"ObjectValueType","objectTypeName":"Query"},"isTransient":false,"objectTypeName":"Query"},"splits":{},"commitConfig":{"splitConfig":{}}}


export const vercelFlagDefinitions = {"customersCanvasMockupPipeline":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcustomersCanvasMockupPipeline"},"manualMockupRegenerationEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EmanualMockupRegenerationEnabled"},"labelTransition.autoupgraderDisabledTooltip":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition%3EautoupgraderDisabledTooltip"},"labelTransition.autoupgraderDisabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition%3EautoupgraderDisabled"},"labelTransition.showLabelMigrationStatus":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition%3EshowLabelMigrationStatus"},"labelTransition.showLabelTransitionBanner":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition%3EshowLabelTransitionBanner"},"labelTransition.migrationDeadline":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition%3EmigrationDeadline"},"labelUpgradePurchase.autoUpgradeTermsLink":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase%3EautoUpgradeTermsLink"},"labelUpgradePurchase.subscriberFreeUpgradesCount":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase%3EsubscriberFreeUpgradesCount"},"labelUpgradePurchase.priceId":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase%3EpriceId"},"labelUpgradePurchase.priceCents":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase%3EpriceCents"},"labelUpgradePurchase.freeCouponId":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase%3EfreeCouponId"},"shopify.useREST4InventoryActivation":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshopify%3EuseREST4InventoryActivation"},"shopify.shopifyShippingRatesSetupAppEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshopify%3EshopifyShippingRatesSetupAppEnabled"},"payments.suplifulCreditsTopupEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epayments%3EsuplifulCreditsTopupEnabled"},"payments.suplifulTokensEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epayments%3EsuplifulTokensEnabled"},"adminGenerateMockupsFromLabelV1Enabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EadminGenerateMockupsFromLabelV1Enabled"},"adminLabelTransitionsPageEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EadminLabelTransitionsPageEnabled"},"adminGenericLabelPreviewEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EadminGenericLabelPreviewEnabled"},"labelSettings.dpi":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelSettings%3Edpi"},"labelSettings.width":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelSettings%3Ewidth"},"labelSettings.height":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelSettings%3Eheight"},"labelSettings.borderWidth":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelSettings%3EborderWidth"},"polotno.unsplashEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epolotno%3EunsplashEnabled"},"polotno.templatesEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epolotno%3EtemplatesEnabled"},"polotno.useNewLabelForFulfillment":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epolotno%3EuseNewLabelForFulfillment"},"polotno.enabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epolotno%3Eenabled"},"shipments.shipmentInsuranceThreshold":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshipments%3EshipmentInsuranceThreshold"},"shipments.easypostEelPfcEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshipments%3EeasypostEelPfcEnabled"},"shiphero.productLotTrackingEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EproductLotTrackingEnabled"},"shiphero.orderTag":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EorderTag"},"shiphero.userProductTag":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EuserProductTag"},"shiphero.userProductSyncEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EuserProductSyncEnabled"},"shiphero.warehouseSyncEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EwarehouseSyncEnabled"},"shiphero.catalogSyncEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EcatalogSyncEnabled"},"regenerateMockupsOnSubscribe":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EregenerateMockupsOnSubscribe"},"hubspot.testing":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Ehubspot%3Etesting"},"tikTok.discontinued":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtikTok%3Ediscontinued"},"tikTok.orderCutoffTimestamp":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtikTok%3EorderCutoffTimestamp"},"canPublishToTiktok":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcanPublishToTiktok"},"canConnectTiktokStore":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcanConnectTiktokStore"},"tiktokSellerShipping.enabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtiktokSellerShipping%3Eenabled"},"tiktokShipping.enabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtiktokShipping%3Eenabled"},"magicLinkWithOTP":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EmagicLinkWithOTP"},"metaConversionsAPI.testEventCode":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EmetaConversionsAPI%3EtestEventCode"},"blackFridayPromoIsEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EblackFridayPromoIsEnabled"},"clickFunnels.clickFunnelsStoreCardURL":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EclickFunnels%3EclickFunnelsStoreCardURL"},"clickFunnelsAllowTestOrdersInProduction":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EclickFunnelsAllowTestOrdersInProduction"},"useAsyncGtmSignupCallbacks":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EuseAsyncGtmSignupCallbacks"},"sampleDiscountValidDate":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsampleDiscountValidDate"},"clickFunnelsIsEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EclickFunnelsIsEnabled"},"extendedCatalogIsEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EextendedCatalogIsEnabled"},"roastifyProduct3DPreviewReportIssueEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EroastifyProduct3DPreviewReportIssueEnabled"},"stripeInvoicing.sampleDiscountPercent":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EsampleDiscountPercent"},"stripeInvoicing.shippingFee":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EshippingFee"},"stripeInvoicing.sampleDiscountId":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EsampleDiscountId"},"stripeInvoicing.enabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3Eenabled"},"stripeInvoicing.firstItemFulfillmentFee":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EfirstItemFulfillmentFee"},"stripeInvoicing.additionalItemFulfillmentFee":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EadditionalItemFulfillmentFee"},"stripeInvoicing.processingFee":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EprocessingFee"},"subscriptionItems.enabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsubscriptionItems%3Eenabled"},"subscriptionItems.brandedCustomerSupportPriceId":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsubscriptionItems%3EbrandedCustomerSupportPriceId"},"singleSkuBundleEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsingleSkuBundleEnabled"},"socialSignOn.facebook":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsocialSignOn%3Efacebook"},"socialSignOn.google":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsocialSignOn%3Egoogle"},"socialSignOn.twitter":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsocialSignOn%3Etwitter"},"newPricingSystemVideoPopupEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EnewPricingSystemVideoPopupEnabled"},"cnameRedirectNotificationEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcnameRedirectNotificationEnabled"},"bulkOrdersEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EbulkOrdersEnabled"},"processingFeeRate":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EprocessingFeeRate"},"fulfillmentFeeAdditionalSkuUnits":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentFeeAdditionalSkuUnits"},"fulfillmentFeeFirstSkuUnit":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentFeeFirstSkuUnit"},"helpArticles.labelMigrateCommonIssues":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3ElabelMigrateCommonIssues"},"helpArticles.labelMigration":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3ElabelMigration"},"helpArticles.orderKinds":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EorderKinds"},"helpArticles.sampleDiscount":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EsampleDiscount"},"helpArticles.createGeneralLabel":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EcreateGeneralLabel"},"helpArticles.createRoastifyLabels":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EcreateRoastifyLabels"},"helpArticles.shippingCost":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EshippingCost"},"helpArticles.productCost":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EproductCost"},"helpArticles.processingFee":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EprocessingFee"},"helpArticles.fulfillmentFee":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EfulfillmentFee"},"helpArticles.tieredPricing":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EtieredPricing"},"helpArticles.storeAlreadyConnected":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EstoreAlreadyConnected"},"helpArticles.setUserStoreShippingRates":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EsetUserStoreShippingRates"},"helpArticles.returns":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3Ereturns"},"helpArticles.shipping":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3Eshipping"},"newPricingSystemEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EnewPricingSystemEnabled"},"orderProcessingStatusItemCountThreshold":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderProcessingStatusItemCountThreshold","description":"Defines the number of products in a line item that requires processing before fulfillment."},"partnerProductStockSnapshotEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EpartnerProductStockSnapshotEnabled"},"shouldApplyExpressShippingSampleOrder":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EshouldApplyExpressShippingSampleOrder"},"fulfillmentDeadlines.fbaDays":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines%3EfbaDays"},"fulfillmentDeadlines.priorityDays":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines%3EpriorityDays"},"fulfillmentDeadlines.sampleDays":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines%3EsampleDays"},"fulfillmentDeadlines.defaultDays":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines%3EdefaultDays"},"fulfillmentDeadlines.prelabeledDays":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines%3EprelabeledDays"},"paymentDeadlines.prePaymentDays":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EpaymentDeadlines%3EprePaymentDays"},"postOrderCreationFeedbackIntervalSeconds":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EpostOrderCreationFeedbackIntervalSeconds"},"cronJobs.runClickFunnelsOrderImportCron":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunClickFunnelsOrderImportCron"},"cronJobs.runOrderInvoiceGenerationCron":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunOrderInvoiceGenerationCron"},"cronJobs.runShopifyFulfillmentCheckCron":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunShopifyFulfillmentCheckCron"},"cronJobs.runShopifyStoreWebhookCheckCron":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunShopifyStoreWebhookCheckCron"},"cronJobs.notionFbaProducts.enabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3EnotionFbaProducts%3Eenabled"},"cronJobs.notionFbaProducts.schedule":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3EnotionFbaProducts%3Eschedule"},"cronJobs.postPaymentBuckets.paymentEmailRemindersEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3EpostPaymentBuckets%3EpaymentEmailRemindersEnabled","description":"Controls whether the app should send email reminders to customer about unpaid post-payment bucket invoices."},"cronJobs.runExpireOldUserCreditsCron":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunExpireOldUserCreditsCron"},"cronJobs.runClickFunnelsStoreWebhookCheckCron":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunClickFunnelsStoreWebhookCheckCron"},"cronJobs.runShipheroAccessTokenCheckCron":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunShipheroAccessTokenCheckCron"},"postOrderCreationFeedbackEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EpostOrderCreationFeedbackEnabled","description":"Asks for feedback after creating order with new order form. Depends on new order form being enabled."},"orderFormFeedbackEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderFormFeedbackEnabled","description":"Asks for feedback in new order form. Depends on new order form being enabled."},"prepaidPriceEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EprepaidPriceEnabled"},"easypostEelPfcEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EeasypostEelPfcEnabled"},"onboardingSurveyEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EonboardingSurveyEnabled","description":"Enables the onboarding survey displayed to newly registered users"},"acceptOrderDelayMinutes":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EacceptOrderDelayMinutes"},"orderTypeMinimumQuantities.minManualQuantity":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderTypeMinimumQuantities%3EminManualQuantity"},"orderTypeMinimumQuantities.minSampleQuantity":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderTypeMinimumQuantities%3EminSampleQuantity"},"orderTypeMinimumQuantities.minFbaQuantity":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderTypeMinimumQuantities%3EminFbaQuantity"},"orderTypeMinimumQuantities.minBulkQuantity":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderTypeMinimumQuantities%3EminBulkQuantity"},"user.userMinimumPricingTier":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Euser%3EuserMinimumPricingTier"},"aiProductBuilder.isEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EaiProductBuilder%3EisEnabled"},"aiProductBuilder.appURL":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EaiProductBuilder%3EappURL"},"membershipsEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EmembershipsEnabled"},"sgtm.hubspotDirectEventsEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Esgtm%3EhubspotDirectEventsEnabled"},"onboarding.surveyEnabled":{"options":[{"label":"Off","value":false},{"label":"On","value":true}],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eonboarding%3EsurveyEnabled"},"onboarding.surveyEnabledSince":{"options":[],"origin":"https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eonboarding%3EsurveyEnabledSince"}};

export type FlagValues = {
  "customersCanvasMockupPipeline": boolean;
  "manualMockupRegenerationEnabled": boolean;
  "labelTransition.autoupgraderDisabledTooltip": string;
  "labelTransition.autoupgraderDisabled": boolean;
  "labelTransition.showLabelMigrationStatus": boolean;
  "labelTransition.showLabelTransitionBanner": boolean;
  "labelTransition.migrationDeadline": string;
  "labelUpgradePurchase.autoUpgradeTermsLink": string;
  "labelUpgradePurchase.subscriberFreeUpgradesCount": number;
  "labelUpgradePurchase.priceId": string;
  "labelUpgradePurchase.priceCents": number;
  "labelUpgradePurchase.freeCouponId": string;
  "shopify.useREST4InventoryActivation": boolean;
  "shopify.shopifyShippingRatesSetupAppEnabled": boolean;
  "payments.suplifulCreditsTopupEnabled": boolean;
  "payments.suplifulTokensEnabled": boolean;
  "adminGenerateMockupsFromLabelV1Enabled": boolean;
  "adminLabelTransitionsPageEnabled": boolean;
  "adminGenericLabelPreviewEnabled": boolean;
  "labelSettings.dpi": number;
  "labelSettings.width": number;
  "labelSettings.height": number;
  "labelSettings.borderWidth": number;
  "polotno.unsplashEnabled": boolean;
  "polotno.templatesEnabled": boolean;
  "polotno.useNewLabelForFulfillment": boolean;
  "polotno.enabled": boolean;
  "shipments.shipmentInsuranceThreshold": number;
  "shipments.easypostEelPfcEnabled": boolean;
  "shiphero.productLotTrackingEnabled": boolean;
  "shiphero.orderTag": string;
  "shiphero.userProductTag": string;
  "shiphero.userProductSyncEnabled": boolean;
  "shiphero.warehouseSyncEnabled": boolean;
  "shiphero.catalogSyncEnabled": boolean;
  "regenerateMockupsOnSubscribe": boolean;
  "hubspot.testing": boolean;
  "tikTok.discontinued": boolean;
  "tikTok.orderCutoffTimestamp": number;
  "canPublishToTiktok": boolean;
  "canConnectTiktokStore": boolean;
  "tiktokSellerShipping.enabled": boolean;
  "tiktokShipping.enabled": boolean;
  "magicLinkWithOTP": boolean;
  "metaConversionsAPI.testEventCode": string;
  "blackFridayPromoIsEnabled": boolean;
  "clickFunnels.clickFunnelsStoreCardURL": string;
  "clickFunnelsAllowTestOrdersInProduction": boolean;
  "useAsyncGtmSignupCallbacks": boolean;
  "sampleDiscountValidDate": string;
  "clickFunnelsIsEnabled": boolean;
  "extendedCatalogIsEnabled": boolean;
  "roastifyProduct3DPreviewReportIssueEnabled": boolean;
  "stripeInvoicing.sampleDiscountPercent": number;
  "stripeInvoicing.shippingFee": string;
  "stripeInvoicing.sampleDiscountId": string;
  "stripeInvoicing.enabled": boolean;
  "stripeInvoicing.firstItemFulfillmentFee": string;
  "stripeInvoicing.additionalItemFulfillmentFee": string;
  "stripeInvoicing.processingFee": string;
  "subscriptionItems.enabled": boolean;
  "subscriptionItems.brandedCustomerSupportPriceId": string;
  "singleSkuBundleEnabled": boolean;
  "socialSignOn.facebook": boolean;
  "socialSignOn.google": boolean;
  "socialSignOn.twitter": boolean;
  "newPricingSystemVideoPopupEnabled": boolean;
  "cnameRedirectNotificationEnabled": boolean;
  "bulkOrdersEnabled": boolean;
  "processingFeeRate": number;
  "fulfillmentFeeAdditionalSkuUnits": number;
  "fulfillmentFeeFirstSkuUnit": number;
  "helpArticles.labelMigrateCommonIssues": string;
  "helpArticles.labelMigration": string;
  "helpArticles.orderKinds": string;
  "helpArticles.sampleDiscount": string;
  "helpArticles.createGeneralLabel": string;
  "helpArticles.createRoastifyLabels": string;
  "helpArticles.shippingCost": string;
  "helpArticles.productCost": string;
  "helpArticles.processingFee": string;
  "helpArticles.fulfillmentFee": string;
  "helpArticles.tieredPricing": string;
  "helpArticles.storeAlreadyConnected": string;
  "helpArticles.setUserStoreShippingRates": string;
  "helpArticles.returns": string;
  "helpArticles.shipping": string;
  "newPricingSystemEnabled": boolean;
  "orderProcessingStatusItemCountThreshold": number;
  "partnerProductStockSnapshotEnabled": boolean;
  "shouldApplyExpressShippingSampleOrder": boolean;
  "fulfillmentDeadlines.fbaDays": number;
  "fulfillmentDeadlines.priorityDays": number;
  "fulfillmentDeadlines.sampleDays": number;
  "fulfillmentDeadlines.defaultDays": number;
  "fulfillmentDeadlines.prelabeledDays": number;
  "paymentDeadlines.prePaymentDays": number;
  "postOrderCreationFeedbackIntervalSeconds": number;
  "cronJobs.runClickFunnelsOrderImportCron": boolean;
  "cronJobs.runOrderInvoiceGenerationCron": boolean;
  "cronJobs.runShopifyFulfillmentCheckCron": boolean;
  "cronJobs.runShopifyStoreWebhookCheckCron": boolean;
  "cronJobs.notionFbaProducts.enabled": boolean;
  "cronJobs.notionFbaProducts.schedule": string;
  "cronJobs.postPaymentBuckets.paymentEmailRemindersEnabled": boolean;
  "cronJobs.runExpireOldUserCreditsCron": boolean;
  "cronJobs.runClickFunnelsStoreWebhookCheckCron": boolean;
  "cronJobs.runShipheroAccessTokenCheckCron": boolean;
  "postOrderCreationFeedbackEnabled": boolean;
  "orderFormFeedbackEnabled": boolean;
  "prepaidPriceEnabled": boolean;
  "easypostEelPfcEnabled": boolean;
  "onboardingSurveyEnabled": boolean;
  "acceptOrderDelayMinutes": number;
  "orderTypeMinimumQuantities.minManualQuantity": number;
  "orderTypeMinimumQuantities.minSampleQuantity": number;
  "orderTypeMinimumQuantities.minFbaQuantity": number;
  "orderTypeMinimumQuantities.minBulkQuantity": number;
  "user.userMinimumPricingTier": number;
  "aiProductBuilder.isEnabled": boolean;
  "aiProductBuilder.appURL": string;
  "membershipsEnabled": boolean;
  "sgtm.hubspotDirectEventsEnabled": boolean;
  "onboarding.surveyEnabled": boolean;
  "onboarding.surveyEnabledSince": string;
}

export type FlagPath = keyof FlagValues & string;

export const flagFallbacks: FlagValues = {
  "customersCanvasMockupPipeline": false,
  "manualMockupRegenerationEnabled": false,
  "labelTransition.autoupgraderDisabledTooltip": "",
  "labelTransition.autoupgraderDisabled": false,
  "labelTransition.showLabelMigrationStatus": false,
  "labelTransition.showLabelTransitionBanner": false,
  "labelTransition.migrationDeadline": "",
  "labelUpgradePurchase.autoUpgradeTermsLink": "",
  "labelUpgradePurchase.subscriberFreeUpgradesCount": 0,
  "labelUpgradePurchase.priceId": "",
  "labelUpgradePurchase.priceCents": 0,
  "labelUpgradePurchase.freeCouponId": "",
  "shopify.useREST4InventoryActivation": false,
  "shopify.shopifyShippingRatesSetupAppEnabled": false,
  "payments.suplifulCreditsTopupEnabled": false,
  "payments.suplifulTokensEnabled": false,
  "adminGenerateMockupsFromLabelV1Enabled": false,
  "adminLabelTransitionsPageEnabled": false,
  "adminGenericLabelPreviewEnabled": false,
  "labelSettings.dpi": 0,
  "labelSettings.width": 0,
  "labelSettings.height": 0,
  "labelSettings.borderWidth": 0,
  "polotno.unsplashEnabled": false,
  "polotno.templatesEnabled": false,
  "polotno.useNewLabelForFulfillment": false,
  "polotno.enabled": false,
  "shipments.shipmentInsuranceThreshold": 0,
  "shipments.easypostEelPfcEnabled": false,
  "shiphero.productLotTrackingEnabled": false,
  "shiphero.orderTag": "",
  "shiphero.userProductTag": "",
  "shiphero.userProductSyncEnabled": false,
  "shiphero.warehouseSyncEnabled": false,
  "shiphero.catalogSyncEnabled": false,
  "regenerateMockupsOnSubscribe": false,
  "hubspot.testing": false,
  "tikTok.discontinued": false,
  "tikTok.orderCutoffTimestamp": 0,
  "canPublishToTiktok": false,
  "canConnectTiktokStore": false,
  "tiktokSellerShipping.enabled": false,
  "tiktokShipping.enabled": false,
  "magicLinkWithOTP": false,
  "metaConversionsAPI.testEventCode": "",
  "blackFridayPromoIsEnabled": false,
  "clickFunnels.clickFunnelsStoreCardURL": "",
  "clickFunnelsAllowTestOrdersInProduction": false,
  "useAsyncGtmSignupCallbacks": false,
  "sampleDiscountValidDate": "",
  "clickFunnelsIsEnabled": false,
  "extendedCatalogIsEnabled": false,
  "roastifyProduct3DPreviewReportIssueEnabled": false,
  "stripeInvoicing.sampleDiscountPercent": 0,
  "stripeInvoicing.shippingFee": "",
  "stripeInvoicing.sampleDiscountId": "",
  "stripeInvoicing.enabled": false,
  "stripeInvoicing.firstItemFulfillmentFee": "",
  "stripeInvoicing.additionalItemFulfillmentFee": "",
  "stripeInvoicing.processingFee": "",
  "subscriptionItems.enabled": false,
  "subscriptionItems.brandedCustomerSupportPriceId": "",
  "singleSkuBundleEnabled": false,
  "socialSignOn.facebook": false,
  "socialSignOn.google": false,
  "socialSignOn.twitter": false,
  "newPricingSystemVideoPopupEnabled": false,
  "cnameRedirectNotificationEnabled": false,
  "bulkOrdersEnabled": false,
  "processingFeeRate": 0,
  "fulfillmentFeeAdditionalSkuUnits": 0,
  "fulfillmentFeeFirstSkuUnit": 0,
  "helpArticles.labelMigrateCommonIssues": "",
  "helpArticles.labelMigration": "",
  "helpArticles.orderKinds": "",
  "helpArticles.sampleDiscount": "",
  "helpArticles.createGeneralLabel": "",
  "helpArticles.createRoastifyLabels": "",
  "helpArticles.shippingCost": "",
  "helpArticles.productCost": "",
  "helpArticles.processingFee": "",
  "helpArticles.fulfillmentFee": "",
  "helpArticles.tieredPricing": "",
  "helpArticles.storeAlreadyConnected": "",
  "helpArticles.setUserStoreShippingRates": "",
  "helpArticles.returns": "",
  "helpArticles.shipping": "",
  "newPricingSystemEnabled": false,
  "orderProcessingStatusItemCountThreshold": 0,
  "partnerProductStockSnapshotEnabled": false,
  "shouldApplyExpressShippingSampleOrder": false,
  "fulfillmentDeadlines.fbaDays": 0,
  "fulfillmentDeadlines.priorityDays": 0,
  "fulfillmentDeadlines.sampleDays": 0,
  "fulfillmentDeadlines.defaultDays": 0,
  "fulfillmentDeadlines.prelabeledDays": 0,
  "paymentDeadlines.prePaymentDays": 0,
  "postOrderCreationFeedbackIntervalSeconds": 0,
  "cronJobs.runClickFunnelsOrderImportCron": false,
  "cronJobs.runOrderInvoiceGenerationCron": false,
  "cronJobs.runShopifyFulfillmentCheckCron": false,
  "cronJobs.runShopifyStoreWebhookCheckCron": false,
  "cronJobs.notionFbaProducts.enabled": false,
  "cronJobs.notionFbaProducts.schedule": "",
  "cronJobs.postPaymentBuckets.paymentEmailRemindersEnabled": false,
  "cronJobs.runExpireOldUserCreditsCron": false,
  "cronJobs.runClickFunnelsStoreWebhookCheckCron": false,
  "cronJobs.runShipheroAccessTokenCheckCron": false,
  "postOrderCreationFeedbackEnabled": false,
  "orderFormFeedbackEnabled": false,
  "prepaidPriceEnabled": false,
  "easypostEelPfcEnabled": false,
  "onboardingSurveyEnabled": false,
  "acceptOrderDelayMinutes": 0,
  "orderTypeMinimumQuantities.minManualQuantity": 0,
  "orderTypeMinimumQuantities.minSampleQuantity": 0,
  "orderTypeMinimumQuantities.minFbaQuantity": 0,
  "orderTypeMinimumQuantities.minBulkQuantity": 0,
  "user.userMinimumPricingTier": 0,
  "aiProductBuilder.isEnabled": false,
  "aiProductBuilder.appURL": "",
  "membershipsEnabled": false,
  "sgtm.hubspotDirectEventsEnabled": false,
  "onboarding.surveyEnabled": false,
  "onboarding.surveyEnabledSince": "",
}

export function decodeFlagValues<TFlagPath extends keyof FlagValues & string>(
  encodedFlagValues: string,
  flagPaths: TFlagPath[]
): Pick<FlagValues, TFlagPath> {
  return sdk.decodeFlagValues({ encodedFlagValues, flagPaths })
}

export type VariableValues = {};

export type WebUser = {
  id: string;
  email: string;
}

export type AdminUser = {
  id: string;
  email: string;
}

export const EnvironmentEnumValues = [
  "production",
  "staging",
  "development"
] as const;
export type Environment = typeof EnvironmentEnumValues[number];

/**
 * This `Context` input type is used for the `context` argument on your root field.
 * It contains details of the current `user` and `environment`.
 * 
 * You can define other custom input types with fields that are primitives, enums 
 * or other input types.
 */
export type Context = {
  webUser: WebUser;
  adminUser: AdminUser;
  environment: Environment;
  /**
   * Allows to toggle feature flags only on specific Remote Development Env
   */
  rdeID: string;
}

export type RootArgs = {
  context: Context;
}

export type EmptyObject = {};

export type LabelTransition = {
  autoupgraderDisabledTooltip: string;
  autoupgraderDisabled: boolean;
  showLabelMigrationStatus: boolean;
  showLabelTransitionBanner: boolean;
  migrationDeadline: string;
}

const labelTransitionFallback = {autoupgraderDisabledTooltip:"",autoupgraderDisabled:false,showLabelMigrationStatus:false,showLabelTransitionBanner:false,migrationDeadline:""};

export class LabelTransitionNode extends sdk.Node {
  override typeName = "LabelTransition" as const;

  get({ fallback = labelTransitionFallback as LabelTransition}: { fallback?: LabelTransition } = {}): LabelTransition {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "labelTransition"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as LabelTransition;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition%3EautoupgraderDisabledTooltip})
   */
  autoupgraderDisabledTooltip({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("autoupgraderDisabledTooltip", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition%3EautoupgraderDisabled})
   */
  autoupgraderDisabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("autoupgraderDisabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition%3EshowLabelMigrationStatus})
   */
  showLabelMigrationStatus({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("showLabelMigrationStatus", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition%3EshowLabelTransitionBanner})
   */
  showLabelTransitionBanner({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("showLabelTransitionBanner", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition%3EmigrationDeadline})
   */
  migrationDeadline({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("migrationDeadline", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type LabelUpgradePurchase = {
  autoUpgradeTermsLink: string;
  subscriberFreeUpgradesCount: number;
  priceId: string;
  priceCents: number;
  freeCouponId: string;
}

const labelUpgradePurchaseFallback = {autoUpgradeTermsLink:"",subscriberFreeUpgradesCount:0,priceId:"",priceCents:0,freeCouponId:""};

export class LabelUpgradePurchaseNode extends sdk.Node {
  override typeName = "LabelUpgradePurchase" as const;

  get({ fallback = labelUpgradePurchaseFallback as LabelUpgradePurchase}: { fallback?: LabelUpgradePurchase } = {}): LabelUpgradePurchase {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "labelUpgradePurchase"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as LabelUpgradePurchase;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase%3EautoUpgradeTermsLink})
   */
  autoUpgradeTermsLink({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("autoUpgradeTermsLink", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase%3EsubscriberFreeUpgradesCount})
   */
  subscriberFreeUpgradesCount({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("subscriberFreeUpgradesCount", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase%3EpriceId})
   */
  priceId({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("priceId", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase%3EpriceCents})
   */
  priceCents({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("priceCents", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase%3EfreeCouponId})
   */
  freeCouponId({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("freeCouponId", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type Shopify = {
  useREST4InventoryActivation: boolean;
  shopifyShippingRatesSetupAppEnabled: boolean;
}

const shopifyFallback = {useREST4InventoryActivation:false,shopifyShippingRatesSetupAppEnabled:false};

export class ShopifyNode extends sdk.Node {
  override typeName = "Shopify" as const;

  get({ fallback = shopifyFallback as Shopify}: { fallback?: Shopify } = {}): Shopify {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "shopify"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as Shopify;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshopify%3EuseREST4InventoryActivation})
   */
  useREST4InventoryActivation({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("useREST4InventoryActivation", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshopify%3EshopifyShippingRatesSetupAppEnabled})
   */
  shopifyShippingRatesSetupAppEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("shopifyShippingRatesSetupAppEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type Payments = {
  suplifulCreditsTopupEnabled: boolean;
  suplifulTokensEnabled: boolean;
}

const paymentsFallback = {suplifulCreditsTopupEnabled:false,suplifulTokensEnabled:false};

export class PaymentsNode extends sdk.Node {
  override typeName = "Payments" as const;

  get({ fallback = paymentsFallback as Payments}: { fallback?: Payments } = {}): Payments {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "payments"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as Payments;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epayments%3EsuplifulCreditsTopupEnabled})
   */
  suplifulCreditsTopupEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("suplifulCreditsTopupEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epayments%3EsuplifulTokensEnabled})
   */
  suplifulTokensEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("suplifulTokensEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type LabelSettings = {
  dpi: number;
  width: number;
  height: number;
  borderWidth: number;
}

const labelSettingsFallback = {dpi:0,width:0,height:0,borderWidth:0};

export class LabelSettingsNode extends sdk.Node {
  override typeName = "LabelSettings" as const;

  get({ fallback = labelSettingsFallback as LabelSettings}: { fallback?: LabelSettings } = {}): LabelSettings {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "labelSettings"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as LabelSettings;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelSettings%3Edpi})
   */
  dpi({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("dpi", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelSettings%3Ewidth})
   */
  width({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("width", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      (expression0.type === "IntExpression" ||
      expression0.type === "FloatExpression")
    ) {
      const node = new sdk.FloatNode(props0);
      return node.get({ fallback });
    }
    const node = new sdk.FloatNode(props0);
    node._logUnexpectedTypeError();
    return fallback;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelSettings%3Eheight})
   */
  height({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("height", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      (expression0.type === "IntExpression" ||
      expression0.type === "FloatExpression")
    ) {
      const node = new sdk.FloatNode(props0);
      return node.get({ fallback });
    }
    const node = new sdk.FloatNode(props0);
    node._logUnexpectedTypeError();
    return fallback;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelSettings%3EborderWidth})
   */
  borderWidth({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("borderWidth", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      (expression0.type === "IntExpression" ||
      expression0.type === "FloatExpression")
    ) {
      const node = new sdk.FloatNode(props0);
      return node.get({ fallback });
    }
    const node = new sdk.FloatNode(props0);
    node._logUnexpectedTypeError();
    return fallback;
  }
}

export type Polotno = {
  unsplashEnabled: boolean;
  templatesEnabled: boolean;
  useNewLabelForFulfillment: boolean;
  enabled: boolean;
}

const polotnoFallback = {unsplashEnabled:false,templatesEnabled:false,useNewLabelForFulfillment:false,enabled:false};

export class PolotnoNode extends sdk.Node {
  override typeName = "Polotno" as const;

  get({ fallback = polotnoFallback as Polotno}: { fallback?: Polotno } = {}): Polotno {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "polotno"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as Polotno;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epolotno%3EunsplashEnabled})
   */
  unsplashEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("unsplashEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epolotno%3EtemplatesEnabled})
   */
  templatesEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("templatesEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epolotno%3EuseNewLabelForFulfillment})
   */
  useNewLabelForFulfillment({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("useNewLabelForFulfillment", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epolotno%3Eenabled})
   */
  enabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("enabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type Shipments = {
  shipmentInsuranceThreshold: number;
  easypostEelPfcEnabled: boolean;
}

const shipmentsFallback = {shipmentInsuranceThreshold:0,easypostEelPfcEnabled:false};

export class ShipmentsNode extends sdk.Node {
  override typeName = "Shipments" as const;

  get({ fallback = shipmentsFallback as Shipments}: { fallback?: Shipments } = {}): Shipments {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "shipments"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as Shipments;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshipments%3EshipmentInsuranceThreshold})
   */
  shipmentInsuranceThreshold({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("shipmentInsuranceThreshold", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      (expression0.type === "IntExpression" ||
      expression0.type === "FloatExpression")
    ) {
      const node = new sdk.FloatNode(props0);
      return node.get({ fallback });
    }
    const node = new sdk.FloatNode(props0);
    node._logUnexpectedTypeError();
    return fallback;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshipments%3EeasypostEelPfcEnabled})
   */
  easypostEelPfcEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("easypostEelPfcEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type Shiphero = {
  productLotTrackingEnabled: boolean;
  orderTag: string;
  userProductTag: string;
  userProductSyncEnabled: boolean;
  warehouseSyncEnabled: boolean;
  catalogSyncEnabled: boolean;
}

const shipheroFallback = {productLotTrackingEnabled:false,orderTag:"",userProductTag:"",userProductSyncEnabled:false,warehouseSyncEnabled:false,catalogSyncEnabled:false};

export class ShipheroNode extends sdk.Node {
  override typeName = "Shiphero" as const;

  get({ fallback = shipheroFallback as Shiphero}: { fallback?: Shiphero } = {}): Shiphero {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "shiphero"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as Shiphero;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EproductLotTrackingEnabled})
   */
  productLotTrackingEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("productLotTrackingEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EorderTag})
   */
  orderTag({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("orderTag", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EuserProductTag})
   */
  userProductTag({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("userProductTag", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EuserProductSyncEnabled})
   */
  userProductSyncEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("userProductSyncEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EwarehouseSyncEnabled})
   */
  warehouseSyncEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("warehouseSyncEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero%3EcatalogSyncEnabled})
   */
  catalogSyncEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("catalogSyncEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type Hubspot = {
  testing: boolean;
}

const hubspotFallback = {testing:false};

export class HubspotNode extends sdk.Node {
  override typeName = "Hubspot" as const;

  get({ fallback = hubspotFallback as Hubspot}: { fallback?: Hubspot } = {}): Hubspot {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "hubspot"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as Hubspot;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Ehubspot%3Etesting})
   */
  testing({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("testing", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type TikTok = {
  discontinued: boolean;
  orderCutoffTimestamp: number;
}

const tikTokFallback = {discontinued:false,orderCutoffTimestamp:0};

export class TikTokNode extends sdk.Node {
  override typeName = "TikTok" as const;

  get({ fallback = tikTokFallback as TikTok}: { fallback?: TikTok } = {}): TikTok {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "tikTok"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as TikTok;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtikTok%3Ediscontinued})
   */
  discontinued({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("discontinued", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtikTok%3EorderCutoffTimestamp})
   */
  orderCutoffTimestamp({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("orderCutoffTimestamp", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type TiktokSellerShipping = {
  enabled: boolean;
  shopUrls: string[];
}

const tiktokSellerShippingFallback = {enabled:false,shopUrls:[]};

export class TiktokSellerShippingNode extends sdk.Node {
  override typeName = "TiktokSellerShipping" as const;

  get({ fallback = tiktokSellerShippingFallback as TiktokSellerShipping}: { fallback?: TiktokSellerShipping } = {}): TiktokSellerShipping {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "tiktokSellerShipping"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as TiktokSellerShipping;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtiktokSellerShipping%3Eenabled})
   */
  enabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("enabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtiktokSellerShipping%3EshopUrls})
   */
  shopUrls({ args = {}, itemFallback: fallback, listFallbackLength = 0 }: { args?: EmptyObject; itemFallback: string; listFallbackLength?: number; }): string[] {
    const props0 = this.getFieldNodeProps("shopUrls", { fieldArguments: args });

    return new sdk.Node(props0).getItemNodeProps({ fallbackLength: listFallbackLength }).map((props1) => {
      const expression1 = props1.expression;

      if (
        expression1 &&
        expression1.type === "StringExpression"
      ) {
        const node = new sdk.StringNode(props1);
        return node.get({ fallback });
      }
  
      const node = new sdk.StringNode(props1);
      node._logUnexpectedTypeError();
      return node.get({ fallback });
    });
  }
}

export type TiktokShipping = {
  enabled: boolean;
  shopUrls: string[];
}

const tiktokShippingFallback = {enabled:false,shopUrls:[]};

export class TiktokShippingNode extends sdk.Node {
  override typeName = "TiktokShipping" as const;

  get({ fallback = tiktokShippingFallback as TiktokShipping}: { fallback?: TiktokShipping } = {}): TiktokShipping {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "tiktokShipping"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as TiktokShipping;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtiktokShipping%3Eenabled})
   */
  enabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("enabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtiktokShipping%3EshopUrls})
   */
  shopUrls({ args = {}, itemFallback: fallback, listFallbackLength = 0 }: { args?: EmptyObject; itemFallback: string; listFallbackLength?: number; }): string[] {
    const props0 = this.getFieldNodeProps("shopUrls", { fieldArguments: args });

    return new sdk.Node(props0).getItemNodeProps({ fallbackLength: listFallbackLength }).map((props1) => {
      const expression1 = props1.expression;

      if (
        expression1 &&
        expression1.type === "StringExpression"
      ) {
        const node = new sdk.StringNode(props1);
        return node.get({ fallback });
      }
  
      const node = new sdk.StringNode(props1);
      node._logUnexpectedTypeError();
      return node.get({ fallback });
    });
  }
}

export type MetaConversionsAPI = {
  testEventCode: string;
}

const metaConversionsAPIFallback = {testEventCode:""};

export class MetaConversionsAPINode extends sdk.Node {
  override typeName = "MetaConversionsAPI" as const;

  get({ fallback = metaConversionsAPIFallback as MetaConversionsAPI}: { fallback?: MetaConversionsAPI } = {}): MetaConversionsAPI {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "metaConversionsAPI"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as MetaConversionsAPI;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EmetaConversionsAPI%3EtestEventCode})
   */
  testEventCode({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("testEventCode", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type ClickFunnels = {
  clickFunnelsStoreCardURL: string;
}

const clickFunnelsFallback = {clickFunnelsStoreCardURL:""};

export class ClickFunnelsNode extends sdk.Node {
  override typeName = "ClickFunnels" as const;

  get({ fallback = clickFunnelsFallback as ClickFunnels}: { fallback?: ClickFunnels } = {}): ClickFunnels {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "clickFunnels"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as ClickFunnels;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EclickFunnels%3EclickFunnelsStoreCardURL})
   */
  clickFunnelsStoreCardURL({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("clickFunnelsStoreCardURL", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type StripeInvoicingProducts = {
  sampleDiscountPercent: number;
  shippingFee: string;
  sampleDiscountId: string;
  enabled: boolean;
  firstItemFulfillmentFee: string;
  additionalItemFulfillmentFee: string;
  processingFee: string;
}

const stripeInvoicingProductsFallback = {sampleDiscountPercent:0,shippingFee:"",sampleDiscountId:"",enabled:false,firstItemFulfillmentFee:"",additionalItemFulfillmentFee:"",processingFee:""};

export class StripeInvoicingProductsNode extends sdk.Node {
  override typeName = "StripeInvoicingProducts" as const;

  get({ fallback = stripeInvoicingProductsFallback as StripeInvoicingProducts}: { fallback?: StripeInvoicingProducts } = {}): StripeInvoicingProducts {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "stripeInvoicing"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as StripeInvoicingProducts;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EsampleDiscountPercent})
   */
  sampleDiscountPercent({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("sampleDiscountPercent", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EshippingFee})
   */
  shippingFee({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("shippingFee", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EsampleDiscountId})
   */
  sampleDiscountId({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("sampleDiscountId", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3Eenabled})
   */
  enabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("enabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EfirstItemFulfillmentFee})
   */
  firstItemFulfillmentFee({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("firstItemFulfillmentFee", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EadditionalItemFulfillmentFee})
   */
  additionalItemFulfillmentFee({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("additionalItemFulfillmentFee", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing%3EprocessingFee})
   */
  processingFee({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("processingFee", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type SubscriptionItems = {
  enabled: boolean;
  brandedCustomerSupportPriceId: string;
}

const subscriptionItemsFallback = {enabled:false,brandedCustomerSupportPriceId:""};

export class SubscriptionItemsNode extends sdk.Node {
  override typeName = "SubscriptionItems" as const;

  get({ fallback = subscriptionItemsFallback as SubscriptionItems}: { fallback?: SubscriptionItems } = {}): SubscriptionItems {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "subscriptionItems"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as SubscriptionItems;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsubscriptionItems%3Eenabled})
   */
  enabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("enabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsubscriptionItems%3EbrandedCustomerSupportPriceId})
   */
  brandedCustomerSupportPriceId({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("brandedCustomerSupportPriceId", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export const RoastifyProductTypeEnumValues = [
  "CoffeeBox12oz",
  "Pods",
  "InstantCoffee",
  "Tubes"
] as const;
export type RoastifyProductType = typeof RoastifyProductTypeEnumValues[number];

export class RoastifyProductTypeNode extends sdk.Node {
  override typeName = "RoastifyProductType" as const;

  get({
    fallback,
    shouldReturnUnrecognizedValues = false,
   }: {
    fallback: RoastifyProductType; 
    shouldReturnUnrecognizedValues?: boolean;
  }): RoastifyProductType {
    const value = this.getValue({ fallback });

    if (typeof value !== "string" || !value) {
      this.logUnexpectedValueError(value);
      return fallback;
    }
    if (!shouldReturnUnrecognizedValues && !RoastifyProductTypeEnumValues.includes(value as RoastifyProductType)) {
      this.logUnexpectedValueError(value);
      return fallback;
    }

    return value as RoastifyProductType;
  }
}

export type RoastifyProduct = {
  sku: string;
  productType: RoastifyProductType;
  desiredWidthInPixels: number;
}

const roastifyProductFallback = {sku:"",productType:"CoffeeBox12oz",desiredWidthInPixels:0};

export class RoastifyProductNode extends sdk.Node {
  override typeName = "RoastifyProduct" as const;

  get({ fallback = roastifyProductFallback as RoastifyProduct}: { fallback?: RoastifyProduct } = {}): RoastifyProduct {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "roastifySkus"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as RoastifyProduct;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/schema?selected_schema_type=%7B%22type%22%3A%22object%22%2C%22name%22%3A%22RoastifyProduct%22%2C%22selectedChildName%22%3A%22sku%22%7D})
   */
  sku({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("sku", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/schema?selected_schema_type=%7B%22type%22%3A%22object%22%2C%22name%22%3A%22RoastifyProduct%22%2C%22selectedChildName%22%3A%22productType%22%7D})
   */
  productType({ args = {}, fallback, shouldReturnUnrecognizedValues = false }: { args?: EmptyObject; fallback: RoastifyProductType; shouldReturnUnrecognizedValues?: boolean; }): RoastifyProductType {
    const props0 = this.getFieldNodeProps("productType", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      (expression0.type === "StringExpression" || 
        expression0.type === "EnumExpression") &&
      RoastifyProductTypeEnumValues.includes(expression0.value as RoastifyProductType)
    ) {
      const node = new RoastifyProductTypeNode(props0);
      return node.get({ fallback, shouldReturnUnrecognizedValues });
    }

    const node = new RoastifyProductTypeNode(props0);
    node._logUnexpectedTypeError();
    return fallback;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/schema?selected_schema_type=%7B%22type%22%3A%22object%22%2C%22name%22%3A%22RoastifyProduct%22%2C%22selectedChildName%22%3A%22desiredWidthInPixels%22%7D})
   */
  desiredWidthInPixels({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("desiredWidthInPixels", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type SocialSignOn = {
  facebook: boolean;
  google: boolean;
  twitter: boolean;
}

const socialSignOnFallback = {facebook:false,google:false,twitter:false};

export class SocialSignOnNode extends sdk.Node {
  override typeName = "SocialSignOn" as const;

  get({ fallback = socialSignOnFallback as SocialSignOn}: { fallback?: SocialSignOn } = {}): SocialSignOn {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "socialSignOn"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as SocialSignOn;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsocialSignOn%3Efacebook})
   */
  facebook({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("facebook", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsocialSignOn%3Egoogle})
   */
  google({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("google", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsocialSignOn%3Etwitter})
   */
  twitter({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("twitter", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type HelpArticles = {
  labelMigrateCommonIssues: string;
  labelMigration: string;
  orderKinds: string;
  sampleDiscount: string;
  createGeneralLabel: string;
  createRoastifyLabels: string;
  shippingCost: string;
  productCost: string;
  processingFee: string;
  fulfillmentFee: string;
  tieredPricing: string;
  storeAlreadyConnected: string;
  setUserStoreShippingRates: string;
  returns: string;
  shipping: string;
}

const helpArticlesFallback = {labelMigrateCommonIssues:"",labelMigration:"",orderKinds:"",sampleDiscount:"",createGeneralLabel:"",createRoastifyLabels:"",shippingCost:"",productCost:"",processingFee:"",fulfillmentFee:"",tieredPricing:"",storeAlreadyConnected:"",setUserStoreShippingRates:"",returns:"",shipping:""};

export class HelpArticlesNode extends sdk.Node {
  override typeName = "HelpArticles" as const;

  get({ fallback = helpArticlesFallback as HelpArticles}: { fallback?: HelpArticles } = {}): HelpArticles {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "helpArticles"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as HelpArticles;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3ElabelMigrateCommonIssues})
   */
  labelMigrateCommonIssues({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("labelMigrateCommonIssues", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3ElabelMigration})
   */
  labelMigration({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("labelMigration", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EorderKinds})
   */
  orderKinds({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("orderKinds", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EsampleDiscount})
   */
  sampleDiscount({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("sampleDiscount", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EcreateGeneralLabel})
   */
  createGeneralLabel({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("createGeneralLabel", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EcreateRoastifyLabels})
   */
  createRoastifyLabels({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("createRoastifyLabels", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EshippingCost})
   */
  shippingCost({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("shippingCost", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EproductCost})
   */
  productCost({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("productCost", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EprocessingFee})
   */
  processingFee({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("processingFee", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EfulfillmentFee})
   */
  fulfillmentFee({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("fulfillmentFee", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EtieredPricing})
   */
  tieredPricing({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("tieredPricing", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EstoreAlreadyConnected})
   */
  storeAlreadyConnected({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("storeAlreadyConnected", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3EsetUserStoreShippingRates})
   */
  setUserStoreShippingRates({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("setUserStoreShippingRates", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3Ereturns})
   */
  returns({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("returns", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles%3Eshipping})
   */
  shipping({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("shipping", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type FulfillmentDeadlines = {
  fbaDays: number;
  priorityDays: number;
  sampleDays: number;
  defaultDays: number;
  prelabeledDays: number;
}

const fulfillmentDeadlinesFallback = {fbaDays:0,priorityDays:0,sampleDays:0,defaultDays:0,prelabeledDays:0};

export class FulfillmentDeadlinesNode extends sdk.Node {
  override typeName = "FulfillmentDeadlines" as const;

  get({ fallback = fulfillmentDeadlinesFallback as FulfillmentDeadlines}: { fallback?: FulfillmentDeadlines } = {}): FulfillmentDeadlines {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "fulfillmentDeadlines"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as FulfillmentDeadlines;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines%3EfbaDays})
   */
  fbaDays({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("fbaDays", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines%3EpriorityDays})
   */
  priorityDays({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("priorityDays", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines%3EsampleDays})
   */
  sampleDays({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("sampleDays", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines%3EdefaultDays})
   */
  defaultDays({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("defaultDays", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines%3EprelabeledDays})
   */
  prelabeledDays({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("prelabeledDays", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type PaymentDeadlines = {
  prePaymentDays: number;
}

const paymentDeadlinesFallback = {prePaymentDays:0};

export class PaymentDeadlinesNode extends sdk.Node {
  override typeName = "PaymentDeadlines" as const;

  get({ fallback = paymentDeadlinesFallback as PaymentDeadlines}: { fallback?: PaymentDeadlines } = {}): PaymentDeadlines {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "paymentDeadlines"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as PaymentDeadlines;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EpaymentDeadlines%3EprePaymentDays})
   */
  prePaymentDays({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("prePaymentDays", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type RunNotionFbaProductsCron = {
  enabled: boolean;
  schedule: string;
}

const runNotionFbaProductsCronFallback = {enabled:false,schedule:""};

export class RunNotionFbaProductsCronNode extends sdk.Node {
  override typeName = "RunNotionFbaProductsCron" as const;

  get({ fallback = runNotionFbaProductsCronFallback as RunNotionFbaProductsCron}: { fallback?: RunNotionFbaProductsCron } = {}): RunNotionFbaProductsCron {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "cronJobs", "CronJobs", "notionFbaProducts"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as RunNotionFbaProductsCron;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3EnotionFbaProducts%3Eenabled})
   */
  enabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("enabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3EnotionFbaProducts%3Eschedule})
   */
  schedule({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("schedule", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type PostPaymentBucketsCron = {
  /**
   * Controls whether the app should send email reminders to customer about unpaid post-payment bucket invoices.
   */
  paymentEmailRemindersEnabled: boolean;
}

const postPaymentBucketsCronFallback = {paymentEmailRemindersEnabled:false};

export class PostPaymentBucketsCronNode extends sdk.Node {
  override typeName = "PostPaymentBucketsCron" as const;

  get({ fallback = postPaymentBucketsCronFallback as PostPaymentBucketsCron}: { fallback?: PostPaymentBucketsCron } = {}): PostPaymentBucketsCron {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "cronJobs", "CronJobs", "postPaymentBuckets"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as PostPaymentBucketsCron;
  }

  /**
   * Controls whether the app should send email reminders to customer about unpaid post-payment bucket invoices.
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3EpostPaymentBuckets%3EpaymentEmailRemindersEnabled})
   */
  paymentEmailRemindersEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("paymentEmailRemindersEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type CronJobs = {
  runClickFunnelsOrderImportCron: boolean;
  runOrderInvoiceGenerationCron: boolean;
  runShopifyFulfillmentCheckCron: boolean;
  runShopifyStoreWebhookCheckCron: boolean;
  notionFbaProducts: RunNotionFbaProductsCron;
  postPaymentBuckets: PostPaymentBucketsCron;
  runExpireOldUserCreditsCron: boolean;
  runClickFunnelsStoreWebhookCheckCron: boolean;
  runShipheroAccessTokenCheckCron: boolean;
}

const cronJobsFallback = {runClickFunnelsOrderImportCron:false,runOrderInvoiceGenerationCron:false,runShopifyFulfillmentCheckCron:false,runShopifyStoreWebhookCheckCron:false,notionFbaProducts:{enabled:false,schedule:""},postPaymentBuckets:{paymentEmailRemindersEnabled:false},runExpireOldUserCreditsCron:false,runClickFunnelsStoreWebhookCheckCron:false,runShipheroAccessTokenCheckCron:false};

export class CronJobsNode extends sdk.Node {
  override typeName = "CronJobs" as const;

  get({ fallback = cronJobsFallback as CronJobs}: { fallback?: CronJobs } = {}): CronJobs {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "cronJobs"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as CronJobs;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunClickFunnelsOrderImportCron})
   */
  runClickFunnelsOrderImportCron({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("runClickFunnelsOrderImportCron", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunOrderInvoiceGenerationCron})
   */
  runOrderInvoiceGenerationCron({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("runOrderInvoiceGenerationCron", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunShopifyFulfillmentCheckCron})
   */
  runShopifyFulfillmentCheckCron({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("runShopifyFulfillmentCheckCron", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunShopifyStoreWebhookCheckCron})
   */
  runShopifyStoreWebhookCheckCron({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("runShopifyStoreWebhookCheckCron", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3EnotionFbaProducts})
   */
  notionFbaProducts({ args = {} }: { args?: EmptyObject; } = {}): RunNotionFbaProductsCronNode {
    const props0 = this.getFieldNodeProps("notionFbaProducts", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "RunNotionFbaProductsCron"
    ) {
      return new RunNotionFbaProductsCronNode(props0);
    }

    const node = new RunNotionFbaProductsCronNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3EpostPaymentBuckets})
   */
  postPaymentBuckets({ args = {} }: { args?: EmptyObject; } = {}): PostPaymentBucketsCronNode {
    const props0 = this.getFieldNodeProps("postPaymentBuckets", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "PostPaymentBucketsCron"
    ) {
      return new PostPaymentBucketsCronNode(props0);
    }

    const node = new PostPaymentBucketsCronNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunExpireOldUserCreditsCron})
   */
  runExpireOldUserCreditsCron({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("runExpireOldUserCreditsCron", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunClickFunnelsStoreWebhookCheckCron})
   */
  runClickFunnelsStoreWebhookCheckCron({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("runClickFunnelsStoreWebhookCheckCron", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs%3ErunShipheroAccessTokenCheckCron})
   */
  runShipheroAccessTokenCheckCron({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("runShipheroAccessTokenCheckCron", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type OrderTypeMinimumQuantities = {
  minManualQuantity: number;
  minSampleQuantity: number;
  minFbaQuantity: number;
  minBulkQuantity: number;
}

const orderTypeMinimumQuantitiesFallback = {minManualQuantity:0,minSampleQuantity:0,minFbaQuantity:0,minBulkQuantity:0};

export class OrderTypeMinimumQuantitiesNode extends sdk.Node {
  override typeName = "OrderTypeMinimumQuantities" as const;

  get({ fallback = orderTypeMinimumQuantitiesFallback as OrderTypeMinimumQuantities}: { fallback?: OrderTypeMinimumQuantities } = {}): OrderTypeMinimumQuantities {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "orderTypeMinimumQuantities"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as OrderTypeMinimumQuantities;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderTypeMinimumQuantities%3EminManualQuantity})
   */
  minManualQuantity({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("minManualQuantity", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderTypeMinimumQuantities%3EminSampleQuantity})
   */
  minSampleQuantity({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("minSampleQuantity", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderTypeMinimumQuantities%3EminFbaQuantity})
   */
  minFbaQuantity({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("minFbaQuantity", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderTypeMinimumQuantities%3EminBulkQuantity})
   */
  minBulkQuantity({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("minBulkQuantity", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type User = {
  userMinimumPricingTier: number;
}

const userFallback = {userMinimumPricingTier:0};

export class UserNode extends sdk.Node {
  override typeName = "User" as const;

  get({ fallback = userFallback as User}: { fallback?: User } = {}): User {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "user"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as User;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Euser%3EuserMinimumPricingTier})
   */
  userMinimumPricingTier({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("userMinimumPricingTier", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type AIProductBuilder = {
  isEnabled: boolean;
  appURL: string;
}

const aIProductBuilderFallback = {isEnabled:false,appURL:""};

export class AIProductBuilderNode extends sdk.Node {
  override typeName = "AIProductBuilder" as const;

  get({ fallback = aIProductBuilderFallback as AIProductBuilder}: { fallback?: AIProductBuilder } = {}): AIProductBuilder {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "aiProductBuilder"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as AIProductBuilder;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EaiProductBuilder%3EisEnabled})
   */
  isEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("isEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EaiProductBuilder%3EappURL})
   */
  appURL({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("appURL", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type SGTM = {
  hubspotDirectEventsEnabled: boolean;
}

const sGTMFallback = {hubspotDirectEventsEnabled:false};

export class SGTMNode extends sdk.Node {
  override typeName = "SGTM" as const;

  get({ fallback = sGTMFallback as SGTM}: { fallback?: SGTM } = {}): SGTM {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "sgtm"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as SGTM;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Esgtm%3EhubspotDirectEventsEnabled})
   */
  hubspotDirectEventsEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("hubspotDirectEventsEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type Onboarding = {
  surveyEnabled: boolean;
  surveyEnabledSince: string;
}

const onboardingFallback = {surveyEnabled:false,surveyEnabledSince:""};

export class OnboardingNode extends sdk.Node {
  override typeName = "Onboarding" as const;

  get({ fallback = onboardingFallback as Onboarding}: { fallback?: Onboarding } = {}): Onboarding {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root", "Root", "onboarding"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as Onboarding;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eonboarding%3EsurveyEnabled})
   */
  surveyEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("surveyEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eonboarding%3EsurveyEnabledSince})
   */
  surveyEnabledSince({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("surveyEnabledSince", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }
}

export type Root = {
  customersCanvasMockupPipeline: boolean;
  manualMockupRegenerationEnabled: boolean;
  labelTransition: LabelTransition;
  labelUpgradePurchase: LabelUpgradePurchase;
  shopify: Shopify;
  payments: Payments;
  adminGenerateMockupsFromLabelV1Enabled: boolean;
  adminLabelTransitionsPageEnabled: boolean;
  adminGenericLabelPreviewEnabled: boolean;
  labelSettings: LabelSettings;
  polotno: Polotno;
  shipments: Shipments;
  shiphero: Shiphero;
  regenerateMockupsOnSubscribe: boolean;
  hubspot: Hubspot;
  tikTok: TikTok;
  canPublishToTiktok: boolean;
  canConnectTiktokStore: boolean;
  tiktokSellerShipping: TiktokSellerShipping;
  tiktokShipping: TiktokShipping;
  magicLinkWithOTP: boolean;
  metaConversionsAPI: MetaConversionsAPI;
  blackFridayPromoIsEnabled: boolean;
  clickFunnels: ClickFunnels;
  clickFunnelsAllowTestOrdersInProduction: boolean;
  useAsyncGtmSignupCallbacks: boolean;
  sampleDiscountValidDate: string;
  clickFunnelsIsEnabled: boolean;
  extendedCatalogIsEnabled: boolean;
  roastifyProduct3DPreviewReportIssueEnabled: boolean;
  stripeInvoicing: StripeInvoicingProducts;
  subscriptionItems: SubscriptionItems;
  roastifySkus: RoastifyProduct[];
  singleSkuBundleEnabled: boolean;
  socialSignOn: SocialSignOn;
  jetpackFbaEmails: string[];
  newPricingSystemVideoPopupEnabled: boolean;
  /**
   * List of user product ids that will be exempt from fulfillment fee
   */
  fulfillmentFeeExemptProducts: string[];
  cnameRedirectNotificationEnabled: boolean;
  bulkOrdersEnabled: boolean;
  processingFeeRate: number;
  fulfillmentFeeAdditionalSkuUnits: number;
  fulfillmentFeeFirstSkuUnit: number;
  helpArticles: HelpArticles;
  newPricingSystemEnabled: boolean;
  /**
   * Defines the number of products in a line item that requires processing before fulfillment.
   */
  orderProcessingStatusItemCountThreshold: number;
  partnerProductStockSnapshotEnabled: boolean;
  shouldApplyExpressShippingSampleOrder: boolean;
  fulfillmentDeadlines: FulfillmentDeadlines;
  paymentDeadlines: PaymentDeadlines;
  postOrderCreationFeedbackIntervalSeconds: number;
  cronJobs: CronJobs;
  /**
   * Asks for feedback after creating order with new order form. Depends on new order form being enabled.
   */
  postOrderCreationFeedbackEnabled: boolean;
  /**
   * Asks for feedback in new order form. Depends on new order form being enabled.
   */
  orderFormFeedbackEnabled: boolean;
  prepaidPriceEnabled: boolean;
  easypostEelPfcEnabled: boolean;
  /**
   * Enables the onboarding survey displayed to newly registered users
   */
  onboardingSurveyEnabled: boolean;
  acceptOrderDelayMinutes: number;
  orderTypeMinimumQuantities: OrderTypeMinimumQuantities;
  user: User;
  devMailBypassList: string[];
  aiProductBuilder: AIProductBuilder;
  membershipsEnabled: boolean;
  sgtm: SGTM;
  onboarding: Onboarding;
}

const rootFallback = {customersCanvasMockupPipeline:false,manualMockupRegenerationEnabled:false,labelTransition:{autoupgraderDisabledTooltip:"",autoupgraderDisabled:false,showLabelMigrationStatus:false,showLabelTransitionBanner:false,migrationDeadline:""},labelUpgradePurchase:{autoUpgradeTermsLink:"",subscriberFreeUpgradesCount:0,priceId:"",priceCents:0,freeCouponId:""},shopify:{useREST4InventoryActivation:false,shopifyShippingRatesSetupAppEnabled:false},payments:{suplifulCreditsTopupEnabled:false,suplifulTokensEnabled:false},adminGenerateMockupsFromLabelV1Enabled:false,adminLabelTransitionsPageEnabled:false,adminGenericLabelPreviewEnabled:false,labelSettings:{dpi:0,width:0,height:0,borderWidth:0},polotno:{unsplashEnabled:false,templatesEnabled:false,useNewLabelForFulfillment:false,enabled:false},shipments:{shipmentInsuranceThreshold:0,easypostEelPfcEnabled:false},shiphero:{productLotTrackingEnabled:false,orderTag:"",userProductTag:"",userProductSyncEnabled:false,warehouseSyncEnabled:false,catalogSyncEnabled:false},regenerateMockupsOnSubscribe:false,hubspot:{testing:false},tikTok:{discontinued:false,orderCutoffTimestamp:0},canPublishToTiktok:false,canConnectTiktokStore:false,tiktokSellerShipping:{enabled:false,shopUrls:[]},tiktokShipping:{enabled:false,shopUrls:[]},magicLinkWithOTP:false,metaConversionsAPI:{testEventCode:""},blackFridayPromoIsEnabled:false,clickFunnels:{clickFunnelsStoreCardURL:""},clickFunnelsAllowTestOrdersInProduction:false,useAsyncGtmSignupCallbacks:false,sampleDiscountValidDate:"",clickFunnelsIsEnabled:false,extendedCatalogIsEnabled:false,roastifyProduct3DPreviewReportIssueEnabled:false,stripeInvoicing:{sampleDiscountPercent:0,shippingFee:"",sampleDiscountId:"",enabled:false,firstItemFulfillmentFee:"",additionalItemFulfillmentFee:"",processingFee:""},subscriptionItems:{enabled:false,brandedCustomerSupportPriceId:""},roastifySkus:[],singleSkuBundleEnabled:false,socialSignOn:{facebook:false,google:false,twitter:false},jetpackFbaEmails:[],newPricingSystemVideoPopupEnabled:false,fulfillmentFeeExemptProducts:[],cnameRedirectNotificationEnabled:false,bulkOrdersEnabled:false,processingFeeRate:0,fulfillmentFeeAdditionalSkuUnits:0,fulfillmentFeeFirstSkuUnit:0,helpArticles:{labelMigrateCommonIssues:"",labelMigration:"",orderKinds:"",sampleDiscount:"",createGeneralLabel:"",createRoastifyLabels:"",shippingCost:"",productCost:"",processingFee:"",fulfillmentFee:"",tieredPricing:"",storeAlreadyConnected:"",setUserStoreShippingRates:"",returns:"",shipping:""},newPricingSystemEnabled:false,orderProcessingStatusItemCountThreshold:0,partnerProductStockSnapshotEnabled:false,shouldApplyExpressShippingSampleOrder:false,fulfillmentDeadlines:{fbaDays:0,priorityDays:0,sampleDays:0,defaultDays:0,prelabeledDays:0},paymentDeadlines:{prePaymentDays:0},postOrderCreationFeedbackIntervalSeconds:0,cronJobs:{runClickFunnelsOrderImportCron:false,runOrderInvoiceGenerationCron:false,runShopifyFulfillmentCheckCron:false,runShopifyStoreWebhookCheckCron:false,notionFbaProducts:{enabled:false,schedule:""},postPaymentBuckets:{paymentEmailRemindersEnabled:false},runExpireOldUserCreditsCron:false,runClickFunnelsStoreWebhookCheckCron:false,runShipheroAccessTokenCheckCron:false},postOrderCreationFeedbackEnabled:false,orderFormFeedbackEnabled:false,prepaidPriceEnabled:false,easypostEelPfcEnabled:false,onboardingSurveyEnabled:false,acceptOrderDelayMinutes:0,orderTypeMinimumQuantities:{minManualQuantity:0,minSampleQuantity:0,minFbaQuantity:0,minBulkQuantity:0},user:{userMinimumPricingTier:0},devMailBypassList:[],aiProductBuilder:{isEnabled:false,appURL:""},membershipsEnabled:false,sgtm:{hubspotDirectEventsEnabled:false},onboarding:{surveyEnabled:false,surveyEnabledSince:""}};

export class RootNode extends sdk.Node {
  override typeName = "Root" as const;

  getRootArgs(): RootArgs {
    const { step } = this.props;
    return (step?.type === 'GetFieldStep' ? step.fieldArguments : {}) as RootArgs;
  }

  get({ fallback = rootFallback as Root}: { fallback?: Root } = {}): Root {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, ["Query", "root"]), 
      null,
    );
    return this.getValue({ query: getQuery, fallback }) as Root;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcustomersCanvasMockupPipeline})
   */
  customersCanvasMockupPipeline({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("customersCanvasMockupPipeline", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EmanualMockupRegenerationEnabled})
   */
  manualMockupRegenerationEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("manualMockupRegenerationEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelTransition})
   */
  labelTransition({ args = {} }: { args?: EmptyObject; } = {}): LabelTransitionNode {
    const props0 = this.getFieldNodeProps("labelTransition", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "LabelTransition"
    ) {
      return new LabelTransitionNode(props0);
    }

    const node = new LabelTransitionNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelUpgradePurchase})
   */
  labelUpgradePurchase({ args = {} }: { args?: EmptyObject; } = {}): LabelUpgradePurchaseNode {
    const props0 = this.getFieldNodeProps("labelUpgradePurchase", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "LabelUpgradePurchase"
    ) {
      return new LabelUpgradePurchaseNode(props0);
    }

    const node = new LabelUpgradePurchaseNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshopify})
   */
  shopify({ args = {} }: { args?: EmptyObject; } = {}): ShopifyNode {
    const props0 = this.getFieldNodeProps("shopify", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "Shopify"
    ) {
      return new ShopifyNode(props0);
    }

    const node = new ShopifyNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epayments})
   */
  payments({ args = {} }: { args?: EmptyObject; } = {}): PaymentsNode {
    const props0 = this.getFieldNodeProps("payments", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "Payments"
    ) {
      return new PaymentsNode(props0);
    }

    const node = new PaymentsNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EadminGenerateMockupsFromLabelV1Enabled})
   */
  adminGenerateMockupsFromLabelV1Enabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("adminGenerateMockupsFromLabelV1Enabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EadminLabelTransitionsPageEnabled})
   */
  adminLabelTransitionsPageEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("adminLabelTransitionsPageEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EadminGenericLabelPreviewEnabled})
   */
  adminGenericLabelPreviewEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("adminGenericLabelPreviewEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3ElabelSettings})
   */
  labelSettings({ args = {} }: { args?: EmptyObject; } = {}): LabelSettingsNode {
    const props0 = this.getFieldNodeProps("labelSettings", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "LabelSettings"
    ) {
      return new LabelSettingsNode(props0);
    }

    const node = new LabelSettingsNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Epolotno})
   */
  polotno({ args = {} }: { args?: EmptyObject; } = {}): PolotnoNode {
    const props0 = this.getFieldNodeProps("polotno", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "Polotno"
    ) {
      return new PolotnoNode(props0);
    }

    const node = new PolotnoNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshipments})
   */
  shipments({ args = {} }: { args?: EmptyObject; } = {}): ShipmentsNode {
    const props0 = this.getFieldNodeProps("shipments", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "Shipments"
    ) {
      return new ShipmentsNode(props0);
    }

    const node = new ShipmentsNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eshiphero})
   */
  shiphero({ args = {} }: { args?: EmptyObject; } = {}): ShipheroNode {
    const props0 = this.getFieldNodeProps("shiphero", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "Shiphero"
    ) {
      return new ShipheroNode(props0);
    }

    const node = new ShipheroNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EregenerateMockupsOnSubscribe})
   */
  regenerateMockupsOnSubscribe({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("regenerateMockupsOnSubscribe", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Ehubspot})
   */
  hubspot({ args = {} }: { args?: EmptyObject; } = {}): HubspotNode {
    const props0 = this.getFieldNodeProps("hubspot", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "Hubspot"
    ) {
      return new HubspotNode(props0);
    }

    const node = new HubspotNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtikTok})
   */
  tikTok({ args = {} }: { args?: EmptyObject; } = {}): TikTokNode {
    const props0 = this.getFieldNodeProps("tikTok", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "TikTok"
    ) {
      return new TikTokNode(props0);
    }

    const node = new TikTokNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcanPublishToTiktok})
   */
  canPublishToTiktok({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("canPublishToTiktok", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcanConnectTiktokStore})
   */
  canConnectTiktokStore({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("canConnectTiktokStore", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtiktokSellerShipping})
   */
  tiktokSellerShipping({ args = {} }: { args?: EmptyObject; } = {}): TiktokSellerShippingNode {
    const props0 = this.getFieldNodeProps("tiktokSellerShipping", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "TiktokSellerShipping"
    ) {
      return new TiktokSellerShippingNode(props0);
    }

    const node = new TiktokSellerShippingNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EtiktokShipping})
   */
  tiktokShipping({ args = {} }: { args?: EmptyObject; } = {}): TiktokShippingNode {
    const props0 = this.getFieldNodeProps("tiktokShipping", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "TiktokShipping"
    ) {
      return new TiktokShippingNode(props0);
    }

    const node = new TiktokShippingNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EmagicLinkWithOTP})
   */
  magicLinkWithOTP({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("magicLinkWithOTP", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EmetaConversionsAPI})
   */
  metaConversionsAPI({ args = {} }: { args?: EmptyObject; } = {}): MetaConversionsAPINode {
    const props0 = this.getFieldNodeProps("metaConversionsAPI", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "MetaConversionsAPI"
    ) {
      return new MetaConversionsAPINode(props0);
    }

    const node = new MetaConversionsAPINode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EblackFridayPromoIsEnabled})
   */
  blackFridayPromoIsEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("blackFridayPromoIsEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EclickFunnels})
   */
  clickFunnels({ args = {} }: { args?: EmptyObject; } = {}): ClickFunnelsNode {
    const props0 = this.getFieldNodeProps("clickFunnels", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "ClickFunnels"
    ) {
      return new ClickFunnelsNode(props0);
    }

    const node = new ClickFunnelsNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EclickFunnelsAllowTestOrdersInProduction})
   */
  clickFunnelsAllowTestOrdersInProduction({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("clickFunnelsAllowTestOrdersInProduction", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EuseAsyncGtmSignupCallbacks})
   */
  useAsyncGtmSignupCallbacks({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("useAsyncGtmSignupCallbacks", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsampleDiscountValidDate})
   */
  sampleDiscountValidDate({ args = {}, fallback }: { args?: EmptyObject; fallback: string; }): string {
    const props0 = this.getFieldNodeProps("sampleDiscountValidDate", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "StringExpression"
    ) {
      const node = new sdk.StringNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.StringNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EclickFunnelsIsEnabled})
   */
  clickFunnelsIsEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("clickFunnelsIsEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EextendedCatalogIsEnabled})
   */
  extendedCatalogIsEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("extendedCatalogIsEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EroastifyProduct3DPreviewReportIssueEnabled})
   */
  roastifyProduct3DPreviewReportIssueEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("roastifyProduct3DPreviewReportIssueEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EstripeInvoicing})
   */
  stripeInvoicing({ args = {} }: { args?: EmptyObject; } = {}): StripeInvoicingProductsNode {
    const props0 = this.getFieldNodeProps("stripeInvoicing", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "StripeInvoicingProducts"
    ) {
      return new StripeInvoicingProductsNode(props0);
    }

    const node = new StripeInvoicingProductsNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsubscriptionItems})
   */
  subscriptionItems({ args = {} }: { args?: EmptyObject; } = {}): SubscriptionItemsNode {
    const props0 = this.getFieldNodeProps("subscriptionItems", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "SubscriptionItems"
    ) {
      return new SubscriptionItemsNode(props0);
    }

    const node = new SubscriptionItemsNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EroastifySkus})
   */
  roastifySkus({ args = {}, listFallbackLength = 0 }: { args?: EmptyObject; listFallbackLength?: number; } = {}): RoastifyProductNode[] {
    const props0 = this.getFieldNodeProps("roastifySkus", { fieldArguments: args });

    return new sdk.Node(props0).getItemNodeProps({ fallbackLength: listFallbackLength }).map((props1) => {
      const expression1 = props1.expression;

      if (
        expression1 &&
        expression1.type === "ObjectExpression" &&
        expression1.objectTypeName === "RoastifyProduct"
      ) {
        return new RoastifyProductNode(props1);
      }
  
      const node = new RoastifyProductNode(props1);
      node._logUnexpectedTypeError();
      return node;
    });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsingleSkuBundleEnabled})
   */
  singleSkuBundleEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("singleSkuBundleEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EsocialSignOn})
   */
  socialSignOn({ args = {} }: { args?: EmptyObject; } = {}): SocialSignOnNode {
    const props0 = this.getFieldNodeProps("socialSignOn", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "SocialSignOn"
    ) {
      return new SocialSignOnNode(props0);
    }

    const node = new SocialSignOnNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EjetpackFbaEmails})
   */
  jetpackFbaEmails({ args = {}, itemFallback: fallback, listFallbackLength = 0 }: { args?: EmptyObject; itemFallback: string; listFallbackLength?: number; }): string[] {
    const props0 = this.getFieldNodeProps("jetpackFbaEmails", { fieldArguments: args });

    return new sdk.Node(props0).getItemNodeProps({ fallbackLength: listFallbackLength }).map((props1) => {
      const expression1 = props1.expression;

      if (
        expression1 &&
        expression1.type === "StringExpression"
      ) {
        const node = new sdk.StringNode(props1);
        return node.get({ fallback });
      }
  
      const node = new sdk.StringNode(props1);
      node._logUnexpectedTypeError();
      return node.get({ fallback });
    });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EnewPricingSystemVideoPopupEnabled})
   */
  newPricingSystemVideoPopupEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("newPricingSystemVideoPopupEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * List of user product ids that will be exempt from fulfillment fee
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentFeeExemptProducts})
   */
  fulfillmentFeeExemptProducts({ args = {}, itemFallback: fallback, listFallbackLength = 0 }: { args?: EmptyObject; itemFallback: string; listFallbackLength?: number; }): string[] {
    const props0 = this.getFieldNodeProps("fulfillmentFeeExemptProducts", { fieldArguments: args });

    return new sdk.Node(props0).getItemNodeProps({ fallbackLength: listFallbackLength }).map((props1) => {
      const expression1 = props1.expression;

      if (
        expression1 &&
        expression1.type === "StringExpression"
      ) {
        const node = new sdk.StringNode(props1);
        return node.get({ fallback });
      }
  
      const node = new sdk.StringNode(props1);
      node._logUnexpectedTypeError();
      return node.get({ fallback });
    });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcnameRedirectNotificationEnabled})
   */
  cnameRedirectNotificationEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("cnameRedirectNotificationEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EbulkOrdersEnabled})
   */
  bulkOrdersEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("bulkOrdersEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EprocessingFeeRate})
   */
  processingFeeRate({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("processingFeeRate", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      (expression0.type === "IntExpression" ||
      expression0.type === "FloatExpression")
    ) {
      const node = new sdk.FloatNode(props0);
      return node.get({ fallback });
    }
    const node = new sdk.FloatNode(props0);
    node._logUnexpectedTypeError();
    return fallback;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentFeeAdditionalSkuUnits})
   */
  fulfillmentFeeAdditionalSkuUnits({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("fulfillmentFeeAdditionalSkuUnits", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      (expression0.type === "IntExpression" ||
      expression0.type === "FloatExpression")
    ) {
      const node = new sdk.FloatNode(props0);
      return node.get({ fallback });
    }
    const node = new sdk.FloatNode(props0);
    node._logUnexpectedTypeError();
    return fallback;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentFeeFirstSkuUnit})
   */
  fulfillmentFeeFirstSkuUnit({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("fulfillmentFeeFirstSkuUnit", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      (expression0.type === "IntExpression" ||
      expression0.type === "FloatExpression")
    ) {
      const node = new sdk.FloatNode(props0);
      return node.get({ fallback });
    }
    const node = new sdk.FloatNode(props0);
    node._logUnexpectedTypeError();
    return fallback;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EhelpArticles})
   */
  helpArticles({ args = {} }: { args?: EmptyObject; } = {}): HelpArticlesNode {
    const props0 = this.getFieldNodeProps("helpArticles", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "HelpArticles"
    ) {
      return new HelpArticlesNode(props0);
    }

    const node = new HelpArticlesNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EnewPricingSystemEnabled})
   */
  newPricingSystemEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("newPricingSystemEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * Defines the number of products in a line item that requires processing before fulfillment.
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderProcessingStatusItemCountThreshold})
   */
  orderProcessingStatusItemCountThreshold({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("orderProcessingStatusItemCountThreshold", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EpartnerProductStockSnapshotEnabled})
   */
  partnerProductStockSnapshotEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("partnerProductStockSnapshotEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EshouldApplyExpressShippingSampleOrder})
   */
  shouldApplyExpressShippingSampleOrder({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("shouldApplyExpressShippingSampleOrder", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EfulfillmentDeadlines})
   */
  fulfillmentDeadlines({ args = {} }: { args?: EmptyObject; } = {}): FulfillmentDeadlinesNode {
    const props0 = this.getFieldNodeProps("fulfillmentDeadlines", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "FulfillmentDeadlines"
    ) {
      return new FulfillmentDeadlinesNode(props0);
    }

    const node = new FulfillmentDeadlinesNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EpaymentDeadlines})
   */
  paymentDeadlines({ args = {} }: { args?: EmptyObject; } = {}): PaymentDeadlinesNode {
    const props0 = this.getFieldNodeProps("paymentDeadlines", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "PaymentDeadlines"
    ) {
      return new PaymentDeadlinesNode(props0);
    }

    const node = new PaymentDeadlinesNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EpostOrderCreationFeedbackIntervalSeconds})
   */
  postOrderCreationFeedbackIntervalSeconds({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("postOrderCreationFeedbackIntervalSeconds", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EcronJobs})
   */
  cronJobs({ args = {} }: { args?: EmptyObject; } = {}): CronJobsNode {
    const props0 = this.getFieldNodeProps("cronJobs", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "CronJobs"
    ) {
      return new CronJobsNode(props0);
    }

    const node = new CronJobsNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * Asks for feedback after creating order with new order form. Depends on new order form being enabled.
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EpostOrderCreationFeedbackEnabled})
   */
  postOrderCreationFeedbackEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("postOrderCreationFeedbackEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * Asks for feedback in new order form. Depends on new order form being enabled.
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderFormFeedbackEnabled})
   */
  orderFormFeedbackEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("orderFormFeedbackEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EprepaidPriceEnabled})
   */
  prepaidPriceEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("prepaidPriceEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EeasypostEelPfcEnabled})
   */
  easypostEelPfcEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("easypostEelPfcEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * Enables the onboarding survey displayed to newly registered users
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EonboardingSurveyEnabled})
   */
  onboardingSurveyEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("onboardingSurveyEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EacceptOrderDelayMinutes})
   */
  acceptOrderDelayMinutes({ args = {}, fallback }: { args?: EmptyObject; fallback: number; }): number {
    const props0 = this.getFieldNodeProps("acceptOrderDelayMinutes", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "IntExpression"
    ) {
      const node = new sdk.IntNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.IntNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EorderTypeMinimumQuantities})
   */
  orderTypeMinimumQuantities({ args = {} }: { args?: EmptyObject; } = {}): OrderTypeMinimumQuantitiesNode {
    const props0 = this.getFieldNodeProps("orderTypeMinimumQuantities", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "OrderTypeMinimumQuantities"
    ) {
      return new OrderTypeMinimumQuantitiesNode(props0);
    }

    const node = new OrderTypeMinimumQuantitiesNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Euser})
   */
  user({ args = {} }: { args?: EmptyObject; } = {}): UserNode {
    const props0 = this.getFieldNodeProps("user", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "User"
    ) {
      return new UserNode(props0);
    }

    const node = new UserNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EdevMailBypassList})
   */
  devMailBypassList({ args = {}, itemFallback: fallback, listFallbackLength = 0 }: { args?: EmptyObject; itemFallback: string; listFallbackLength?: number; }): string[] {
    const props0 = this.getFieldNodeProps("devMailBypassList", { fieldArguments: args });

    return new sdk.Node(props0).getItemNodeProps({ fallbackLength: listFallbackLength }).map((props1) => {
      const expression1 = props1.expression;

      if (
        expression1 &&
        expression1.type === "StringExpression"
      ) {
        const node = new sdk.StringNode(props1);
        return node.get({ fallback });
      }
  
      const node = new sdk.StringNode(props1);
      node._logUnexpectedTypeError();
      return node.get({ fallback });
    });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EaiProductBuilder})
   */
  aiProductBuilder({ args = {} }: { args?: EmptyObject; } = {}): AIProductBuilderNode {
    const props0 = this.getFieldNodeProps("aiProductBuilder", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "AIProductBuilder"
    ) {
      return new AIProductBuilderNode(props0);
    }

    const node = new AIProductBuilderNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3EmembershipsEnabled})
   */
  membershipsEnabled({ args = {}, fallback }: { args?: EmptyObject; fallback: boolean; }): boolean {
    const props0 = this.getFieldNodeProps("membershipsEnabled", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "BooleanExpression"
    ) {
      const node = new sdk.BooleanNode(props0);
      return node.get({ fallback });
    }

    const node = new sdk.BooleanNode(props0);
    node._logUnexpectedTypeError();
    return node.get({ fallback });
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Esgtm})
   */
  sgtm({ args = {} }: { args?: EmptyObject; } = {}): SGTMNode {
    const props0 = this.getFieldNodeProps("sgtm", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "SGTM"
    ) {
      return new SGTMNode(props0);
    }

    const node = new SGTMNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }

  /**
   * [Open in Hypertune UI]({@link https://app.hypertune.com/projects/4333/main/draft/logic?selected_field_path=root%3Eonboarding})
   */
  onboarding({ args = {} }: { args?: EmptyObject; } = {}): OnboardingNode {
    const props0 = this.getFieldNodeProps("onboarding", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "Onboarding"
    ) {
      return new OnboardingNode(props0);
    }

    const node = new OnboardingNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }
}

/**
 * This is your project schema expressed in GraphQL.
 * 
 * Define `Boolean` fields for feature flags, custom `enum` fields for flags with 
 * more than two states, `Int` fields for numeric flags like timeouts and limits, 
 * `String` fields to manage in-app copy, `Void` fields for analytics events, and 
 * fields with custom object and list types for more complex app configuration, 
 * e.g. to use Hypertune as a CMS.
 * 
 * Once you've changed your schema, set your flag logic in the Logic view.
 */
export type Source = {
  /**
   * You can add arguments to any field in your schema, which you can then use when
   * setting its logic, including the logic of any nested fields. Your root field 
   * already has a `context` argument. Since all flags are nested under the root 
   * field, this context will be available to all of them.
   */
  root: Root;
}

const sourceFallback = {root:{customersCanvasMockupPipeline:false,manualMockupRegenerationEnabled:false,labelTransition:{autoupgraderDisabledTooltip:"",autoupgraderDisabled:false,showLabelMigrationStatus:false,showLabelTransitionBanner:false,migrationDeadline:""},labelUpgradePurchase:{autoUpgradeTermsLink:"",subscriberFreeUpgradesCount:0,priceId:"",priceCents:0,freeCouponId:""},shopify:{useREST4InventoryActivation:false,shopifyShippingRatesSetupAppEnabled:false},payments:{suplifulCreditsTopupEnabled:false,suplifulTokensEnabled:false},adminGenerateMockupsFromLabelV1Enabled:false,adminLabelTransitionsPageEnabled:false,adminGenericLabelPreviewEnabled:false,labelSettings:{dpi:0,width:0,height:0,borderWidth:0},polotno:{unsplashEnabled:false,templatesEnabled:false,useNewLabelForFulfillment:false,enabled:false},shipments:{shipmentInsuranceThreshold:0,easypostEelPfcEnabled:false},shiphero:{productLotTrackingEnabled:false,orderTag:"",userProductTag:"",userProductSyncEnabled:false,warehouseSyncEnabled:false,catalogSyncEnabled:false},regenerateMockupsOnSubscribe:false,hubspot:{testing:false},tikTok:{discontinued:false,orderCutoffTimestamp:0},canPublishToTiktok:false,canConnectTiktokStore:false,tiktokSellerShipping:{enabled:false,shopUrls:[]},tiktokShipping:{enabled:false,shopUrls:[]},magicLinkWithOTP:false,metaConversionsAPI:{testEventCode:""},blackFridayPromoIsEnabled:false,clickFunnels:{clickFunnelsStoreCardURL:""},clickFunnelsAllowTestOrdersInProduction:false,useAsyncGtmSignupCallbacks:false,sampleDiscountValidDate:"",clickFunnelsIsEnabled:false,extendedCatalogIsEnabled:false,roastifyProduct3DPreviewReportIssueEnabled:false,stripeInvoicing:{sampleDiscountPercent:0,shippingFee:"",sampleDiscountId:"",enabled:false,firstItemFulfillmentFee:"",additionalItemFulfillmentFee:"",processingFee:""},subscriptionItems:{enabled:false,brandedCustomerSupportPriceId:""},roastifySkus:[],singleSkuBundleEnabled:false,socialSignOn:{facebook:false,google:false,twitter:false},jetpackFbaEmails:[],newPricingSystemVideoPopupEnabled:false,fulfillmentFeeExemptProducts:[],cnameRedirectNotificationEnabled:false,bulkOrdersEnabled:false,processingFeeRate:0,fulfillmentFeeAdditionalSkuUnits:0,fulfillmentFeeFirstSkuUnit:0,helpArticles:{labelMigrateCommonIssues:"",labelMigration:"",orderKinds:"",sampleDiscount:"",createGeneralLabel:"",createRoastifyLabels:"",shippingCost:"",productCost:"",processingFee:"",fulfillmentFee:"",tieredPricing:"",storeAlreadyConnected:"",setUserStoreShippingRates:"",returns:"",shipping:""},newPricingSystemEnabled:false,orderProcessingStatusItemCountThreshold:0,partnerProductStockSnapshotEnabled:false,shouldApplyExpressShippingSampleOrder:false,fulfillmentDeadlines:{fbaDays:0,priorityDays:0,sampleDays:0,defaultDays:0,prelabeledDays:0},paymentDeadlines:{prePaymentDays:0},postOrderCreationFeedbackIntervalSeconds:0,cronJobs:{runClickFunnelsOrderImportCron:false,runOrderInvoiceGenerationCron:false,runShopifyFulfillmentCheckCron:false,runShopifyStoreWebhookCheckCron:false,notionFbaProducts:{enabled:false,schedule:""},postPaymentBuckets:{paymentEmailRemindersEnabled:false},runExpireOldUserCreditsCron:false,runClickFunnelsStoreWebhookCheckCron:false,runShipheroAccessTokenCheckCron:false},postOrderCreationFeedbackEnabled:false,orderFormFeedbackEnabled:false,prepaidPriceEnabled:false,easypostEelPfcEnabled:false,onboardingSurveyEnabled:false,acceptOrderDelayMinutes:0,orderTypeMinimumQuantities:{minManualQuantity:0,minSampleQuantity:0,minFbaQuantity:0,minBulkQuantity:0},user:{userMinimumPricingTier:0},devMailBypassList:[],aiProductBuilder:{isEnabled:false,appURL:""},membershipsEnabled:false,sgtm:{hubspotDirectEventsEnabled:false},onboarding:{surveyEnabled:false,surveyEnabledSince:""}}};

export type GetQueryRootArgs = {
  args: RootArgs;
}

export type GetQueryArgs = {
  root: GetQueryRootArgs;
}

/**
 * This is your project schema expressed in GraphQL.
 * 
 * Define `Boolean` fields for feature flags, custom `enum` fields for flags with 
 * more than two states, `Int` fields for numeric flags like timeouts and limits, 
 * `String` fields to manage in-app copy, `Void` fields for analytics events, and 
 * fields with custom object and list types for more complex app configuration, 
 * e.g. to use Hypertune as a CMS.
 * 
 * Once you've changed your schema, set your flag logic in the Logic view.
 */
export class SourceNode extends sdk.Node {
  override typeName = "Query" as const;

  get({ args, fallback = sourceFallback as Source}: { args: GetQueryArgs; fallback?: Source }): Source {
    const getQuery = sdk.mergeFieldQueryAndArgs(
      query.fragmentDefinitions,
      sdk.getFieldQueryForPath(query.fragmentDefinitions, query.fieldQuery, []), 
      args,
    );
    return this.getValue({ query: getQuery, fallback }) as Source;
  }

  /**
   * You can add arguments to any field in your schema, which you can then use when
   * setting its logic, including the logic of any nested fields. Your root field 
   * already has a `context` argument. Since all flags are nested under the root 
   * field, this context will be available to all of them.
   */
  root({ args }: { args: RootArgs; }): RootNode {
    const props0 = this.getFieldNodeProps("root", { fieldArguments: args });
    const expression0 = props0.expression;

    if (
      expression0 &&
      expression0.type === "ObjectExpression" &&
      expression0.objectTypeName === "Root"
    ) {
      return new RootNode(props0);
    }

    const node = new RootNode(props0);
    node._logUnexpectedTypeError();
    return node;
  }
}

export type DehydratedState = sdk.DehydratedState<Source, VariableValues>

const sources: { [key: string]: SourceNode } = {};

export type CreateSourceOptions = {
  token: string; 
  variableValues?: VariableValues;
  override?: sdk.DeepPartial<Source> | null;
  key?: string;
} & sdk.CreateOptions

export function createSource({
  token,
  variableValues = {},
  override,
  key,
  ...options
}: CreateSourceOptions): SourceNode {
  const sourceKey =
    key ?? (typeof window === "undefined" ? "server" : "client");

  if (!sources[sourceKey]) {
    sources[sourceKey] = sdk.create({
      NodeConstructor: SourceNode,
      token,
      variableValues,
      override,
      options: {initData: initData as unknown as sdk.InitData, ...options },
    });
  }

  return sources[sourceKey];
}

export const emptySource = new SourceNode({
  context: null,
  logger: null,
  parent: null,
  step: null,
  expression: null,
  initDataHash: null,
});

export function createSourceForServerOnly({
  token,
  variableValues = {},
  override,
  key,
  ...options
}: CreateSourceOptions): SourceNode {
  return typeof window === "undefined"
    ? createSource({ token, variableValues, override, ...options })
    : emptySource;
}

export const overrideCookieName = "hypertuneOverride";

/**
 * @deprecated use createSource instead.
 */
export const initHypertune = createSource
/**
 * @deprecated use SourceNode instead.
 */
export type QueryNode = SourceNode;
/**
 * @deprecated use Source instead.
 */
export type Query = Source;
